angular.module('c', [
    'ui.router',
    'ui.mask',

    'elif',

    // 'angular-loading-bar',
    //'ui.select',
    'ngSanitize',
    'ngTable',
    'ngLocale',
    'toaster',
    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'sticky',

    //'ui.tree',
    // 'ui.slimscroll',
    'ui.checkbox',
    'ngAnimate',
    'rzModule',
    'angular-clipboard',
    'angularPromiseButtons',

    //'monospaced.qrcode',
    'angular-click-outside',
    'monospaced.elastic',
    'mgo-angular-wizard',

    'ui.bootstrap',
    'ui.bootstrap.datetimepicker',
    'mwl.calendar',
    'toggle-switch',
    'FBAngular',
    'ngFileUpload',
    'btford.socket-io',
    'angularMoment',

    //'angular-img-cropper',
    'ipCookie',
    'colorpicker.module',

    'dndLists',
    'oc.lazyLoad',

    'ng.deviceDetector',
    'ckeditor',
    'uiCropper',

    'ngResource',
    'ngStorage',
    'fileSaver'
]);

angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
// moment.js locale configuration
// locale : chinese (zh-cn)
// author : suupic : https://github.com/suupic
// author : Zeno Zeng : https://github.com/zenozeng

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function (moment) {
    return moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah点mm',
            LTS : 'Ah点m分s秒',
            L : 'YYYY-MM-DD',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日LT',
            LLLL : 'YYYY年MMMD日ddddLT',
            l : 'YYYY-MM-DD',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日LT',
            llll : 'YYYY年MMMD日ddddLT'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay : function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay : function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse : 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            m : '1分钟',
            mm : '%d分钟',
            h : '1小时',
            hh : '%d小时',
            d : '1天',
            dd : '%d天',
            M : '1个月',
            MM : '%d个月',
            y : '1年',
            yy : '%d年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));

angular.module('c')
    .factory('BloodStorage', function ($resource) {
        return $resource('/api/v1/blood_storage/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c')
        .factory('CommonPhone', CommonPhone);

    /** @ngInject */
    function CommonPhone($resource, serviceConfObj) {
        return $resource('/api/v1/common_phones/:id', {}, serviceConfObj);
    }

})();

angular.module('c')
    .factory('ContactGroup', ['$resource', function ($resource) {
        return $resource('/api/v1/contact_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            index_members: {
                method: 'GET',
                params: {
                    action: 'index_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c')
        .factory('Dept', Dept)
        .factory('DeptType', DeptType)
        .factory('DeptPhone', DeptPhone)
        .factory('AdminGroup', AdminGroup)
        .factory('DeptAgent', DeptAgent)
        .factory('DeptGroup', DeptGroup)
    ;

    /** @ngInject */
    function DeptType($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/dept_types';
        var service = {
            ID: {
                OTHER: 1,    // 其他
                CB_AGENCY: 2,    // 成办机关
                DIRECT_AGENCY: 3    // 直属机关
            },
            getDepts: getDepts,
            getDeptTypes: getDeptTypes
        };
        return angular.extend(service, $resource(API + '/:id',
            {}, serviceConfObj));

        function getDepts(typeId) {
            var api = API + '/' + typeId + '/depts';
            return $http.get(api);
        }

        function getDeptTypes(vm, reFun) {
            this.query({op: 'options'}).$promise.then(function (resp) {
                var items = resp.items;
                items.unshift({id: 0, name: '所有公司'});
                vm.companies = items;

                if (reFun) reFun(items);
            });
        }
    }

    /** @ngInject */
    function DeptGroup($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/dept_groups';
        var service = {};
        return angular.extend(service, $resource(API + '/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function DeptAgent($resource, serviceConfObj) {
        var service = {};
        return angular.extend(service, $resource('/api/v1/dept/dept_agents/:id',
            {}, serviceConfObj));
    }


    /** @ngInject */
    function DeptPhone($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept/dept_phones/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function AdminGroup($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept/admin_groups/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function Dept($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/depts';
        var service = {
            urls: {
                API: API
            },
            ID: {
                // todo: 人事部待录入
                HOSPITAL: 3,  // 办公室
                PERSONNEL: 8,  // 人事部
                PUBLICITY: 4  // 经联处
            },

            getMembers: getMembers,

            // ov: old version or new version
            ov: angular.extend({
                INDEX: {
                    //所有部门选项
                    DEPTS_OPTIONS: 4,
                    //当前登录用户所属部门列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS: 5,
                    //当前登录用户所负责部门列表，用于下拉列表选项
                    DEPTS_LED_BY: 6,
                    //当前登录用户所属部门列表，用于下拉列表选项,总经理可选所管部门
                    USER_DEPTS_OPTIONS2: 12,
                    //查询用户所属部门列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS3: 13,
                    //总经理已审核制度的部门列表
                    DEPTS_LED_BY2: 15,
                    //部门物资管理员管理的部门列表
                    DEPTS_CSMB_OPTIONS: 16
                }
            }, $resource('/api/v1/dept/ov/depts/:id', {}, serviceConfObj))
        };

        return angular.extend(service, $resource(API + '/:id', {}, serviceConfObj));

        function getMembers(deptId) {
            var api = API + '/' + deptId + '/members';
            return $http.get(api);
        }
    }

})();

angular.module('c')
    .factory('Email', function ($resource) {
        return $resource('/api/v1/emails/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            withdraw: {
                method: 'POST',
                params: {
                    action: 'withdraw'
                }
            },
            rm_from_inbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_inbox'
                }
            },
            rm_from_outbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_outbox'
                }
            }
        });
    }
);


angular.module('c')
    .factory('HelpPage', ['$resource', function ($resource) {
        return $resource('/api/v1/help_pages/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c')
    .factory('HelpContent', ['$resource', function ($resource) {
        return $resource('/api/v1/help_contents/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c')
    .factory('MedicalInfo', function ($resource) {
        return $resource('/api/v1/medical_info/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c')
        .factory('OfficeDeptPhone', OfficeDeptPhone)
    ;

    /** @ngInject */
    function OfficeDeptPhone($resource, serviceConfObj) {
        var service = {
        };
        return angular.extend(service, $resource('/api/v1/dept_phone/:id', {
            id: '@id',
            action: '@action'
        }, serviceConfObj,{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .factory('OperationPermit', OperationPermit)      // 手术单申请
        .factory('ORRecipient', ORRecipient)
        .factory('IRSchedule', IRSchedule)      // 介入手术室手术单
        .factory('ORSchedule', ORSchedule)      // 住院部手术单
        .factory('OutPSchedule', OutPSchedule)  // 门诊部手术单
    ;

    /** @ngInject */
    function OperationPermit($resource, serviceConfObj) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/operation_permits/upload',
                DN: '/api/v1/operation_permits/download'
            }
        };
        return angular.extend(service, $resource('/api/v1/operation_permits/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function ORRecipient($resource, serviceConfObj) {
        return $resource('/api/v1/or_recipients/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function IRSchedule($resource) {
        return opSchedule($resource, 'ir_schedules');
    }

    /** @ngInject */
    function ORSchedule($resource) {
        return opSchedule($resource, 'or_schedules');
    }

    /** @ngInject */
    function OutPSchedule($resource) {
        return opSchedule($resource, 'out_p_schedules');
    }

    function opSchedule($resource, type) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/' + type + '/upload',
                DN: '/api/v1/' + type + '/download',
            }
        };

        return angular.extend(service, $resource('/api/v1/' + type + '/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        }));
    }
})();

angular.module('c')
    .factory('QualificationChangeRemind', ['$resource', function ($resource) {
        return $resource('/api/v1/qualification/qualification_change_reminds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c')
    .factory('RedHeadApprover', ['$resource', function ($resource) {
        return $resource('/api/v1/red_head_approvers/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c')
        .factory('Role', Role)
        .factory('Permission', Permission)
    ;

    /** @ngInject */
    function Permission($resource) {
        return $resource('/api/v1/permissions/:id');
    }

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/roles/:id',
            {}, serviceConfObj));
    }

})();
(function () {
    'use strict';


    angular.module('c')
        .factory('Setting', SettingService);

    /** @ngInject */
    function SettingService($resource) {
        return $resource('/api/v1/settings/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .factory('Sms', Sms)
    ;

    /** @ngInject */
    function Sms($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/sms/:action/:id',
            {}, angular.extend(serviceConfObj, {
                send: {
                    method: 'POST',
                    params: {
                        action: 'send'
                    }
                },
                batchRemove: {
                    method: 'POST',
                    params: {
                        action: 'batchRemove'
                    }
                }
            })));
    }

})();

// angular.module('c')
//     .factory('Sms', function($http, C) {
//         return {
//             send: function (data, success, error) {
//                 $http.post(C.URL.SMS_SEND, data).success(success).error(error);
//             },
//             remove: function (data, success, error) {
//                 $http.post(C.URL.SMS_RM, data).success(success).error(error);
//             },
//             history: function (data, success, error) {
//                 $http.get(C.URL.SMS_HISTORY, {params: data}).success(success).error(error);
//             }
//         };
//     });


(function () {
    'use strict';


    angular.module('c')
        .factory('UserType', UserType)
        .factory('UserStatus', UserStatus)
        .factory('UserOnType', UserOnType)
        .factory('User', User)
        .factory('UserDept', UserDept)
        .factory('EntryType', EntryType)
        .factory('LeaveReason', LeaveReason)
        .factory('Role', Role)
        .factory('Permission', Permission)
    ;

    /** @ngInject */
    function UserDept($resource, serviceConfObj) {
        return $resource('/api/v1/user/user_depts/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function User($resource, $http, Dlg, UserStatus, serviceConfObj, DateHelper) {
        var bindVm;
        var API = '/api/v1/user/users';
        var service = {
            urls: {
                API: API,
                DN_WORK_PHOTO: API + '/dnWorkPhoto',
                EXPORT_USER_INFO: API + '/exportUsers',
                EXPORT_DEPT_NOT_SIGN: API + '/exportSignSeal'
            },
            CONFIRM: {
                PENDING: 0,
                USER: 1,
                DEPT: 2,
                PERSONNEL: 3
            },
            BADGE: {
                PENDING: 1,
                MAKING: 2,
                RECEIVE: 3,
                FINISH: 4
            },
            getDegree: getDegree,

            getYesNos: getYesNos,
            getSexes: getSexes,

            getDegreeTypes: getDegreeTypes,
            getEduBgList: getEduBgList,
            getEnLvList: getEnLvList,
            getTitles: getTitles,

            getBadges: getBadges,

            // helper
            formHelper: {
                init: init,
                bindAsyncOptions: bindAsyncOptions,
                loadParams: loadParams
            },

            transferDept: transferDept,

            // means old version , 应该逐渐抛弃
            ov: $resource('/api/v1/user/ov/users/:action/:id', {
                id: '@id',
                action: '@action'
            }, {
                update: {
                    method: 'PUT'
                },
                query: {
                    method: 'GET'
                }
            })
        };

        return angular.extend(service, $resource(service.urls.API + '/:action/:id',
            {}, angular.extend(serviceConfObj, {
                batchBadge: {
                    method: 'POST',
                    params: {
                        action: 'batchBadge'
                    }
                }
            })));

        /////////////////////////////////////////////////////////////
        // form helper
        function init(vm, $scope) {

            vm.addUserPhoto = addUserPhoto;
            vm.calcAnnualTotal = calcAnnualTotal;

            vm.edu_bgs = getEduBgList();
            vm.degree_types = getDegreeTypes();
            vm.en_lvs = getEnLvList();
            vm.titles = getTitles();

            $scope.$watch('vm.m.edu_bg', function (newValue) {
                if (typeof newValue !== 'undefined') {
                    if (vm.m) {
                        if (newValue.id == 5) {
                            vm.m.degree = vm.degree_types[0];
                        } else if (newValue.id == 6) {
                            vm.m.degree = vm.degree_types[1];
                        } else if (newValue.id == 7) {
                            vm.m.degree = vm.degree_types[2];
                        } else {
                            vm.m.degree = vm.degree_types[3];
                        }
                    }
                }
            });

            $scope.$watch('vm.m.pt_edu_bg', function (newValue) {
                if (typeof newValue !== 'undefined' && newValue != null) {
                    if (vm.m) {
                        if (newValue.id == 5) {
                            vm.m.pt_degree = vm.degree_types[0];
                        } else if (newValue.id == 6) {
                            vm.m.pt_degree = vm.degree_types[1];
                        } else if (newValue.id == 7) {
                            vm.m.pt_degree = vm.degree_types[2];
                        } else {
                            vm.m.pt_degree = vm.degree_types[3];
                        }
                    }
                }
            });

            $scope.$watch('vm.m.political_status', function (newValue) {
                if (typeof newValue !== 'undefined' && newValue != null) {
                    if (vm.m) {
                        if (newValue.id !== 1 && newValue.id !== 2) {
                            vm.m.party_time = null;
                        }
                    }
                }
            });

            bindVm = vm;
        }

        function getYesNos() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ];
        }

        function getSexes() {
            return [
                {id: 0, name: '女'},
                {id: 1, name: '男'}
            ];
        }

        function bindAsyncOptions(vm, options) {
            //
            vm.types = options.items.types;
            vm.statuses = options.items.statuses;

            vm.political_statuses = options.items.political_statuses;
            vm.companies = options.items.companies;

            bindVm = vm;
        }

        function loadParams(m, op) {
            var pa = {
                op: op,
                // 账户信息
                // username: m.username, // 自动根据id生成 4位数，不足在前面用0补齐
                phone: m.phone,
                name: m.name,
                // 基本信息
                sex: m.sex,
                id_card: m.id_card,
                political_status_id: m.political_status ? m.political_status.id : null,
                salary_card: m.salary_card ? m.salary_card : null,
                card_bank: m.card_bank ? m.card_bank : null,
                // 工作相关 ! 头像/工作照 修改后直接更新
                status_id: m.status ? m.status.id : null,
                type_id: m.type ? m.type.id : null,
                is_cadre: m.is_cadre,
                entry_time: m.entry_time ? DateHelper.date2Str(m.entry_time) : null,
                started_work: m.started_work ? DateHelper.date2Str(m.started_work) : null,
                post: m.post,
                // 教育背景
                graduate_school: m.graduate_school,
                major: m.major,
                edu_bg: m.edu_bg ? m.edu_bg.id : null,
                degree: m.degree ? m.degree.name : null,
                en_lv: m.en_lv ? m.en_lv.id : null,
                // 联系方式
                phone2: m.phone2,
                office_phone: m.office_phone,
                email: m.email,
                qq: m.qq,
                address: m.address,
                //
                update_annual_num: m.update_annual_num,
                //籍贯
                native_place: m.native_place,
                //籍贯
                domicile: m.domicile,
                //入党时间
                party_time: m.party_time ? DateHelper.date2Str(m.party_time) : null,
                //非全日制
                pt_graduate_school: m.pt_graduate_school,
                pt_major: m.pt_major,
                pt_edu_bg: m.pt_edu_bg ? m.pt_edu_bg.id : null,
                pt_degree: m.pt_degree ? m.pt_degree.name : null,
                pt_en_lv: m.pt_en_lv ? m.pt_en_lv.id : null
            };
            // 3 表示护士
            if (m.update_annual_num) pa.annual_days = m.annual_days;

            return pa;
        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
                m.work_photo = resp[1];
            });
        }

        function calcAnnualTotal(m) {
            var vm = bindVm;
            if (m.status && m.entry_time && m.started_work) {
                var params = {
                    op: 'annual_total',
                    status_id: m.status.id, entry_time: m.entry_time,
                    started_work: m.started_work
                };
                var api = service.urls.API + '/-';
                $http.get(api, {params: params}).success(function (resp) {
                    vm.annualTotal = resp;
                });
            } else {
                delete vm.annualTotal;
            }
            // addition
            var required = m.status && m.status.id !== UserStatus.ID.PRACTICE;
            bindVm.cfg.required.annualDays = required;
        }

        ///////////////////////////////////////////////////////////////
        function transferDept(userId, deptId, params) {
            var api = service.urls.API + '/' + userId + '/transfer/' + deptId;
            params.op = 'transfer';
            return $http.post(api, params);
        }

        function getDegree(degree) {
            var degreeTypes = getDegreeTypes();
            if (degree) {
                for (var i = 0; i < degreeTypes.length; i++) {
                    var type = degreeTypes[i];
                    if (degree.indexOf(type.name) >= 0) {
                        return type;
                    }
                }
            }
            return degreeTypes[0];
        }

        function getDegreeTypes() {
            return [
                {id: 4, name: "学士"},
                {id: 3, name: "硕士"},
                {id: 2, name: "博士"},
                {id: 0, name: "无"}
            ];
        }

        function getEduBgList() {
            return [
                {id: 5, name: "本科"},
                {id: 6, name: "硕士研究生"},
                {id: 7, name: "博士研究生"},
                {id: 1, name: "高中"},
                {id: 2, name: "中专"},
                {id: 3, name: "大专"},
                {id: 4, name: "初中"},
                {id: 8, name: "职高"},
                {id: 9, name: "其他"}
            ];
        }

        function getEnLvList() {
            return [
                {id: 3, name: "大学公共英语4级"},
                {id: 4, name: "大学公共英语6级"},
                {id: 2, name: "大学公共英语2级"},
                {id: 5, name: "其他英语等级"},
                {id: 6, name: "其他外语种"},
                {id: 1, name: "无"}
            ];
        }
        function getTitles() {
            return [
                {id: 1, name: "初级会计师"},
                {id: 2, name: "中级会计师"},
                {id: 3, name: "高级会计师"},
                {id: 4, name: "主任护师（高级）"},
                {id: 5, name: "副主任护师（高级）"},
                {id: 6, name: "主管护师（中级）"},
                {id: 7, name: "护师（初级）"},
                {id: 8, name: "护士（初级）"},
                {id: 9, name: "医师（初级）"},
                {id: 10, name: "主治医师（中级）"},
                {id: 11, name: "副主任医师（高级）"},
                {id: 12, name: "主任医师（高级）"},
                {id: 20, name: "药师（初级）"},
                {id: 21, name: "主管药师（中级）"},
                {id: 22, name: "副主任药师（高级）"},
                {id: 23, name: "主任药师（高级）"},
                {id: 13, name: "软件工程师"},
                {id: 14, name: "中级软件工程师"},
                {id: 15, name: "高级软件工程师"},
                {id: 17, name: "初级技师"},
                {id: 18, name: "中级技师"},
                {id: 19, name: "高级技师"},
                {id: 16, name: "无"},
            ];
        }

        function getBadges() {
            return [
                {id: 1, name: '胸牌待制作'},
                {id: 2, name: '胸牌制作中'},
                {id: 3, name: '胸牌待领取'},
                {id: 4, name: '胸牌已领取'}
            ]
        }
    }

    /** @ngInject */
    function UserOnType($resource, serviceConfObj) {
        return $resource('/api/v1/user/user_on_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function UserType($resource) {
        return $resource('/api/v1/user/user_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function UserStatus($resource) {
        var service = {
            ID: {
                OTHER: 1,
                DIRECT: 5
            }
        };

        return angular.extend(service, $resource('/api/v1/user/user_statuses/:id', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function EntryType($resource) {
        return $resource('/api/v1/user/entry_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function LeaveReason($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/user/leave_reasons/:id', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function Permission($resource) {
        return $resource('/api/v1/user/permissions/:id');
    }

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/user/roles/:id',
            {}, serviceConfObj));
    }

})();

(function () {
    'use strict';

    angular.module('c').config(config);

    /** @ngInject */
    function config(calendarConfig) {
        calendarConfig.dateFormatter = 'moment'; //use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.

        calendarConfig.allDateFormats.moment.date.hour = 'HH:mm'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
        calendarConfig.allDateFormats.moment.date.datetime = 'MMM D日, h:mm a'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour

        calendarConfig.allDateFormats.moment.title.week = '{year}年 {week}周'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.day = 'dddd MMMM D号'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.month = 'YYYY年 MMMM'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.year = 'YYYY年'; //this will configure the day view title to be shorter

        calendarConfig.showTimesOnWeekView = false;

        calendarConfig.i18nStrings.weekNumber = '{week}周'; //This will set the week number hover label on the month view

    }

})();

(function () {
    'use strict';

    angular.module('c').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');
        dialogsProvider.useAnimation();

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

(function () {
    'use strict';

    angular.module('c').config(lazyLoadConfig);

    /** @ngInject */
    function lazyLoadConfig($ocLazyLoadProvider) {
        var l = '/ocLazyLoad/';
        var m = [
            //0               1       2        3          4         5
            'ngHandsontable', 'pdf', 'video', 'uiSelect', 'qrCode', 'chart'
        ];
        $ocLazyLoadProvider.config({
            modules: [
                {
                    name: m[0],
                    files: [
                        l + m[0] + '/handsontable.full.min.js',
                        l + m[0] + '/handsontable.full.min.css',
                        l + m[0] + '/ngHandsontable.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[1],
                    files: [
                        l + m[1] + '/compatibility.js',
                        l + m[1] + '/pdf.js',
                        l + m[1] + '/angular-pdf.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[2],
                    files: [
                        l + m[2] + '/vg-overlay-play.min.js',
                        l + m[2] + '/vg-controls.min.js',
                        l + m[2] + '/vg-buffering.min.js',
                        l + m[2] + '/videogular.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[3],
                    files: [
                        l + m[3] + '/select.min.css',
                        l + m[3] + '/select.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[4],
                    files: [
                        l + m[4] + '/qrCode.min.js',
                        l + m[4] + '/angular-qrcode.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[5],
                    files: [
                        l + m[5] + '/chart.min.js',
                        l + m[5] + '/chartjs-plugin-piechart-outlabels.min.js',
                        l + m[5] + '/angular-chart.min.js'
                    ],
                    serie: true
                }
            ]
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(otherCfg)
        .run(otherRunner);
    /** @ngInject */
    function otherCfg($provide, $httpProvider, $compileProvider, $localStorageProvider) {
        // Improving Angular performance with 1 line of code
        // https://blog.upstate.agency/improving-angular-performance-with-1-line-of-code-a1fb814a6476
        $compileProvider.debugInfoEnabled(false);

        $provide.constant('$compileProvider', $compileProvider);

        $httpProvider.useApplyAsync(true);

        $localStorageProvider.setKeyPrefix('ycoa');
    }

    /** @ngInject */
    function otherRunner($anchorScroll, amMoment) {
        $anchorScroll.yOffset = 128;
        amMoment.changeLocale('zh-cn');
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['$urlRouterProvider', modWhenRouter])
        .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', MainRouter])
        .run(stateChangeCfg);


    /**
     * ui-router bug
     * http://stackoverflow.com/questions/23658846/angular-ui-router-urlrouterprovider-when-not-working-anymore
     */
    function modWhenRouter($urlRouterProvider) {
        // $urlRouterProvider.when('/app/pc/stock', '/app/pc/stock/rooms');
        // $urlRouterProvider.when('/app/pc/remind', '/app/pc/remind/rooms');
    }

    function MainRouter($stateProvider, $urlRouterProvider, $httpProvider) {
        $urlRouterProvider.deferIntercept();

        $urlRouterProvider.otherwise('/app/home');

        $stateProvider
            // 主页
            .state('app', {
                url: '/app',
                templateUrl: 'templates/cache/main.html',
                resolve: {
                    window: ['$window', function ($window) {
                        return $window;
                    }],
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                },
                controller: 'MainCtrl',
                //目前能实现注销后路由状态重载的办法，但会引起页面刷新（bad!）
                //2016-7-15,以上方法在手机浏览器和苹果浏览器上会引起注销异常，现在弃用
                //关注：https://github.com/angular-ui/ui-router/issues/1095
                onExit: function () {
                    //window.location.reload();
                },
                data: {
                    requireLogin: true
                }
            })
            .state('app.home', {
                url: '/home?pendingDlgOpen',
                templateUrl: 'templates/cache/home.html',
                controller: 'HomeCtrl',
                controllerAs: 'home'
            })
            //登录
            .state('login', {
                templateUrl: 'pages/login.html',
                url: '/login',
                params: {data: {}},
                controller: 'LoginCtrl',
                data: {
                    requireLogin: false
                }
            })
            .state('temp', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {requireLogin: false}
            })
            .state('get_wechat_token', {
                url: "/get_wechat_token?code&state&toState&toParams",
                controller: "WechatAuthCtrl",
                data: {requireLogin: false}
            })

            .state('user_confirm', {
                templateUrl: 'pages/userConfirm.html',
                url: "/user_confirm",
                data: {requireLogin: true},
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                }
            });

        angular.forEach(previewRoutes, function (b) {
            var pa = {
                templateUrl: "/pages/preview/" + b[1],
                url: "/" + b[2],
                data: {
                    requireLogin: true
                }
            };
            $stateProvider.state(b[0], pa);
        });

        angular.forEach(routes, function (r) {
            var pa = {
                url: "/" + r[1] + '?tab&wxnpId&wxnpType',
                reloadOnSearch: false,
                params: {data: {}},
                perm: r[3],
                onExit: function () {
                    for (var i in CKEDITOR.instances) {
                        var editor = CKEDITOR.instances[i];
                        if (editor) editor.destroy();
                    }
                }
            };
            if (r[2].charAt(0) === '<') {
                pa.template = '<ui-view></ui-view>';
            } else {
                pa.templateUrl = "pages/" + r[2];
            }
            if (r[4]) {
                pa.resolve = {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(r[4]);
                    }]
                };
            }
            if (r[5]) {
                angular.forEach(r[5], function (c) {
                    $stateProvider.state("app." + r[0] + "." + c[0], {
                        url: "/" + c[1],
                        templateUrl: "pages/" + c[2]
                    });
                });
            }
            $stateProvider.state("app." + r[0], pa);
        });

        $httpProvider.interceptors.push(apiInterceptorFn);
    }

    var pendingRequests = [];
    var previousToState, previousToParams;
    var isRedirectingWechatAuth = false;
    var WECHAT_AUTH_REDIRECT_LOCK_KEY = 'wechat_auth_redirect_lock';
    var WECHAT_AUTH_REDIRECT_TARGET_KEY = 'xzcd_wechat_oauth_redirect_target';
    var WECHAT_AUTH_REDIRECT_LOCK_TTL = 5000;

    /** @ngInject */
    function apiInterceptorFn($timeout, $q, $injector, $window, Auth, WxHelper) {
        var $state;
        var dialogs;
        var $http;
        var CODE = Auth.CODE;
        $timeout(function () {
            $state = $injector.get('$state');
            dialogs = $injector.get('dialogs');
            $http = $injector.get('$http');
        });

        return {
            'request': function (config) {
                config.headers = config.headers || {};
                if (Auth.hasToken()) {
                    config.headers.Authorization = 'Bearer ' + Auth.getToken();
                }
                return config;
            },
            'responseError': function (response) {
                if (response.status === 401) {
                    var code = getCode(response.data);
                    if (code === CODE.TOKEN_DEAD || code === CODE.INVALID) {
                        logout(code === CODE.TOKEN_DEAD);
                    }
                    if (code !== CODE.TOKEN_EXPIRED) return $q.reject(response);

                    if (pendingRequests.length === 0) {
                        $timeout(function () {
                            Auth.refreshToken().then(function (resp) {
                                var token = resp.data;
                                Auth.setToken(token);
                                var newAuth = 'Bearer ' + Auth.getToken();
                                angular.forEach(pendingRequests, function (req) {
                                    req.config.headers.Authorization = newAuth;
                                    req.resolve($http(req.config));
                                });
                            }, function (err) {
                                angular.forEach(pendingRequests, function (req) {
                                    req.reject();
                                });
                                logout(err.data.code === CODE.TOKEN_DEAD);
                            }).finally(function () {
                                pendingRequests = [];
                            });
                        }, 1000);
                    }

                    return $q(function (resolve, reject) {
                        pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                    });

                }
                return $q.reject(response);
            }
        };

        function logout(tokenDead) {
            if (Auth.hasToken()) {
                Auth.deleteToken();
                if (tokenDead) {
                    var isWx = WxHelper.isWechatBrowser();
                    dialogs.notify('信标已过期', '安全信标已过期，' +
                        (isWx ? '系统将通过微信绑定账号重新登录.' : '您需要重新登录！'))
                        .result.then(function () {
                        if (isWx) {
                            redirectWechatAuthOrRetry($window, WxHelper, previousToState, previousToParams);
                        } else {
                            $state.go('login');
                        }
                    });
                } else {
                    $state.go('login');
                }
            }
        }

        function getCode(body) {
            // 针对文件上传时，响应数据类型为ArrayBuffer的情况
            if (body instanceof ArrayBuffer) {
                var str = String.fromCharCode.apply(null, new Uint8Array(body));
                body = JSON.parse(str)
            }
            return parseInt(body.code)
        }
    }

    /** @ngInject */
    function stateChangeCfg($rootScope, $state, $window, $uibModalStack, WxHelper,
                            $urlRouter, Auth, Dlg, Sidebar) {
        // $urlRouter sync() 貌似只能用在 $locationChangeSuccess 事件
        $rootScope.$on('$stateChangeStart', changeStart);
        $rootScope.$on('$stateChangeSuccess', changeSuccess);

        $urlRouter.listen();

        function changeStart(event, toState, toParams) {
            var requireLogin = toState.data.requireLogin;
            var isLoggedIn = Auth.hasToken();

            previousToState = toState;
            previousToParams = toParams;

            if (!requireLogin) { // 无需登录，则直接访问该路由
                // alert('无需登录，则直接访问该路由');
                return;
            }

            if (!isLoggedIn) {  // 未登录，则尝试利用微信登录或跳到登录页面
                event.preventDefault();
                if (WxHelper.isWechatBrowser()) {  // 尝试通过微信认证方式登录
                    // alert('未登录，尝试通过微信');
                    redirectWechatAuthOrRetry($window, WxHelper, toState, toParams);
                } else {
                    // alert('未登录，跳到login');
                    $state.go('login');
                }
                return;
            }

            // 还未获取用户菜单项表示的权限列表，则尝试获取
            if (!Sidebar.hasMenuItems()) {
                event.preventDefault();
                // alert('还未获取用户菜单项表示的权限列表，则尝试获取, toState: ' + toState.name);
                Sidebar.getMenuItems(function () {
                    $state.go(toState, toParams)
                });
                return;
            }

            // alert('检查是否拥有对应权限, toState: ' + toState.name);
            if (toState.can === false) {
                event.preventDefault();
                Dlg.notify("您没有访问该页面的权限，请求被中止了").then(function () {
                    $state.go('login');
                });
            }
        }

        function changeSuccess(event, state) {
            if (state.name) {
                $uibModalStack.dismissAll();
                if (window.innerWidth < 768) Sidebar.updateState(Sidebar.STATE.HIDDEN);
                window.scrollTo(0, 0);

                var index = $state.current.index;
                if (angular.isDefined(index)) $rootScope.collapseVar = index;
            }
        }
    }

    function redirectWechatAuthOrRetry($window, WxHelper, toState, toParams) {
        if (redirectWechatAuthOnce($window, WxHelper, toState, toParams)) return;

        $window.setTimeout(function () {
            redirectWechatAuthOnce($window, WxHelper, toState, toParams);
        }, WECHAT_AUTH_REDIRECT_LOCK_TTL);
    }

    function redirectWechatAuthOnce($window, WxHelper, toState, toParams) {
        var now = new Date().getTime();

        try {
            var storage = $window.localStorage;
            storage.setItem(WECHAT_AUTH_REDIRECT_TARGET_KEY, JSON.stringify({
                toState: toState ? (toState.name || toState) : null,
                toParams: toParams || {},
                at: now
            }));

            if (isRedirectingWechatAuth) return false;

            var lockedAt = parseInt(storage.getItem(WECHAT_AUTH_REDIRECT_LOCK_KEY), 10);
            if (lockedAt && now - lockedAt < WECHAT_AUTH_REDIRECT_LOCK_TTL) return false;
            storage.setItem(WECHAT_AUTH_REDIRECT_LOCK_KEY, now);
        } catch (e) {
            // localStorage can be unavailable in restricted browser modes; keep the in-memory lock.
            if (isRedirectingWechatAuth) return false;
        }

        isRedirectingWechatAuth = true;
        $window.location.href = WxHelper.getWechatAuthorizeUrl(toState, toParams);
        return true;
    }

    var previewRoutes = [
        ["email", "email.html", "emails/:id"],
        ["article", "article.html", "articles/:type/:id"],
        ["meeting", "meeting.html", "meetings/:id"],
        ["topic", "topic.html", "topics/:id"],
        ["mission", "mission.html", "missions/:id"],
        ["attendancePublicity", "attendancePublicity.html", "attendancePublicity"],
        ["meeting_comment", "meetingComment.html", "meeting_attendances/:id"],
        ["attendance_abnormal_appeals", "attendanceAbnormal.html", "attendance_abnormal_appeals/:day"]
    ];

    var routes = [
        ["user_profile", "user/profile", "user/profile.html", 1000],
        ["coop_file_cabinet", "coop/file_cabinet", "user/file_cabinet.html", 1024],
        ["user_dept_record", "user/dept_record", "user/dept_record.html", 1001],
        ["user_meal", "user/meal", "user/meal.html", 1018],
        ["user_duty_fee", "user/duty_fee", "user/duty.html", 1005],

        ["user_edu", "user/edu", "user/edu.html", 1011, ['pdf', 'video']],
        ["user_contract", "user/contract", "user/contract.html", 1006, ['pdf']],
        ["coop_qualification", "coop/qualification", "user/qualification.html", 10019],
        ["coop_authorization", "coop/authorization", "user/authorization.html", 10016],
        ["coop_ap_search", "coop/aq_search", "user/aq_search.html", 10017],
        ["coop_rule", "coop/rule", "coop/rule.html", 10034, ['pdf']],
        ["coop_responsibility", "coop/responsibility", "coop/responsibility.html", 10035, ['pdf']],
        ["user_help", "user/help", "user/help.html", 1020],
        ["user_integration", "user/integration", "user/integration.html", 1021],
        ["coop_trade_union", "coop/trade_union", "coop/tradeUnion.html", 1022],
        ["coop_tu_interesting_group", "coop/tu_interesting_group", "coop/tuInterestingGroup.html", 1023],
        ["coop_tu_activity", "coop/tu_activity", "coop/tuActivity.html", 1025],

        ["coop_asset", "coop/asset", "coop/asset.html", 10006],
        ["coop_consumable", "coop/consumable", "coop/consumable.html", 10007],
        ["coop_pay", "coop/pay", "coop/pay.html", 10008],
        ["coop_doc", "coop/doc", "coop/doc.html", 10009],
        ["coop_leave", "coop/leave", "coop/leave.html", 1002],
        ["coop_reimbursement", "coop/reimbursement", "coop/reimbursement.html", 1003],
        ["coop_attendance", "coop/attendance", "coop/attendance.html", 10018],
        ["coop_q", "coop/q", "user/q.html", 10011],
        ["coop_file", "coop/file", "user/fileCirculate.html", 10012],
        ["coop_meeting", "coop/meeting", "coop/meeting.html", 10027],
        ["coop_topic", "coop/topic", "coop/topic.html", 10010],
        ["coop_directorate_topic", "coop/directorate_topic", "coop/directorate_topic.html", 10039],
        ["user_car_apply", "user/car_apply", "user/carApply.html", 10030],
        ['user_car_cost', 'user/car_cost', 'user/carCost.html', 10031],
        ['user_car_illegal', 'user/car_illegal', 'user/carIllegal.html', 10032],
        ['coop_workload', 'coop/workload', 'coop/workload.html', 10033],
        ['coop_purchase_contract', 'coop/purchase_contract', 'coop/purchase_contract.html', 10036],
        ['coop_sale_contract', 'coop/sale_contract', 'coop/sale_contract.html', 10037],
        ['coop_other_contract', 'coop/other_contract', 'coop/other_contract.html', 10038],

        ["coop_leave_dept_query", "coop/leave_dept_query", "coop/leaveDeptQuery.html", 10021],
        ["coop_leave_query", "coop/leave_query", "coop/leaveQuery.html", 10020],
        ["coop_stability_schedule", "coop/stability_schedule", "coop/stabilitySchedule.html", 10022],
        ["coop_project_search", "coop/project_search", "coop/project_search.html", 10023],
        // ["coop_project", "coop/project", "coop/project.html", 10024],
        ["coop_company", "coop/company", "coop/company.html", 10025],
        ["coop_wage", "coop/wage", "coop/wage.html", 10026, ["ngHandsontable"]],
        ["coop_mission", "coop/mission", "coop/mission.html", 10029],
        ["coop_clinic_activity", "coop/clinic_activity", "coop/activity.html", 10028],

        ["message_email", "message/email", "message/email.html", 8001],
        ["message_bulletin", "message/bulletin", "message/bulletin.html", 8002],
        ["message_news", "message/news", "message/news.html", 8003],
        ["message_contact_group", "message/contact_group", "message/contact_group.html", 8004],
        ["message_contacts", "message/contacts", "message/contacts.html", 8005],
        ["message_sms", "message/sms", "message/sms.html", 8006],
        ["message_common_phone", "message/common_phone", "message/commonPhone.html", 8007],

        ["dept_attendance", "dept_leader/attendance", "dept_leader/attendance.html", 3018],
        ["dept_notice_approval", "dept_leader/notice_approval", "dept_leader/notice_approval.html", 3001],
        ["dept_news", "dept_leader/news", "dept_leader/news.html", 3016],
        ["dept_doc", "dept_leader/doc", "dept_leader/doc.html", 3030],
        ["dept_meeting_approval", "dept_leader/meeting_approval", "dept_leader/meeting_approval.html", 3004],
        ["dept_q", "dept_leader/q", "dept_leader/q.html", 3006],
        ["dept_leader_topic", "dept_leader/topic", "dept_leader/topic.html", 3008],
        ["dept_leader_contract", "dept_leader/contract", "dept_leader/contract.html", 3009],

        ["dept_phones", "dept_leader/phones", "dept_leader/phones.html", 3010],
        ["dept_member", "dept_leader/members", "dept_leader/members.html", 3020],
        ["dept_file", "dept_leader/dept_file", "dept_leader/dept_file.html", 3012],
        ["dept_edu", "dept_leader/edu", "dept_leader/edu.html", 3011, ['pdf', 'video']],
        ["dept_wage", "dept_leader/wage", "dept_leader/wage.html", 3017, ["ngHandsontable"]],
        // ["dept_overtime_report", "dept_leader/overtime_report", "dept_leader/overtime_report.html", 3019],
        ["dept_car", "dept_leader/car", "dept_leader/car.html", 3021],
        ["dept_workload", "dept_leader/workload", "dept_leader/workload.html", 3022],
        ["dept_rule", "dept_leader/rule", "dept_leader/rule.html", 3023, ['pdf']],
        ["dept_responsibility", "dept_leader/responsibility", "dept_leader/responsibility.html", 3024, ['pdf']],

        ["duty_scheduler", "duty/scheduler", "duty/scheduler.html", 8101],
        ["duty_mes_report_assignment", "duty/mes_report_assignment", "duty/reportAssignment.html", 8106],
        ["duty_shift", "duty/shift", "duty/shift.html", 8102],
        ["duty_group_member", "duty/group_member", "duty/group_member.html", 8103],
        ["duty_fee_declare", "duty/fee_declare", "duty/fee_declare.html", 8104],

        // ["hospital_attendance", "hospital_leader/attendance", "hospital_leader/attendance.html", 3218],
        ["hospital_wage", "hospital_leader/wage", "hospital_leader/wage.html", 3203, ["ngHandsontable"]],

        ["main_leave", "main_leader/leave", "main_leader/leave.html", 3301],
        ["main_doc", "main_leader/doc", "main_leader/doc.html", 3302],
        ["main_users_info", "main_leader/user_info", "main_leader/userInfo.html", 3305],
        ["main_attendance", "main_leader/attendance", "main_leader/attendance.html", 3315],
        ["main_leader_topic", "main_leader/topic", "main_leader/topic.html", 3303],
        ["main_leader_contract", "main_leader/contract", "main_leader/contract.html", 3304],
        ["main_leader_wage", "main_leader/wage", "main_leader/wage.html", 3316, ["ngHandsontable"]],
        ["main_clinic_activity", "main_leader/clinic_activity", "main_leader/clinic_activity.html", 3317],
        ["main_leader_rule", "main_leader/rule", "hospital_leader/rule.html", 3319, ['pdf']],
        ["main_leader_responsibility", "main_leader/responsibility", "hospital_leader/responsibility.html", 3320, ['pdf']],
        // ["main_overtime_report", "main_leader/overtime_report", "main_leader/overtime_report.html", 3317],
        ["main_workload", "main_leader/workload", "main_leader/workload.html", 3318],

        ["party_work_signed", "party_work/signed", "party_work/signed.html", 16101],
        ["party_work_tozr", "party_work/tozr", "party_work/tozr.html", 16102],


        ["publicity_news", "publicity/news", "publicity/news.html", 31001],

        ["stability_explain", "stability/explain", "stability_schedule/explain/explain.html", 32001],
        ["stability_user", "stability/user", "stability_schedule/user/list.html", 32002],
        ["stability_search", "stability/search", "stability_schedule/search/search.html", 32003],

        ["consumable_manage", "consumable/manage", "consumable/manage.html", 32101],
        ["consumable_in_out", "consumable/in_out", "consumable/in_out.html", 32102],

        ["asset_manage", "asset/manage", "asset/manage.html", 32201],
        ["asset_confirm", "asset/confirm", "asset/confirm.html", 32202],
        ["asset_type", "asset/type", "asset/type.html", 32203],

        ["bulletin_manage", "hospital_office/bulletin_manage", "hospital_office/bulletin_manage.html", 4002],
        ["party_doc", "sys/doc", "sys/doc.html", 4018],
        ["hospital_office_dept_phone", "hospital_office/dept_phone", "hospital_office/dept_phone.html", 4019],
        ["hospital_office_common_phone", "hospital_office/common_phone", "hospital_office/common_phone.html", 4020],
        ["file_manage", "hospital_office/file_manage", "hospital_office/file_manage.html", 4003],
        ["work_arrange", "hospital_office/work_arrange", "hospital_office/workArrange.html", 4004],
        ["meeting_manage", "hospital_office/meeting_manage", "hospital_office/meeting_manage.html", 4005],
        ["file_circulate", "hospital_office/file_circulate", "hospital_office/fileCirculate.html", 4008],
        ["rule_manage", "hospital_office/rule_manage", "hospital_office/rule_manage.html", 4009, ['pdf']],
        ["responsibility_manage", "hospital_office/responsibility_manage", "hospital_office/responsibility_manage.html", 4010, ['pdf']],
        ["hospital_user_badge", "hospital_office/badge", "hospital_office/badge.html", 4015],
        ["hospital_office_topic", "hospital_office/topic", "hospital_office/topic.html", 4014],
        ["directorate_topic", "directorate/topic", "directorate/topic.html", 4017],
        ["hospital_office_contract_file", "hospital_office/contract_file", "hospital_office/contract_file.html", 4016, ["ngHandsontable"]],
        ["hospital_office_duty_fee_approval", "hospital_office/duty_fee_approval", "hospital_office/feeApproval.html", 4031],

        ["car_pending", "car_manage/pending", "car_manage/pending.html", 3501],
        ["car_warranty", "car_manage/warranty", "car_manage/warranty.html", 3502],
        ["car_scheduler", "car_manage/scheduler", "car_manage/scheduler.html", 3503],
        ["car_direct", "car_manage/direct", "car_manage/direct.html", 3504],
        ["car_record", "car_manage/record", "car_manage/record.html", 3505],
        ["car_emergency_direct", "car_manage/emergency_direct", "car_manage/emergencyDirect.html", 3506],
        ["cm_car_illegal", "car_manage/car_illegal", "car_manage/carIllegal.html", 3509],
        ["cm_pay_manage", "car_manage/car_pay_manage", "car_manage/payManage.html", 3512],
        ["cm_car_oil", "car_manage/car_oil", "car_manage/carOil.html", 3510, ['chart']],
        ["car_as_manage", "car_manage/as_manage", "car_manage/aSManage.html", 3508],
        ["car_handler", "car_manage/handler", "car_manage/handler.html", 3511],

        ["personnel_user_info", "personnel/user_info", "personnel/userInfo.html", 2000],
        ["personnel_dept_member", "personnel/dept_member", "personnel/deptMember.html", 2001],
        ["personnel_user_leave", "personnel/user_leave", "personnel/userLeave.html", 2002],
        ["personnel_user_reg", "personnel/user_reg", "personnel/userReg.html", 2003],
        ["personnel_user_labor_dispatch", "personnel/user_labor_dispatch", "personnel/userLaborDispatch.html", 2039],
        ["dept_group_manage", "personnel/dept_group_manage", "personnel/dept_group_manage.html", 2006],

        ["personnel_attendance", "personnel/attendance", "personnel/attendance.html", 2005],
        ["personnel_leave", "personnel/leave", "personnel/leave.html", 2011],
        ["personnel_retired_worker", "personnel/retired_worker", "personnel/retired_worker.html", 2031],
        ["personnel_annual_leave_manage", "personnel/annual_leave_manage", "personnel/annual_leave_manage.html", 2032],
        ["personnel_contact_group", "personnel/contact_group", "personnel/contact_group.html", 2033],
        ["personnel_contract", "personnel/contract", "personnel/personnel_contract.html", 2034],
        ["personnel_wage", "personnel/wage", "personnel/wage.html", 2035, ["ngHandsontable"]],
        ["personnel_wage_setting", "personnel/wage_setting", "personnel/wage_setting.html", 2037],
        ["personnel_sanction", "personnel/sanction", "personnel/sanction.html", 2036, ["ngHandsontable"]],
        ["personnel_qualification", "personnel/qualification", "personnel/qualification.html", 2029],
        ["personnel_qa", "personnel/qa", "personnel/qualification_authority.html", 2030],
        ["personnel_workload", "personnel/workload", "personnel/workload.html", 2038],
        ["personnel_trade_union", "personnel/trade_union", "personnel/tradeUnionPersonnel.html", 2040],
        ["personnel_purchase_contract", "personnel/purchase_contract", "personnel/purchase_contract.html", 2041],
        ["personnel_sale_contract", "personnel/sale_contract", "personnel/sale_contract.html", 2042],
        ["personnel_other_contract", "personnel/other_contract", "personnel/other_contract.html", 2043],

        ["finance_office_contract_file", "finance/contract_file", "finance/contract_file.html", 2344, ["ngHandsontable"]],
        ["finance_purchase_contract", "finance/purchase_contract", "finance/purchase_contract.html", 2341],
        ["finance_sale_contract", "finance/sale_contract", "finance/sale_contract.html", 2342],
        ["finance_other_contract", "finance/other_contract", "finance/other_contract.html", 2343],

        ["finance_attendance", "finance/attendance", "finance/attendance.html", 2318],
        ["finance_subsidy_paid", "finance/subsidy", "finance/subsidyPaid.html", 2309],
        ["finance_project_manager", "finance/project_manager", "finance/project_manager.html", 2310],
        ["finance_cashier", "finance/cashier", "finance/cashier.html", 2311, ["ngHandsontable"]],
        ["finance_accounting", "finance/accounting", "finance/accounting.html", 2312, ["ngHandsontable"]],
        ["finance_treasurer", "finance/treasurer", "finance/treasurer.html", 2313, ["ngHandsontable"]],
        ["finance_legaler", "finance/legaler", "finance/legaler.html", 2316, ["ngHandsontable"]],
        ["finance_manager", "finance/manager", "finance/manager.html", 2314, ["ngHandsontable"]],
        ["finance_chairman", "finance/chairman", "finance/chairman.html", 2319, ["ngHandsontable"]],
        ["finance_duty_paid_detail", "finance/duty_paid_detail", "finance/duty.html", 2331],
        ["finance_wage", "finance/wage", "finance/wage.html", 2315, ["ngHandsontable"]],
        ["finance_canteen", "finance/canteen", "finance/canteen.html", 2317, ["ngHandsontable"]],

        ['pec_pharmacy_pill', 'pharmacy/pill', 'pharmacy/pill.html', 3601, ["ngHandsontable"]],

        ["restaurant_spot", "restaurant/spot", "restaurant/spot.html", 8101, ['qrCode']],
        ["restaurant_reconciliation", "restaurant/reconciliation", "restaurant/reconciliation.html", 8102],

        ["meal_recharge", "meal/recharge", "meal/recharge.html", 8201],
        ["meal_purchase_reconciliation", "meal/purchase_reconciliation", "meal/purchaseReconciliation.html", 8202],
        ["meal_recharge_reconciliation", "meal/recharge_reconciliation", "meal/rechargeReconciliation.html", 8203],

        ["partner_company_basic", "partner_company/partner_company", "partner_company/company.html", 8301],
        ["project_manager", "project_manager/project_manager", "project_manager/project_manage.html", 8401],

        ["clinic_activity", "clinic_manage/clinic_activity", "clinic_manage/activity.html", 8501],
        ["clinic_basic", "clinic_manage/clinic_basic", "clinic_manage/basic.html", 8502],

        ["shop_trade_union", "shop/trade_union", "shop/tradeUnion.html", 8601],

        ["tu_user", "tu/user", "tu/user.html", 8701],
        ["tu_festival_award", "tu/festival_award", "tu/festivalAward.html", 8702],
        ["tu_interesting_group", "tu/interesting_group", "tu/interestingGroup.html", 8703],
        ["tu_activity", "tu/activity", "tu/activity.html", 8704],

        ["test", "sys/test", "sys/test/index.html", 9991],
        ["sys_basic", "sys/basic", "sys/basic.html", 9000],
        ["sys_coop", "sys/coop", "sys/coop.html", 9007],
        ["sys_sign", "sys/sign", "sys/sign.html", 9010],
        ["sys_dept", "sys/dept", "sys/dept.html", 9003],
        ["sys_meeting", "sys/meeting", "sys/meeting.html", 9009],
        ["sys_car", "sys/car", "sys/car.html", 9004],
        ["sys_qualification", "sys/qualification", "sys/qualification.html", 9012],
        ["sys_duty_group", "sys/duty_group", "sys/duty_group.html", 9021],

        ["sys_authority", "sys/authority", "sys/authority.html", 9001],
        ["sys_help", "sys/help", "sys/help.html", 9020],
        ["sys_app_cfg", "sys/app_cfg", "sys/app_cfg.html", 9002],
    ];

})();

(function () {
    'use strict';

    angular.module('c')
        .factory('mySocket', socketFactory)
        .run(runSocket)
    ;

    /** @ngInject */
    function runSocket(mySocket) {
    }

    /** @ngInject */
    function socketFactory(socketFactory) {
        // var protocol = window.location.protocol;
        var myIoSocket = io.connect("//" + window.location.hostname + ':3230');

        var mySocket = socketFactory({
            ioSocket: myIoSocket
        });

        mySocket.forward([
            // 餐补
            "ycoa:meal.purchased",

            // 邮件
            "ycoa:mail.read",
            "ycoa:mail.send",
            "ycoa:mail.withdraw",

            // 公文
            "ycoa:bulletin.send",
            "ycoa:file.release",
            "ycoa:meeting.send",
            "ycoa:meeting.read",
            "ycoa:mission.send",
            "ycoa:news.send",
            "ycoa:rule.send",
            "ycoa:selfAssessment.automatic",

            "ycoa:task",

            'ycoa:round.progress',

            //"ycoa:question.send",
            "ycoa:wechat.orderPay",
            "ycoa:takeOut.send",
            "ycoa:workingMeal.handle",
            "ycoa:workingMeal.send",
            "ycoa:appointment.notify",
            "ycoa:festivalAward.spot",
            "ycoa:file.zipDownload",
        ]);

        return mySocket;
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['uiMask.ConfigProvider', uiMaskConfig])
        .config(uibConfig)
    ;

    /** @ngInject */
    function uiMaskConfig(uiMaskConfigProvider) {
        uiMaskConfigProvider.clearOnBlur(false);
    }

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig, $uibTooltipProvider) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";

        $uibTooltipProvider.options({
            appendToBody: true
        });
    }

})();

angular.module('c')
    .constant('C', {
        P: "socket:ycoa:",

        V: "pages/dlg/",
        T: "templates/",


        STAGE1: {
            /**
             * 部门审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 分管审：1
             */
            HOSPITAL_APPROVAL: 1,
            /**
             * 部门退：2
             */
            DEPT_BACK: 2,
            /**
             * 公司退：3
             */
            HOSPITAL_BACK: 3,
            /**
             * 发布：4
             */
            PUBLIC: 4,
            OVER: 5
        },
        STAGE2: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 退回：1
             */
            BACK: 1,
            /**
             * 发布：2
             */
            PUBLIC: 2
        },
        STAGE3: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 发布：1
             */
            PUBLIC: 1,
            /**
             * 退回：2
             */
            BACK: 2
        },

        STAGE5: {
            /**
             * 部门审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 分管审：1
             */
            HOSPITAL_APPROVAL: 1,
            //个人整改意见
            USER_APPROVAL: 5,
            /**
             * 办公室审核：6
             */
            PARTY_APPROVAL: 6,
            /**
             * 接受：7
             */
            ACCEPT: 7,
            /**
             * 拒绝：8
             */
            REJECT: 8,
            /**
             * 退回意见人：9
             */
            BACK: 9
        },

        EDU: {
            Q: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            FOR: {
                DOCTOR: 1,
                NURSE: 2,
                ALL: 3
            },
            P: {
                TYPE: {
                    NORMAL: '1',
                    PACKAGE: '2',
                    PART: '3'
                },
                R_BY: {
                    /**
                     *
                     */
                    DEPT: '1',
                    EDU: '2',
                    NURSE: '3'
                }
            },
            T: {
                SHOW: {
                    FOR: {
                        PAPER: '1',
                        FILL: '2',
                        ANSWER_SHEET: '3',
                        STATISTIC: '4'
                    }
                }
            }
        },
        Q: {
            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            TYPE: {
                NORMAL: '1',
                DEPT: '6',
                USER: '7',
                LEADER: '8'
            }
        },
        Q_SURVEY: {
            TYPE: {
                DEPT: '1',
                HOSPITAL: '2'
            },
            CLOSE: {
                WHEN_EXPIRED: '1',
                WHEN_FINISH: '2',
                WHEN_MANUAL: '3'
            },
            RR: {
                REAL_TIME: '1',
                WHEN_FINISH: '2',
                MANUAL: '3'
            },
            SHOW: {
                FOR: {
                    QUESTIONNAIRE: '1',
                    FILL: '2',
                    ANSWER_SHEET: '3',
                    STATISTIC: '4',
                    APPROVAL: '5'
                }
            }
        },
        Q_OPINION: {
            PRIVACY: {
                NONE: '1',
                RESPONDENT: '2',
                ALL: '3'
            }
        },
        OPT: {
            EDU: {
                TEST: {
                    INDEX: {
                        DEPT: 1,
                        NURSE: 2,
                        EDU: 3
                    },
                    SHOW: {
                        SIMPLE: 1,
                        STATISTICS: 2,
                        PKG_STATISTICS: 3,
                        MAKEUP: 4,
                        REMAINING: 5
                    }
                },
                P: {
                    INDEX: {
                        DEPT_P: 1,
                        DEPT_P_OPTIONS: 2,
                        PARTS: 3,
                        NURSE: 7,
                        EDU: 8
                    },
                    EDIT: {
                        SAVE: 3,
                        STOP: 4
                    }
                },
                Q: {
                    INDEX: {
                        USER_Q: 1,
                        NURSING_Q: 2,
                        EDU_Q: 3,
                        ITEM_BANK: 4
                    },
                    EDIT: {
                        APPROVAL: 1,
                        SAVE: 3,
                        STOP: 4
                    }
                },
                C: {
                    INDEX: {
                        USER: 1,
                        DEPT: 2,
                        NURSE: 3,
                        EDU: 4
                    }
                }
            },
            Q: {
                INDEX: {
                    USER_Q: 1,
                    USER_Q_OPTIONS: 2,
                    PARTY_Q: 3,
                    PARTY_Q_OPTIONS: 4
                },
                EDIT: {
                    SAVE: 3,
                    STOP: 4
                },
                EDIT1: 1,
                EDIT2: 2,
                RELEASE: 3,
                SUBMIT: 5
            },
            Q_SURVEY: {
                INDEX: {
                    USER_Q_SURVEY: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_Q_SURVEY: 4,
                    DEPT_RESULT: 5,
                    DEPT_RESULT4HOSPITAL: 6,
                    RESULT_OPTIONS: 7,
                    OPTION_NOTES: 8,
                    USER_RESULT: 9,
                    APPROVAL_LIST: 10,
                    USER_SS: 11
                },
                SHOW: {
                    SIMPLE: 1,
                    STATISTICS: 2,
                    APPROVAL: 3
                },
                EDIT: {
                    APPROVAL: 1,
                    MANUAL_CLOSE: 2,
                    MANUAL_RR: 3
                },
                APPROVAL: '1'
            },
            Q_ANSWER_SHEET: {
                INDEX: {
                    USER_Q_SHEET: 1,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    FILL: 1
                }
            },
            Q_OPINION: {
                INDEX: {
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_APPROVAL: 4,
                    USER_APPROVAL: 5,
                    USER_OPINION: 6,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    APPROVAL: 1,
                    CHANGE_DEPT: 2,
                    ADD: 3    //补充意见
                }
            },
            FILE: {
                INDEX: {
                    HOSPITAL_OFFICE_FILING: 1,
                    USER_UNREAD: 2,
                    USER_READ: 3,
                    HOSPITAL_OFFICE_SEAL_UP: 4,
                    IS_READING_PRINT: 5,
                    ALREADY_READ_PRINT: 6,
                    SEAL_UP_PRINT: 7,
                    USER_FILING: 8,
                    FILING_PRINT: 9,
                    USER_APPLIED: 10
                },
                EDIT: {
                    SEAL_UP: 1,
                    READ: 2,
                    CIRCULATE: 3,
                    FILING: 4
                }
            },
            /**
             * @deprecated 移到对应服务中
             */
            RULE_TYPE: {
                INDEX: {
                    DEPT_MANAGE: 1,
                    HOSPITAL_MANAGE: 2,
                    OPTIONS: 3,
                    NAME_EXCHANGE: 4,
                    CLASS_EXCHANGE: 5
                }
            }
        },

        URL: {
            CHROME: {
                windows: 'download/android/chrome.exe',
                android: 'download/android/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            },

            IMG_UPLOAD: '/api/v1/file/images/upload',

            MEDICAL_INFO_UPLOAD: '/api/v1/medical_info/upload',
            MEDICAL_INFO_DOWNLOAD: '/api/v1/medical_info/download',

            BLOOD_STORAGE_UPLOAD: '/api/v1/blood_storage/upload',
            BLOOD_STORAGE_DOWNLOAD: '/api/v1/blood_storage/download',

            MAIL_UPLOAD: '/api/v1/emails/upload',
            MAIL_DOWNLOAD: '/api/v1/emails/download',
            BULLETIN_UPLOAD: '/api/v1/bulletin/bulletin/upload',
            BULLETIN_DOWNLOAD: '/api/v1/bulletin/bulletin/download',

            Q_OPINION_EXPORT: '/api/v1/q/q_opinions/export',

            FILE_CABINET_UPLOAD: '/api/v1/file_cabinet/upload',
            FILE_CABINET_DOWNLOAD: '/api/v1/file_cabinet/download',

            NEWS_DOWNLOAD: '/api/v1/bulletin/download',

            MEETING_EXPORT: '/api/v1/meeting/meetings/export',
            MEETING_UPLOAD: '/api/v1/meeting/meetings/upload',
            MEETING_DOWNLOAD: '/api/v1/meeting/meetings/download',

            MISSION_UPLOAD: '/api/v1/mission/missions/upload',
            MISSION_DOWNLOAD: '/api/v1/mission/missions/download',
            MISSION_EXPORT: '/api/v1/mission/missions/export',

            REGULAR_MISSION_UPLOAD: '/api/v1/mission/regular_missions/upload',
            REGULAR_MISSION_DOWNLOAD: '/api/v1/mission/regular_missions/download',

            MISSION_REPORT_UPLOAD: '/api/v1/mission/mission_reports/upload',
            MISSION_REPORT_DOWNLOAD: '/api/v1/mission/mission_reports/download',

            QUALIFICATION_REPORT_UPLOAD: '/api/v1/qualification/qualifications/upload',
            QUALIFICATION_REPORT_DOWNLOAD: '/api/v1/qualification/qualifications/download',

            E_QUESTION_DOWNLOAD: '/api/v1/edu/edu_questions/download',

            E_COURSE_UPLOAD: '/api/v1/edu/edu_courses/upload',
            E_COURSE_DOWNLOAD: '/api/v1/edu/edu_courses/download',
            E_UC_DOWNLOAD: '/api/v1/edu/edu_user_courses/export',
            E_SC_DOWNLOAD: '/api/v1/edu/edu_user_courses/signExport',

            Q_SURVEY_DOWNLOAD: '/api/v1/q/questionnaire_surveys/export',
            E_TEST_DOWNLOAD: '/api/v1/edu/edu_tests/export',

            FILES_EXPORT: '/api/v1/files/export',

            ROUND_DOWNLOAD: '/api/v1/rounds/export',

            CONTRACT_UPLOAD: '/api/v1/contract/contracts/upload',
            CONTRACT_UPLOAD1: '/api/v1/contract/contracts/upload1',
            CONTRACT_DOWNLOAD: '/api/v1/contract/contracts/download',

            CONTRACT_EXPORT: 'api/v1/contract/contracts/export',

            /**
             * 证书订单导出
             */
            QUALIFICATION_EXPORT: '/api/v1/qualification/qualifications/export',
            QUALIFICATION_STATISTIC: '/api/v1/qualification/qualifications/statistic',
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .constant('serviceConfObj', {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        });
})();

(function () {
    'use strict';

    angular.module('c').filter('abs', abs);

    /** @ngInject */
    function abs() {
        return function (num) {
            return Math.abs(num);
        }
    }

})();

angular.module('c')
    .filter('bytes', function() {
    return function(bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
        var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
            measure, floor, precision;
        if (bytes > 1099511627775) {
            measure = 4;
        } else if (bytes > 1048575999 && bytes <= 1099511627775) {
            measure = 3;
        } else if (bytes > 1024000 && bytes <= 1048575999) {
            measure = 2;
        } else if (bytes <= 1024000) {
            measure = 1;
        }
        floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
        if (floor > 3) {
            precision = 0
        } else {
            precision = 3 - floor;
        }
        return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
    }
});

/**
 * 将从laravel服务器传过来的时间格式转换成javascript的格式，在送入内建过滤器date处理
 */
angular.module('c')
    .filter('date2', function ($filter) {
        return function (text, format) {
            if (text != null && text != '') {
                var tempdate = new Date(text.replace(/-/g, "/"));
                return $filter('date')(tempdate, format);
            }
            return text;
        }
    });
angular.module('c')
    .filter('dateInRange', function (uibDateParser) {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (key in params) {
                    var date = item[key];
                    date = uibDateParser.parse(date, 'yyyy-MM-dd');
                    var dateRange = params[key];
                    if ((dateRange.startDate != null && date < dateRange.startDate)
                        || (dateRange.endDate != null && date > dateRange.endDate)) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .filter('defValIfNone', defValIfNone);

    /** @ngInject */
    function defValIfNone() {
        return function (input, val) {
            if (!input) {
                if (angular.isUndefined(val)) {
                    if (input === 0) {
                        val = '无';
                    } else {
                        val = '其他';
                    }
                }
                return val;
            }
            return input;
        }
    }

})();

angular.module('c')
    .filter('exceptItem', function (F) {
        return function (items, exclude) {
            if (exclude && exclude.length > 0) {
                var ret = [];
                angular.forEach(items, function (item) {
                    var i = F.indexOfKey(item, exclude);
                    if (F.indexOfKey(item.id, exclude) == -1) {
                        ret.push(item);
                    }
                });
            } else {
                ret = items;
            }
            return ret;
        }
    });
angular.module('c')
    .filter('numInRange', function () {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (var key in params) {
                    var num = item[key];
                    var numRange = params[key];
                    var start = -Number.MAX_VALUE, end = Number.MAX_VALUE;
                    if (numRange.start != null && numRange.start != '') {
                        start = parseInt(numRange.start);
                    }
                    if (numRange.end != null && numRange.end != '') {
                        end = parseInt(numRange.end);
                    }
                    if (num < start || num > end) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .filter('strLimit', strLimit);

    /** @ngInject */
    function strLimit($filter) {
        return function (input, limit) {
            if (!input) return;
            if (angular.isUndefined(limit)) limit = 20;
            if (input.length <= limit) {
                return input;
            }

            return $filter('limitTo')(input, limit) + '...';
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserConfirmCtrl', UserConfirmCtrl);

    /** @ngInject */
    function UserConfirmCtrl ($scope, $state, Auth, User, $q, Dlg, FormHelper, DateHelper, ArrayHelper) {
        var account = Auth.getAccount();
        var vm = this;
        var helper = User.formHelper;
        var required = {
            status: true, entryTime: false, startedWork: true, annualDays: true, password: true
        };

        vm.ok = ok;
        vm.logout = logout;

        init();


        function init () {

            if (account.confirm_state !== User.CONFIRM.PENDING) $state.go('app.home');

            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    dept: true,
                    company: true,
                    username: true,
                    cardre: true
                },
                enableTransferDept: false,
                hideUpdateAnnualChecker: true,
                required: required,
                contactBodyStyle: {height: '360px'}// 下面再设置
            };

            $q.all([
                User.get({id: '-', op: 'default'}).$promise,
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                var m = respArray[0].item;

                if (m.username && m.name && m.dept && m.type && m.status && m.entry_time && m.started_work) {
                    // vm.cfg.disable = {
                    //     username: true, name: true, dept: true, type: true, status: true,
                    //     entryTime: false, startedWork: true
                    // }
                }

                helper.bindAsyncOptions(vm, respArray[1]);

                m.edu_bg = ArrayHelper.getItem(m.edu_bg, vm.edu_bgs);
                m.degree = User.getDegree(m.degree);
                m.en_lv = ArrayHelper.getItem(m.en_lv, vm.en_lvs);
                m.entry_time = DateHelper.str2Date(m.entry_time);
                m.started_work = DateHelper.str2Date(m.started_work);

                vm.calcAnnualTotal(m);

                m.update_annual_num = true;
                vm.m = m;
            });
        }

        function logout () {
            Auth.logout(function () {
                $state.go('login');
            });
        }

        function ok (m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m, 'user_confirm');
                pa.password = m.password;
                if (m.change_note) pa.change_note = m.change_note;
                else pa.change_note = null;

                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    account.confirm_state = User.CONFIRM.USER;
                    account.name = m.name;
                    account.photo = m.photo;
                    account.phone = m.phone;
                    Auth.setAccount(account);
                    // $state.go('app.user_profile', {data: {requireChangePasswd: true}});
                    $state.go('app.home');
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('c').controller('HomeCtrl', HomeCtrl)
        .controller('BulletinListCtrl', BulletinListCtrl)
        .controller('NewsListCtrl', NewsListCtrl)
        .controller('FileListCtrl', FileListCtrl)
        .controller('MeetingListCtrl', MeetingListCtrl)
        .controller('CPhoneDlgCtrl', CPhoneDlgCtrl)
        .controller('RuleListCtrl', RuleListCtrl)
        .controller('ResponsibilityListCtrl', ResponsibilityListCtrl)
    ;

    /** @ngInject */
    function HomeCtrl ($scope, $http, C, ArrayHelper, Auth, Dlg, FileHelper, DateHelper) {
        var vm = this;
        vm.hrm = hrm;
        vm.openPhoneDlg = openPhoneDlg;
        vm.download = download;
        vm.today = DateHelper.date2Str(new Date()); //bulletin-list news-list use
        vm.bulletins = [];
        vm.meetings = [];
        vm.ns = [];
        vm.files = [];
        vm.rules = [];
        vm.responsibilitys = [];

        init();


        function init () {
            vm.cards = [
                {
                    statTitle: '请假人数',
                    statNum: 0,
                    icon: 'fa-address-card-o',
                    iconTitle: '我的请假',
                    bg: 'bg-red-active',
                    linkTo: 'app.coop_leave'
                },
                {
                    statTitle: '月公文数',
                    statNum: 0, icon: 'fa-files-o', iconTitle: '我的公文', bg: 'bg-orange-active',
                    linkTo: 'app.coop_doc'
                },
                {
                    statTitle: '个人排班查询',
                    icon: 'fa-calendar-check-o',
                    iconTitle: '我的排班',
                    bg: 'bg-blue',
                    linkTo: 'app.user_duty_fee'
                }
            ];

            $http.get('api/v1/home').then(function (resp) {
                var data = resp.data;
                // vm.hasMission = data.hasMission;
                vm.bulletins = data.bulletins;
                vm.meetings = data.meetings;
                loadMeeting($scope, data.meetings, DateHelper, Auth);
                vm.ns = data.ns;
                vm.files = data.files;
                vm.rules = data.rules;
                vm.responsibilitys = data.responsibilitys;
                //
                angular.forEach(data.stats, function (num, i) {
                    vm.cards[i].statNum = num;
                });
            });
        }

        function download (m, _url) {
            FileHelper.download1(C.URL[_url], {name: m.name, filename: m.filename, mime: m.mime});
        }

        function hrm () {
            Dlg.show({
                template: C.T + 'leave/hrm_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function openPhoneDlg () {
            Dlg.show({
                template: C.T + 'misc/common_phone.html',
                ctrl: 'CPhoneDlgCtrl',
                data: {},
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function BulletinListCtrl ($scope, Dlg, C, Api, $http, ArrayHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init () {
            $scope.$on('bulletin.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadBulletin', function (event, data) {
                var id = data.id;
                var bulletin = ArrayHelper.getItem(id, home.bulletins);
                if (bulletin && bulletin.recipient == null) {
                    bulletin.recipient = true;
                }
            });
        }

        function reload () {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/bulletin/bulletins', {
                params: pa
            }).then(function (resp) {
                home.bulletins = resp.items;
            });
        }

        function read (bulletin) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'BulletinShowDlgCtrl',
                data: {
                    id: bulletin.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function NewsListCtrl ($scope, Dlg, C, $http, Api) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init () {
            $scope.$on('news.send', function () {
                reload();
            });
        }

        function reload () {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/news/news', {
                params: pa
            }).then(function (resp) {
                home.ns = resp.items;
            });
        }

        function read (n) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'NewsShowDlgCtrl',
                data: {
                    id: n.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function FileListCtrl ($scope, $http, Api) {
        var vm = $scope;
        var home = $scope.home;

        init();


        function init () {
            $scope.$on('file.release', function () {
                reload();
            });
        }

        function reload () {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/file_cabinet', {
                params: pa
            }).success(function (data) {
                home.files = data.files;
            });
        }
    }

    function loadMeeting (vm, meetings, DateHelper, Auth) {
        var account = Auth.getAccount();
        angular.forEach(meetings, function (meeting) {
            meeting.forLeave = false;
            meeting.forRemind = false;
            meeting.forRCancel = false;
            meeting.isApplicant = false;
            meeting.isModerator = false;
            var start = new Date(),
                end = DateHelper.str2Datetime(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                time = DateHelper.date2Str(yesterday) + ' ' + '08:30:00',
                y_start = DateHelper.str2Datetime(time, 'yyyy-MM-dd HH:mm:ss');
            if (meeting.applicant_id == account.id) {
                meeting.isApplicant = true;
            }
            if (DateHelper.diffInHours(start, y_start) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forDayRemind = true;
                    }
                }
            }

            if (DateHelper.diffInHours(start, end) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forRemind = true;
                    }
                }
            }

            if (DateHelper.diffInMinutes(start, end) >= 30) {
                if (meeting.attendees.length > 0) {
                    meeting.forLeave = true;
                }
            }

            if (meeting.leavers.length > 0) {
                meeting.forLeave = false;
            }

            if (meeting.moderator_id && meeting.moderator_id == account.id) {
                meeting.isModerator = true;
            }
            meeting.start_time = meeting.start_time.substr(0, 16);
        });
    }

    /** @ngInject */
    function MeetingListCtrl ($scope, C, ArrayHelper, DateHelper, Auth, Api, Dlg, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init () {
            $scope.$on('meeting.send', function () {
                reload();
            });

            $scope.$on('MeetingRead', function (event, data) {
                var id = data;
                var meeting = ArrayHelper.getItem(id, home.meetings);
                if (meeting && meeting.recipient == null) {
                    meeting.recipient = true;
                }
            });
        }

        function reload () {
            var pa = Api.param2Url({op: 'home', page: 1, count: 5, sorting: {start_time: 'asc'}});
            $http.get('/api/v1/meeting/meetings', {params: pa}).then(function (data) {
                loadMeeting(vm, data.meetings, DateHelper, Auth);
                home.meetings = data.meetings;
            });
        }

        function read (meeting) {
            Api.loadMod('meeting', function () {
                Dlg.show({
                    template: 'pages/dlg/meeting/show_dlg.html',
                    ctrl: 'MeetingShowDlgCtrl',
                    data: {
                        id: meeting.id,
                        ForLeave: meeting.forLeave,
                        ForRemind: meeting.forRemind,
                        ForDayRemind: meeting.forDayRemind,
                        ForRCancel: meeting.forRCancel,
                        isApplicant: meeting.isApplicant,
                        isModerator: meeting.isModerator
                    },
                    size: 'lg'
                }).then(function (params) {
                    switch (params.opt) {
                        case 4:
                            leave(meeting);
                            break;
                        case 5:
                            remind(meeting, params.op);
                            break;
                        case 6:
                            remove(meeting);
                            break;
                    }
                });
            });
        }


        function leave (meeting) {
            Api.comment({
                title: '会议请假',
                icon: 'sign-out',
                label: '原因'
            }, function (pa) {
                var params = {};
                params['reason'] = pa;
                params['start_time'] = meeting.start_time;
                $http.post('/api/v1/meeting/meetings/leave/' + meeting.id, params).then(function (resp) {
                        // Meeting.leave({id: meeting.id}, params).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('请假成功');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前半小时请假!');
                                break;
                        }
                    }, function () {
                        Dlg.e('请假失败了!');
                    }
                )
            });
        }

        function remind (meeting, op) {
            Dlg.confirm('确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?', function () {
                $http.post('/api/v1/meeting/meetings/get_attendance/' + meeting.id, {
                    opt: op
                }).then(function (resp) {
                        // Meeting.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('设置成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时设置!');
                                break;
                            case 2:
                                Dlg.w('已统一设置会前半小时提醒!');
                                break;
                            case 3:
                                Dlg.w('请在开会前一天08:30之前设置!');
                                break;
                        }
                    }, function () {
                        Dlg.e('设置失败了!');
                    }
                )
            }, '会前提醒');
        }

        function remove (meeting) {
            Dlg.confirm('确定要取消会前短信提醒吗?', function () {
                $http.post('/api/v1/meeting/meetings/set_reminder_time/' + meeting.id, {opt: 3}).then(function (resp) {
                        // Meeting.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                        //     function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('取消成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时取消!');
                                break;
                        }
                    }, function () {
                        Dlg.e('取消失败了!');
                    }
                )
            }, '取消会前提醒');
        }
    }

    /** @ngInject */
    function CPhoneDlgCtrl ($scope, $uibModalInstance, CommonPhone, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init () {
            var options = {
                service: CommonPhone,
                params: {opt: 2/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}}
                ]
            };
            Table.load(vm, options);
        }

    }

    /** @ngInject */
    function RuleListCtrl($scope, $ocLazyLoad, dialogs, C, Api, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('rule.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({op: 'home_list', page: 1, count: 6, sorting: {release_time: 'desc'}});
            $http.get('/api/v1/rule/rules', {params: pa}).then(function (data) {
                home.rules = data.rules;
            });
        }

        function read(rule) {
            $ocLazyLoad.load(['pdf', 'video']).then(function () {
                dialogs.create('pages/dlg/rule/showDlg.html', 'RuleShowDlgCtrl', {
                    id: rule.id
                }, {size: 'lg'});
            });
        }
    }

    function ResponsibilityListCtrl($scope, $ocLazyLoad, dialogs, C, Api, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('rule.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({op: 'home_list', page: 1, count: 6, sorting: {release_time: 'desc'}});
            $http.get('/api/v1/rule/rules', {params: pa}).then(function (data) {
                home.responsibilitys = data.responsibilitys;
            });
        }

        function read(rule) {
            $ocLazyLoad.load(['pdf', 'video']).then(function () {
                dialogs.create('pages/dlg/rule/showDlg.html', 'RuleShowDlgCtrl', {
                    id: rule.id
                }, {size: 'lg'});
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('LoginCtrl', LoginCtrl)
    ;

    /** @ngInject */
    function LoginCtrl($scope, $stateParams, $state, Dlg, deviceDetector,
                       Auth, $http, $interval, $urlRouter, Sidebar, OS_VERSIONS) {
        var vm = $scope;
        vm.loginForm = loginForm;
        vm.openid = $stateParams.data.openid;
        vm.user = {autoLogin: vm.openid ? true : Auth.getAutoLogin()};
        vm.smsLogin = false;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;
        vm.regex = {
            false: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
            true: /^[0-9]{6}$/
        };

        init();


        function init() {
            var chromeUrls = {
                windows: '/download/chrome/chrome.exe',
                android: '/download/chrome/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            };
            vm.chromeUrl = chromeUrls[deviceDetector.os];
            if (deviceDetector.browser !== 'chrome') {
                if (deviceDetector.os_version === OS_VERSIONS.WINDOWS_XP) {
                    vm.chromeUrl = '/download/chrome/chromeXp.exe'
                }
                if (vm.chromeUrl) {
                    Dlg.notify("您正在" + deviceDetector.os + "系统下访问本站,强烈建议您改用<span class='text-red'>" +
                        "chrome浏览器</span>访问,以保证正常使用所有功能" + " 点击<a class='text-red' href=" +
                        vm.chromeUrl + ">" + "这里</a>下载");
                }
            }
        }

        function loginForm(user, Form) {
            if (Form.$valid) {
                user.sms_login = vm.smsLogin;
                if (vm.openid) user.openid = vm.openid;
                Auth.login(user, function (resp) {
                    Sidebar.setupMenuItems(resp.menuItems);
                    if (vm.smsLogin) {
                        $state.go('app.user_profile', {data: {requireChangePasswd: true}});
                    } else {
                        $state.go('app.home');
                    }
                }, function (error) {
                    Dlg.e(error.msg);
                });
            } else {
                Form.submitted = true;
            }
        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/)) {
                Dlg.e('手机号格式不正确');
                return
            }

            $http.post("/auth/sms/password", {
                phone: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    Dlg.e(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .controller('MainCtrl', MainCtrl);

    /** @ngInject */
    function MainCtrl($rootScope, $scope, $http, $state, $timeout, $q, dialogs, Dlg, toaster, Api, C,
                      ArrayHelper, Auth, User, FileHelper, Email, SaveAs, UIHelper, Sidebar) {
        var account = Auth.getAccount();
        var vm = $rootScope.main = $scope;

        init();


        function init() {
            $timeout(function () {
                if (!vm.$finishedLoading) vm.$finishedLoading = true;
            }, 500);

            Sidebar.bindState($scope);

            $scope.$on('state.go', function (event, state) {
                $state.go(state.name, {data: {tab: state.tab}});
            });

            // 等待header初始化完成
            $scope.$on('headerLoaded', function () {
                defer.resolve();
            });

            var pusherFnList = {
                'task': taskFn,

                'mail.send': mailSendFn,
                'bulletin.send': bulletinSendFn,
                'file.release': fileReleaseFn,
                'meeting.send': meetingSendFn,
                'mission.send': missionSendFn,
                'news.send': newsSendFn

            };

            angular.forEach(pusherFnList, function (fn, evtName) {
                $scope.$on(C.P + evtName, fn);
            });


            var defer = $q.defer();

            UIHelper.initCKEditor();

            $q.all([
                $http.get('api/v1/main'),
                defer.promise
            ]).then(function (respArray) {
                var resp = respArray[0];
                var data = resp.data;
                var header = $scope.header;
                header.mails = data.mails;
                header.missions = data.missions;
                header.hasTask = data.hasTask;

                account = data.account;

                // 用户已离职
                if (account.leave_time) {
                    Auth.logout(function () {
                        Dlg.notify('检查到登录账户已离职，请使用其他账户登录系统').then(function () {
                            $state.go('login');
                        });
                    });
                }

                // 临时，如果有任务，弹出待处理列表
                // if (header.hasTask) {
                //     $timeout(function () {
                //         header.openTaskD = true;
                //     }, 500);
                // }

                Auth.setAccount(account);
                Auth.setVisitCnt(data.loginCnt, data.apiCnt);
                header.account = vm.account = account;
                checkIfUnConfirmUpdate(account);
            });
        }

        function checkIfUnConfirmUpdate(account) {
            if (account.confirm_state === User.CONFIRM.PENDING) {
                $state.go('user_confirm');
            }
        }

        function mailSendFn(event, data) {
            var mail = data.data.mail;
            if (ArrayHelper.inArray(account.id, mail.recipients) >= 0) {
                Dlg.msg('新邮件', "你有一封新邮件《" + mail.subject + "》,点击查阅", function () {
                    dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                        {size: 'lg'}).result.then(function (params) {
                        switch (params.opt) {
                            case 1:
                                $state.go('app.message_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailReply',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 2:
                                $state.go('app.message_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailForward',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 3:
                                Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                    function () {
                                        $rootScope.$broadcast('mailDel', mail.id);
                                    },
                                    function () {
                                        toaster.error('邮件删除失败!');
                                    }
                                );
                                break;
                        }
                    });
                });
                $rootScope.$broadcast("mail.send", mail);
            }
        }

        function taskFn(event, data) {
            var task = data.data.task;
            if (ArrayHelper.inArray(account.id, task.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: task.task});
            }
        }

        function bulletinSendFn(event, data) {
            var bulletin = data.data.task;
            switch (bulletin.is_pass) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, bulletin.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: bulletin.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    $rootScope.$broadcast("bulletin.send", bulletin);
                    Dlg.msg('新公告', bulletin.dept.name + "发布了新公告《" + bulletin.title + "》,点击查阅", function () {
                        dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                            id: bulletin.id
                        }, {
                            size: 'lg'
                        });
                    });
                    break;
            }
        }

        function newsSendFn(event, data) {
            var news = data.data.task;
            if (news.is_pass === 0 || news.is_pass === 2) {
                if (ArrayHelper.inArray(account.id, news.approvers) >= 0) {
                    $rootScope.$broadcast("newTask", {task: news.task});
                }
            } else if (news.is_pass === 6) {
                $rootScope.$broadcast("news.send", news);
                Dlg.msg('新闻', news.dept + "发布了新闻《" + news.title + "》,点击查阅", function () {
                    dialogs.create('templates/article/show_dlg.html', 'NewsShowDlgCtrl', {
                        id: news.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function meetingSendFn(event, data) {
            var meeting = data.data.task;
            switch (meeting.stage) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, meeting.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: meeting.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    if (ArrayHelper.inArray(account.id, meeting.attendees) >= 0) {
                        $rootScope.$broadcast("meeting.send", meeting);
                        Api.loadMod('meeting', function () {
                            Dlg.msg('新会议', meeting.dept.name + "发布了新会议《" + meeting.name + "》,点击查阅", function () {
                                dialogs.create('pages/dlg/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                                    id: meeting.id
                                }, {
                                    size: 'lg'
                                });
                            });
                        });
                    }
                    break;
            }
        }

        function missionSendFn(event, data) {
            var mission = data.data.task;
            if (ArrayHelper.inArray(account.id, mission.attendees) >= 0) {
                $rootScope.$broadcast("mission.send", mission);
                Dlg.msg('任务通知', '您加入了任务《' + mission.name + "》,点击查阅", function () {
                    dialogs.create('templates/mission/show_dlg.html', 'MissionShowDlgCtrl', {
                        id: mission.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function fileReleaseFn(event, data) {
            var file = data.data.task;
            if (ArrayHelper.inArray(account.id, file.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: file.task});
            } else if (file.state == C.STAGE3.PUBLIC &&
                ((file.release_type == 2 && ArrayHelper.inArray(account.id, file.receivers) >= 0) || file.release_type == 3)) {
                $rootScope.$broadcast("file.release", file);
                Dlg.msg('文件发布', file.dept + "发布了文件《" + file.name + "》,点击下载", function () {
                    var params = {filename: file.filename, mime: file.mime};
                    file.downloading = true;
                    FileHelper.download(C.URL.FILE_CABINET_DOWNLOAD, params, function (resp) {
                        file.downloading = false;
                        var data = [resp];
                        var options = {type: file.mime};
                        SaveAs.download(data, file.name, options);
                    }, function (error) {
                        file.downloading = false;
                        //toaster.error('服务端文件丢失,请联系管理员!');
                    });
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TabCtrl', TabCtrl);

    /** @ngInject */
    function TabCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('WechatAuthCtrl', WechatAuthCtrl);

    /** @ngInject */
    function WechatAuthCtrl($state, $location, $window, Api, Auth, WxHelper) {
        var WECHAT_AUTH_REDIRECT_LOCK_KEY = 'wechat_auth_redirect_lock';
        var WECHAT_AUTH_REDIRECT_TARGET_KEY = 'xzcd_wechat_oauth_redirect_target';
        var WECHAT_AUTH_REDIRECT_TARGET_TTL = 60000;

        // 获取返回参数 code 和 state
        var qs = $location.search();
        var code = qs.code;
        var state = qs.state;

        new Image().src = '/__debug/wechat-auth-ctrl-enter.gif?t=' + new Date().getTime() +
            '&code=' + window.encodeURIComponent(code || '') +
            '&state=' + window.encodeURIComponent(state || '') +
            '&toState=' + window.encodeURIComponent(qs.toState || '');

        // alert('到达WechatAuthCtrl');

        WxHelper.getWechatToken(code, state).then(function (data) {
            // alert('data.result:' + data.result);
            switch (data.result) {
                case 0:
                    Auth.setAutoLogin(true);
                    Auth.setToken(data.token);
                    Auth.setAccount(data.account);
                    var target = getWechatAuthRedirectTarget();
                    clearWechatAuthRedirectState();
                    if (target) {
                        $state.go(target.toState, target.toParams);
                    } else if (qs.toState) {
                        $state.go(qs.toState, qs.toParams ? JSON.parse(qs.toParams) : undefined);
                    } else {
                        $state.go('app.home');
                        // alert('WechatAuthCtrl:go:app.home');
                    }
                    break;
                case 1:
                    clearWechatAuthRedirectState();
                    Api.e(data.msg);
                    break;
                case 2:  //用户未绑定微信
                case 3:
                    clearWechatAuthRedirectState();
                    $state.go('login', {data: {openid: data.openid}});
                    break;
            }
        }, function () {
            clearWechatAuthRedirectState();
        });

        function getWechatAuthRedirectTarget() {
            try {
                var target = JSON.parse($window.localStorage.getItem(WECHAT_AUTH_REDIRECT_TARGET_KEY));
                if (target && target.toState &&
                    new Date().getTime() - target.at < WECHAT_AUTH_REDIRECT_TARGET_TTL) {
                    return target;
                }
            } catch (e) {
            }
            return null;
        }

        function clearWechatAuthRedirectState() {
            try {
                $window.localStorage.removeItem(WECHAT_AUTH_REDIRECT_LOCK_KEY);
                $window.localStorage.removeItem(WECHAT_AUTH_REDIRECT_TARGET_KEY);
            } catch (e) {
            }
        }
    }

})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Api', apiService);

    /** @ngInject */
    function apiService($ocLazyLoad, $compileProvider, toaster, ArrayHelper, Dlg) {
        var service = {

            setStop: setStop,
            /**
             * @deprecated 请用Dlg.delTableItem 替代
             */
            delTableItem: Dlg.delTableItem,
            /**
             * @deprecated 请用Dlg.addEdit 替代
             */
            addEdit: Dlg.addEdit,

            setDisable: setDisable,

            respMsg: respMsg,

            /**
             * @deprecated use Dlg.w instead
             */
            w: Dlg.w,
            /**
             * @deprecated use Dlg.e instead
             */
            e: Dlg.e,
            /**
             * @deprecated use Dlg.s instead
             */
            s: Dlg.s,
            /**
             * @deprecated use Dlg.i instead
             */
            i: Dlg.i,

            /**
             * @deprecated 请用Dlg.exportDR替代
             */
            exportDR: Dlg.exportDR,
            /**
             * @deprecated 请用Dlg.comment替代
             */
            comment: Dlg.comment,

            EDIT: {
                SAVE: 1,
                STOP: 2
            },

            param2Url: param2Url,

            //身份证检查和手机号码检查
            checkId: checkId,
            checkPhone: checkPhone,

            loadQuestionOpt: loadQuestionOpt,

            //数值转化
            numConversion: numConversion,

            loadMod: loadMod
        };

        return service;


        function loadMod(mod, fn) {
            var debugEnabled = $compileProvider.debugInfoEnabled();
            if (debugEnabled) {
                fn();
            } else {
                $ocLazyLoad.load(['/ocLazyLoad/mod/' + mod + '.js',
                    '/ocLazyLoad/mod/' + mod + '.css']).then(fn);
            }
        }

        function respMsg(resp) {
            if (resp.result === 0) {
                Dlg.s(resp.msg);
                return true;
            } else {
                Dlg.error(resp.msg);
                return false;
            }
        }

        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop(s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 利用ApiController新写法时推荐用此方法替代setStop
         * @param s service
         * @param m model
         */
        function setDisable(s, m) {
            s.update({id: m.id}, {op: 'disable', is_stop: !m.is_stop}).$promise.then(function (resp) {
                m.is_stop = !m.is_stop;
            });
        }

        ///////////////////////////////////////

        function param2Url(params) {
            var pairs = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                pairs[pname] = item[subkey];
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        pairs[name] = encodeURIComponent(item);
                    }
                }
            }
            return pairs;
        }

        /////////////////////////////////////

        function checkPhone(phone) {
            var phoneCheck = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
            return phoneCheck.test(phone);
        }

        function checkId(pId) {
            //检查身份证号码
            pId = pId.toUpperCase();
            var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            if (pId.length != 15 && pId.length != 18) return false;
            var Ai = pId.length == 18 ? pId.substring(0, 17) : pId.slice(0, 6) + "19" + pId.slice(6, 16);
            if (!/^\d+$/.test(Ai)) return false;
            var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
            var d = new Date(yyyy, mm, dd), now = new Date();
            var nowdate = now.getFullYear();
            var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
            if (year != yyyy || mon != mm || day != dd || d > now || year < 1800) return false;
            if (nowdate - year < 14) return false;
            for (var i = 0, ret = 0; i < 17; i++) ret += Ai.charAt(i) * Wi[i];
            Ai += arrVerifyCode[ret %= 11];
            return pId.length == 18 && pId == Ai;
        }

        function numConversion(m, array) {
            angular.forEach(array, function (str) {
                m[str] = !m[str] || m[str] === '0' ? '未填' : m[str]
            });
        }


        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        function loadQuestionOpt(vm) {
            vm.upOption = upOption;
            vm.downOption = downOption;
            vm.rmOption = rmOption;
            vm.addOption = addOption;
            vm.optionOnFocus = optionOnFocus;
            vm.correctOptionDesc = correctOptionDesc;
            vm.isMultiSelect = isMultiSelect;
            vm.checkMaxOptions = checkMaxOptions;
        }

        function upOption(question, index) {
            ArrayHelper.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            ArrayHelper.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length === 1) {
                toaster.warning('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (!option.desc.length) {
                option.desc = '选项' + index;
            }
        }

        function isMultiSelect(question) {
            return question.type === 2;
        }

        function checkMaxOptions(question) {
            if (question.type === 2 && question.max_options) {
                if (question.max_options < 1) {
                    toaster.warning('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    toaster.warning('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }

    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('ArrayHelper', ArrayHelper);

    /** @ngInject */
    function ArrayHelper($timeout, $injector) {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            except: except,
            getItem: getItem,
            indexOfKey: indexOfKey,
            idCardIndexOfKey: idCardIndexOfKey,
            findItem: findItem,
            getItems: getItems,
            listKey: listKey,
            get: get,
            swap: swap,
            mergeObj: mergeObj,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            shuffle: shuffle,
            map: map,
            memset: memset,
            filter: filter,
        };

        var l = null;
        $timeout(function () {
            var $http = $injector.get('$http');
            $http.get('json/options.json').success(function (resp) {
                l = resp;
            });
        });

        return service;


        function get(key) {
            return l[key];
        }

        function map(arr, mapFn) {
            var mapArr = [];
            angular.forEach(arr, function (item) {
                mapArr.push(mapFn(item));
            });
            return mapArr;
        }

        function filter(arr, filterFn) {
            var filterArr = [];
            angular.forEach(arr, function (item) {
                if (filterFn(item)) filterArr.push(item);
            });
            return filterArr;
        }

        function memset(arr, val, start, len) {
            if (angular.isUndefined(start)) start = 0;
            if (angular.isUndefined(len)) len = arr.length;

            for (var i = 0; i < len; i++) {
                arr[start + i] = val;
            }
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for (i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 合并对象
         * @param o1
         * @param o2
         * @returns {*}
         */
        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function array2bitwise(a) {
            var b = 0;
            for (var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        /**
         * 位图转数组
         * @param b
         * @param n
         * @returns {Array}
         */
        function bitwise2array(b, n) {
            var a = [];
            for (var i = 0; i < n; i++) {
                a[i] = (b & 1) === 1;
                b >>= 1;
            }
            return a;
        }

        function swap(arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function listKey(items, key) {
            if (typeof (key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof (key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        function findItem(value, items) {
            var i = -1;
            while (++i < items.length) {
                if (items[i] == value)
                    return i;
            }
            return -1;
        }

        function except(exceptId, items) {
            var itemsExp = [];
            angular.forEach(items, function (item) {
                if (exceptId != item.id) {
                    itemsExp.push(item);
                }
            });
            return itemsExp;
        }

        function getItem(value, items, key) {
            if (typeof (key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        function indexOfKey(value, items, key) {
            if (typeof (key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }

        function idCardIndexOfKey(value, items, key) {
            if (typeof (key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value || replaceString(items[i][key], 8, 12, '*') == value)
                    return i;
            }
            return -1;
        }

        function replaceString(str, frontLen, endLen, cha) {
            var len = endLen - frontLen;
            var replaceStr = '';
            for (var i = 0; i < len; i++) {
                replaceStr += cha;
            }
            return str.substring(0, frontLen) + replaceStr + str.substring(endLen, str.length);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Auth', Auth);

    /** @ngInject */
    function Auth($injector, $localStorage, $sessionStorage) {
        var storage;
        var service = {
            CODE: {
                TOKEN_INVALID: 1,
                TOKEN_EXPIRED: 2,
                TOKEN_DEAD: 3,
                LOGIN: 4
            },

            setAccount: setAccount,
            getAccount: getAccount,
            getAutoLogin: getAutoLogin,
            setAutoLogin: setAutoLogin,
            getVisitCnt: getVisitCnt,
            setVisitCnt: setVisitCnt,
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            deleteToken: deleteToken,
            register: register,
            login: login,
            logout: logout,
            refreshToken: refreshToken
            // getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            // getWechatToken: getWechatToken,
            /**
             * 判断是否为微信浏览器
             * @returns {boolean}
             */
        };

        var $http;

        init();

        return service;

        
        function init() {
            storage = getAutoLogin() ? $localStorage : $sessionStorage;
        }

        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        function logout(success) {
            getHttp().post('/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }

        function refreshToken() {
            return getHttp().post('/auth/token/refresh')
        }

        function login(data, successFn, errorFn) {
            getHttp().post('/auth/token/issue', data).success(function (resp) {
                setAutoLogin(data.autoLogin);
                setToken(resp.token);
                setAccount(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function getAutoLogin() {
            return !!$localStorage.autoLogin;
        }

        function setAutoLogin(autoLogin) {
            delete $localStorage.token;
            delete $localStorage.account;
            $localStorage.autoLogin = !!autoLogin;
            storage = autoLogin ? $localStorage : $sessionStorage;
        }

        function register(data, success, error) {
            getHttp().post('/auth/register', data).success(success).error(error);
        }

        function deleteToken(excludeAccount) {
            delete storage.token;
            if (!excludeAccount) delete storage.account;
        }

        function hasToken() {
            return storage.token;
        }

        function getToken() {
            return storage.token;
        }

        function setToken(token) {
            storage.token = token;
        }

        function getVisitCnt() {
            if (storage.loginCnt) {
                return {loginCnt: storage.loginCnt, apiCnt: storage.apiCnt};
            }
            return undefined;
        }

        function setVisitCnt(loginCnt, apiCnt) {
            storage.loginCnt = loginCnt;
            storage.apiCnt = apiCnt;
        }

        function getAccount() {
            return storage.account || {};
        }

        function setAccount(account) {
            storage.account = account;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Checker', Checker);

    /** @ngInject */
    function Checker() {
        var service = {
            checkIp: checkIp
        };

        return service;


        function checkIp(ip) {
            var exp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            return ip.match(exp);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('DateHelper', DateHelper);

    /** @ngInject */
    function DateHelper($filter, uibDateParser, $ocLazyLoad) {
        var service = {
            date2Str: date2Str,
            datetime2Str: datetime2Str,
            str2Date: str2Date,
            str2Datetime: str2Datetime,
            getDaysInMonth: getDaysInMonth,
            diffInDays: diffInDays,
            diffInHours: diffInHours,
            diffInMinutes: diffInMinutes,
            sec2MinSec: sec2MinSec,
            isSameDay: isSameDay,
            toLocalTime: toLocalTime,
            linarCalendar: linarCalendar,
            time2Str: time2Str,
            getDays: getDays,
            str2Time: str2Time
        };

        return service;


        function sec2MinSec(sec) {
            var r = '';
            var m = Math.floor(sec / 60);
            if (m > 0) {
                r += m + '分';
            }
            var s = sec % 60;
            if (s > 0) {
                r += s + '秒';
            }
            return r;
        }

        function linarCalendar(vm, lunarWeekdays, curr) {
            $ocLazyLoad.load({
                files: ["ocLazyLoad/lunarCalendar/lunarCalendar.min.js"]
            }).then(function () {
                vm.lunarCalendars = [];
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        lunarWeekdays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = lunarWeekdays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        lunarWeekdays[i] = now;
                    }
                    var d = lunarWeekdays[i];
                    var c = lunarCalendar.solar2lunar(d.getFullYear(), (d.getMonth() + 1), d.getDate());
                    var cStr = c.IMonthCn + ' ' + c.IDayCn;
                    vm.lunarCalendars.push(cStr);
                }
            });
        }

        function toLocalTime(utcTime) {
            var u = new Date(utcTime);
            var l = u.getTime() - (u.getTimezoneOffset() * 60000);
            l = new Date(l);
            return l;

        }

        function isSameDay(d1, d2) {
            return d1.getFullYear() === d2.getFullYear()
                && d1.getMonth() === d2.getMonth()
                && d1.getDate() === d2.getDate();
        }

        function diffInMinutes(start, end) {
            return Math.floor((end - start) / (1000 * 60));
        }

        function diffInHours(start, end) {
            return ((end - start) / (1000 * 60 * 60)).toFixed(1);
        }

        function diffInDays(start, end) {
            return Math.round((end - start) / (1000 * 60 * 60 * 24));
        }

        function getDaysInMonth(m, y) {
            return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
        }

        function date2Str(date, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return $filter('date')(date, format);
        }

        function datetime2Str(datetime, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return $filter('date')(datetime, format);
        }

        function time2Str(time, format) {
            if (angular.isUndefined(format)) format = 'HH:mm';
            return $filter('date')(time, format);
        }

        function getDays(d) {
            var date = new Date(d.getFullYear(), d.getMonth() + 1, 0);
            return date.getDate();
        }

        function str2Time(str, format) {
            if (angular.isUndefined(format)) format = 'HH:mm:ss';
            return uibDateParser.parse(str, format);
        }

        function str2Date(str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return uibDateParser.parse(str, format);
        }

        function str2Datetime(str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return uibDateParser.parse(str, format);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Dlg', Dlg);

    /** @ngInject */
    function Dlg($q, FormHelper, dialogs, toaster) {
        var service = {
            TP: {  // toast position
                BR: 1,  // bottom right
                TR: 2   // top right
            },
            show: ds,
            notify: dn,
            error: de,
            confirm: dc,

            w: w,
            e: e,
            s: s,
            i: i,

            //
            msg: msg,
            formError: formError,
            delTableItem: delTableItem,
            addEdit: addEdit,
            addEditOk: addEditOk,

            /**
             * @param pa 可填以下参数
             * title: 标题,
             * label: 文本标签, 默认: '理由说明',
             * icon:  font awesome图标, 默认: 'edit',
             * withRate: 是否打星, 默认: 否,
             * notRequired: 文本是否必填, 默认: 否
             * @param fn 回调函数, 参数option:
             * rate: 星级 1-5
             * opinion: 文本内容
             * @returns {*}
             */
            comment: comment,
            exportDR: exportDR,
            setReminder: setReminder,

            loadScrollbar: loadScrollbar,
        };

        return service;


        function addEditOk(vm, service, paFn, args) {
            var m, form, formIdSelector, op;
            if (angular.isDefined(args)) {
                op = args.op;
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.m) m = args.m;
                if (args.form) form = args.form;
            } else {
                op = 'default';
                formIdSelector = '#Form';
            }
            var closeFn = vm.close;
            if (!m) m = vm.m;
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                var promise;
                var pa = paFn();
                if (m.id) { //修改
                    promise = service.update({id: m.id, op: op}, pa).$promise;
                } else { //添加
                    if (!pa.op) pa.op = op;
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) {
                        s(resp.msg);
                    } else {
                        s('保存成功');
                    }
                    if (args && args.closePa) {
                        var closePa = args.closePa;
                        closeFn(closePa instanceof Function ? closePa(resp) : closePa);
                    } else {
                        closeFn(resp);
                    }
                }, function (error) {
                    console.log(error.data);
                    var data = error.data;
                    if (data.msg) de(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                FormHelper.handleError(formIdSelector, form);
                defer.reject();
            }
            return defer.promise;
        }

        /**
         * @deprecated 请使用 dlgri 模板
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem(s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                s.delete({id: id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }

        function addEdit(vm, dlg, dlgCtrl, m, data, dlgSiz, cb) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            return dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function (resp) {
                vm.tableReload();
                if (cb) cb(resp);
            });
        }

        /**
         * @param pa 可填以下参数
         * title: 标题,
         * label: 文本标签, 默认: '理由说明',
         * icon:  font awesome图标, 默认: 'edit',
         * withRate: 是否打星, 默认: 否,
         * notRequired: 文本是否必填, 默认: 否
         * @param fn 回调函数, 参数option:
         * rate: 星级 1-5
         * opinion: 文本内容
         * @returns {*}
         */
        function comment(pa, fn) {
            return dialogs.create('pages/dialogs/comment/commentDlg.html', 'CommentDlgCtrl', pa, {
                size: 'md'
            }, 'vm').result.then(fn);
        }

        function exportDR(urlOrParams, title, start, end, icon) {
            var params = urlOrParams !== null && typeof urlOrParams === 'object' ?
                urlOrParams : {title: title, url: urlOrParams, icon: icon, start: start, end: end};

            return dialogs.create('pages/dialogs/export/dateRangeDlg.html', 'EDRCtrl',
                params, {size: 'md'}, 'vm');
        }

        function setReminder(service, event, users, title, label) {
            return dialogs.create('pages/dialogs/eventReminderDlg.html', 'eventReminderDlgCtrl',
                {service: service, event: event, title: title, users: users, label: label},
                {size: 'md'}, 'vm');
        }

        function loadScrollbar(vm) {
            if (window.innerWidth < 568) {
                vm.bodyStyle = {
                    'min-height': window.innerHeight - 200,
                    width: window.innerWidth - 40
                };
            } else {
                vm.bodyStyle = {
                    height: 480
                };
            }
        }


        function msg(title, body, hideFn, noSound) {
            toaster.pop({
                title: title, body: body, bodyOutputType: 'trustedHtml', toasterId: 1,
                clickHandler: function (toast, isCloseButton) {
                    if (!isCloseButton && !angular.isUndefined(hideFn)) {
                        hideFn();
                    }
                    return true;
                },
                onShowCallback: function () {
                    if (!noSound) {
                        document.getElementById('msgTone1').play();
                    }
                }
            });
        }

        function formError() {
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
        }

        function w(msg, id) {
            toaster.warning({title: msg, toasterId: id});
        }

        function e(msg, id) {
            toaster.error({title: msg, toasterId: id});
        }

        function s(msg, id) {
            toaster.success({title: msg, toasterId: id});
        }

        function i(msg, id) {
            toaster.info({title: msg, toasterId: id});
        }

        /**
         * 显示对话框
         * @param pa： backdrop: true(非模态) false(无背景) 'static'(默认，模态)
         * @returns {*}
         */
        function ds(pa) {
            var options = {};
            if (pa.name) {
                pa.ctrl = pa.name + 'Ctrl';
                if (!pa.template) pa.template = pa.name;
            }
            if (!pa.data) pa.data = {};
            if (!pa.size) options.size = 'md';
            else options.size = pa.size;
            if (pa.backdrop) options.backdrop = pa.backdrop;
            switch (pa.pos) {
                case 'right':  // 目前仅支持right
                    options.windowClass = 'modal-right';
                    options.backdropClass = 'modal-backdrop-light';
            }
            if (pa.size === 'full') options.windowClass += ' modal-full';
            return dialogs.create(pa.template, pa.ctrl, pa.data, options, 'vm').result;
        }

        function dn(msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.notify(title, msg).result;
        }

        function de(msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            return dialogs.error(title, msg).result;
        }

        function dc(msg, cb, title, error) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.confirm(title, msg).result.then(cb, error);
        }


    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('FileHelper', fileService);

    /** @ngInject */
    function fileService($q, $http, ArrayHelper, Upload, SaveAs, dialogs, toaster) {
        var service = {
            urls: {
                UPLOAD: '/api/v1/file/attachments/upload_single',
                IMG_UPLOAD: '/api/v1/file/images/upload',
            },

            uploadSingle: uploadSingle,
            uploadAttachment: uploadAttachment,
            uploadCroppedImage: uploadCroppedImage,

            isAttachmentsUploaded: isAttachmentsUploaded,
            loadAttachmentParams: loadAttachmentParams,
            upload: upload,
            upload1: upload1,

            dnExcel: dnExcel,
            download: download,
            download1: download1,

            getPublicLink: getPublicLink
        };

        return service;


        function getPublicLink(filename) {
            return $http.post('api/v1/file/preview/mk_pub_link', {filename: filename});
        }

        function download(url, data, success, error) {
            $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(success).error(error);
        }

        function dnExcel(url, params, filename, cb) {
            return $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                SaveAs.download(data, filename, options);
                if (cb) cb();
            });
        }

        /**
         * 上传裁剪后的图片
         * @param image image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();

            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (image.inProgress) {
                defer.reject("正在上传，请稍后再试");
            } else {
                if (!file.$error) {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: {file: file}
                    }).progress(function (evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (resp) {
                        defer.resolve(resp.url);
                    }).error(function () {
                        defer.reject("服务器错误");
                    }).finally(function () {
                        image.inProgress = false;
                    });
                } else {
                    defer.reject("图片不能大于20M");
                }
            }
            return defer.promise;
        }

        function uploadAttachment(file, data, e, extra) {
            service.upload(service.urls.UPLOAD, file, data, e, extra);
        }

        function uploadSingle(file, data, e, rename, extra) {
            return service.upload1(service.urls.UPLOAD, file, data, e, rename, extra);
        }

        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }


        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param data
         * @param e
         * @param extra
         */
        function upload(url, file, data, e, extra) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file === null) return;

            var attachment = {name: file.name, progress: 0};
            data.attachments.push(attachment);
            var pa = {
                url: url, file: file
            };

            if (extra) pa.data = {extra: extra};

            var defer = $q.defer();
            Upload.upload(pa).progress(function (evt) {
                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        attachment.name = resp.name;
                        attachment.mime = resp.mime;
                        attachment.filename = resp.filename;
                        attachment.size = resp.size;
                        defer.resolve(attachment);
                        break;
                    case 1:
                        attachment.progress = 101;
                        attachment.errorInfo = '服务器空间不足!';
                        defer.reject();
                        break;
                }
            }).error(function () {
                defer.reject();
                attachment.progress = 102;
                attachment.errorInfo = '服务器错误!';
            });

            return defer.promise;
        }

        /**
         * @deprecated
         * 用于单个附件上传
         * @param url
         * @param file
         * @param data 附件依附对象，其各字段标准为attach_name（附件名称），mime，filename（服务器路径），size
         * @param e
         * @param rename
         * @param extra 额外参数
         */
        function upload1(url, file, data, e, rename, extra) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (!file) return;

            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';

            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                mergeObj(pa, extra);
            }
            delete data[rename.filename];

            var defer = $q.defer();
            Upload.upload({
                url: url, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        defer.resolve(data);
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        defer.reject();
                        break;
                }
            }).error(function () {
                defer.reject();
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });

            return defer.promise;
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param data
         * @param attachmentField
         * @returns {boolean}
         */
        function isAttachmentsUploaded(data, attachmentField) {
            if (angular.isUndefined(attachmentField)) attachmentField = 'attachments';
            for (var i = 0; i < data[attachmentField].length; i++) {
                if (!data[attachmentField][i].filename) {
                    return false;
                }
            }
            return true;
        }

        function loadAttachmentParams(pa, m) {
            pa.attachments = ArrayHelper.map(m.attachments, function (attachment) {
                return attachment.id ? {id: attachment.id} : {
                    name: attachment.name, mime: attachment.mime,
                    filename: attachment.filename, size: attachment.size
                };
            });
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param data 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download1(url, data, rename) {


            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = {name: data[rename.name], filename: data[rename.filename], mime: data[rename.mime]};
            data.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                SaveAs.download([resp], data[rename.name], {type: data[rename.mime]});
            }).error(function (error) {
                toaster.error('文件丢失');
            }).finally(function () {
                data.downloading = false;
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Float', Float);

    /** @ngInject */
    function Float() {
        var service = {
            toFixed: toFixed
        };

        return service;


        function toFixed(floatNum, decimal) {
            if (angular.isUndefined(decimal)) decimal = 2;
            return parseFloat(floatNum.toFixed(decimal));
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('FormHelper', FormHelper);

    /** @ngInject */
    function FormHelper($q, $timeout, $location, $anchorScroll, toaster) {
        var service = {
            handleError: handleError,
            handleSubmit: handleSubmit,
            deleteAttachment: deleteAttachment
        };

        return service;


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function handleSubmit(vm, cb, args) {
            var form, formIdSelector, skipTip = false;
            if (angular.isDefined(args)) {
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.form) form = args.form;
                skipTip = args.skipTip;
            } else {
                formIdSelector = '#Form';
            }
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                if (cb) cb(defer);
            } else {
                if (skipTip) {
                    form.$submitted = true;
                } else {
                    service.handleError(formIdSelector, form);
                }
                defer.reject();
            }
            return defer.promise;
        }


        function handleError(formIdSelector, form) {
            $timeout(function () {
                var firstInvalid = angular.element(formIdSelector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            form.$submitted = true;
        }
    }
})();

/**
 * @deprecated 1.模块相关的服务应当放在模块的服务中，而不是这里；
 * 2.不同功能的公共方法应该按功能分类，而不是统一放在这里，
 * 所以F服务从此废弃，不要在往里面放东西了，也尽量不要再用它了。
 */
angular.module('c')
    .factory('F', function (ArrayHelper, Table, UIHelper, uibDateParser) {
        return {
            /**
             * @deprecated ArrayHelper.inArray 替代
             */
            inArray: ArrayHelper.inArray,
            /**
             * @deprecated ArrayHelper.indexOf 替代
             */
            indexOf: ArrayHelper.inArray,
            /**
             * @deprecated UIHelper.getIconFromMime 替代
             */
            getIconFromMime: UIHelper.getIconFromMime,
            /**
             * @deprecated Table.getNgTableOpts 替代
             */
            getNgTableOpts: Table.getNgTableOpts,
            /**
             * @deprecated ArrayHelper.except 替代
             */
            except: ArrayHelper.except,
            /**
             * @deprecated 使用Array.getItem替代
             */
            getItem: ArrayHelper.getItem,
            /**
             * @deprecated 使用Array.indexOfKey 替代
             */
            indexOfKey: ArrayHelper.indexOfKey,
            /**
             * @deprecated 使用Array.findItem 替代
             */
            findItem: ArrayHelper.findItem,
            /**
             * @deprecated 使用Array.getItems 替代
             */
            getItems: ArrayHelper.getItems,
            /**
             * @deprecated 使用Array.listKey 替代
             */
            listKey: ArrayHelper.listKey,
            /**
             * @deprecated 使用Array.get 替代
             */
            get: ArrayHelper.get,
            /**
             * @deprecated
             * 公告审批阶段列表
             * @returns {*[]}
             */
            getApprovalStages1: function (appendOverStage) {
                var states = ArrayHelper.get('approval_stages1');
                if (appendOverStage) {
                    var arr = angular.copy(states);
                    arr.push({id: '5', name: '已结束'});
                    return arr;
                }
                return states;
            },
            /**
             * @deprecated 使用 UIHelper.getProgressType 替代
             */
            getProgressType: UIHelper.getProgressType,
            /**
             * @deprecated 使用 UIHelper.loadTabs 替代
             */
            loadTabs: UIHelper.loadTabs,
            /**
             * @deprecated 使用  UIHelper.loadTab 替代
             */
            loadTab: UIHelper.loadTab,
            bitwise2array: ArrayHelper.bitwise2array,
            array2bitwise: ArrayHelper.array2bitwise,
            checkTime: function (dateTime, beginTime, endTime) {
                var bd = uibDateParser.parse(beginTime, 'HH:mm');
                var ed = uibDateParser.parse(endTime, 'HH:mm');
                var nd = uibDateParser.parse(dateTime, 'HH:mm');
                if (bd > ed && nd > bd) {
                    var edNew = ed.getTime() + 24 * 60 * 60 * 1000;
                    ed = new Date(edNew);
                }
                if (bd > ed && nd < ed) {
                    var bdNew = bd.getTime() - 24 * 60 * 60 * 1000;
                    bd = new Date(bdNew);
                }
                return nd > bd && nd < ed;
            },
            toFixed: function (floatNum, decimal) {
                if (angular.isUndefined(decimal)) decimal = 2;
                return parseFloat(floatNum.toFixed(decimal));
            },
            getParent: function getParent(type) {
                if (type.parent) {
                    return getParent(type.parent);
                }
                return type;
            }
        };
    });


/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('PrintHelper', Print);

    /** @ngInject */
    function Print($timeout, $templateRequest, $sce, SaveAs, $ocLazyLoad) {
        var service = {
            print: print,
            printAsWord: printAsWord,
            STYLE: {
                TEMP2: 'templates/print/table2.html'
            }
        };

        return service;


        function printAsWord(name, styleFile, createBody) {
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                    html += createBody();
                    html += '</body></html>';
                    $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                        var converted = htmlDocx.asBlob(html + printStyle);
                        SaveAs.download(converted, name + '.docx');
                    });
                });
            } else {
                var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                    var converted = htmlDocx.asBlob(html);
                    SaveAs.download(converted, name + '.docx');
                });
            }
        }

        /**
         * @param w, 已打开窗口
         * @param styleFileOrCB
         * @param createBody:function, 创建<body>元素内的html并返回
         */
        function print(w, styleFileOrCB, createBody) {
            if (typeof styleFileOrCB === "function") {
                createBody = styleFileOrCB;
                styleFileOrCB = service.STYLE.TEMP2;
            }

            if (styleFileOrCB) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFileOrCB, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<html><body>';
                    html += createBody();
                    html += '</body></html>';
                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                });
            } else {
                var html = '<html><body>';
                html += createBody();
                html += '</body></html>';
                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('Table', TableHelper);

    /** @ngInject */
    function TableHelper (NgTableParams, $filter, Dlg) {
        return {
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 208,

            _1_CHAR: 48,
            _2_CHAR: 72,
            _3_CHAR: 96,
            _4_CHAR: 128,
            _5_CHAR: 170,
            _6_CHAR: 300,

            loadMultiSelectedFn: loadMultiSelectedFn,
            getTableData: getTableData,
            /**
             * 方便ngTable获取数据
             * @param service 服务名称
             * @param url 参数
             * @param $defer ngTable的参数
             * @param params ngTable的参数
             * @param items 获取的主要数据项，字符串
             * @param cb 回调函数，可选
             */
            query: queryItems,

            /**
             * @deprecated
             * 加载ngTable
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，justDataCol：是否只显示数据列
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）, dateFilters：日期范围过滤器数组,
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             * @param cb 回调函数
             */
            loadNgTable: loadNgTable
            ,
            /**
             * 加载ngtable，后台分页
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
             *  cbWidth: 多选列表中checkbox列宽度
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             *  primaryFilter: 如果filter中该过滤项为空，则返回暂无数据
             * @param cb 回调函数
             */
            load: loadTable,
            loadItem: loadItem,
            loadTableCols: loadTableCols,
            getNgTableOpts: getNgTableOpts
        };

        function loadItem(resp, startSn, cb) {
            angular.forEach(resp.items, function (item, i) {
                item.sn = startSn + i + 1;
                if (cb) cb(item, i);
            });
        }

        function loadTableCols(service, params) {
            var cols = [];
            var serviceCols = service.getCols();
            angular.forEach(params, function (param) {
                cols.push(serviceCols[param]);
            });
            return cols;
        }

        function getNgTableOpts(items, firstRow) {
            var data = [angular.isDefined(firstRow) ? {id: firstRow[0], title: firstRow[1]} : {id: '', title: '-'}];
            angular.forEach(items, function (item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        function loadMultiSelectedFn(scope) {
            scope.header = {checkAll: false};
            scope.checkOneFn = function (item, items) {
                if (item.is_checked) {
                    scope.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        scope.header.checkAll = false;
                    }
                }
            };
            scope.checkAllFn = function (checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function (item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function () {
                    return scope.header.checkAll;
                },
                clearChecked: function (items) {
                    scope.header.checkAll = false;
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    });
                },
                getCheckedIds: function (items) {
                    var ids = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function (items, fields) {
                    var checked = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }

        function getTableData(data, $defer, params, $filter) {
            if ($filter) {
                data = params.filter() ?
                    $filter('filter')(data, params.filter()) :
                    data;
                data = params.sorting() ?
                    $filter('orderBy')(data, params.orderBy()) : data;
            }
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() === 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        function loadTable(scope, options, cb) {
            var filters = options.filter ? options.filter : {};
            options.filterDelay = options.filter ? 0 : 750;
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
                if (typeof col.width === 'number') {
                    col.widthStyle = {'min-width': col.width + 'px'};
                }
            });
            scope.optColWidth = options.optColWidth;
            if (options.optColWidth) scope.optColStyle = {'min-width': options.optColWidth + 'px'};
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.showSn = options.showSn;
            scope.optInFront = options.optInFront;
            scope.cbWidth = options.cbWidth ? options.cbWidth : 62;
            scope.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {id: 'desc'},
                filter: filters
            }, {
                filterDelay: options.filterDelay,
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function ($defer, params) {
                    if ((options.primaryParam && !options.params[options.primaryParam]) || (
                            options.primaryFilter && !params.filter()[options.primaryFilter]
                        )) {
                        //return $defer.resolve([]);
                    } else {
                        if (options.filterDelay === 0) {
                            options.filterDelay = 750;
                            scope.tableParams.settings({filterDelay: options.filterDelay});
                        }
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function loadNgTable (scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            if (options.dateFilters) {
                scope.dateRangeFilter = {};
                scope.$watch('dateRangeFilter',
                    function () {
                        scope.tableParams.reload();
                    }, true
                );
            }
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.justDataCol = options.justDataCol;
            scope.tableParams = new NgTableParams({
                page: 1, count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                        created_at: 'desc'
                    }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        if (options.dateFilters != null && options.dateFilters.length > 0) {
                            angular.forEach(options.dateFilters, function (d) {
                                if (scope.dateRangeFilter[d.name] != null) {
                                    var start = d.start;
                                    var end = d.end;
                                    if (!start) start = 'startDate';
                                    if (!end) end = 'endDate';
                                    url[start] = $filter('date')(scope.dateRangeFilter[d.name][start], 'yyyy-MM-dd');
                                    url[end] = $filter('date')(scope.dateRangeFilter[d.name][end], 'yyyy-MM-dd');
                                }
                            });
                        }
                        queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
                if (options.dateFilters) {
                    scope.dateRangeFilter = {};
                }
            };

            scope.clearReload = function () {
                if (angular.equals(scope.tableParams.filter(), {}) &&
                    (!scope.dateRangeFilter || angular.equals(scope.dateRangeFilter, {}))) {
                    scope.tableReload();
                } else {
                    scope.clearFilters();
                }
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function queryItems(service, url, $defer, params, items, cb) {
            if (items === null || items === undefined) {
                items = 'items';
            }
            service.query(url).$promise.then(function (data) {
                if (data.total > 0 && data[items].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data[items]);
                }
            }, function (err) {
                if (err.data.msg) Dlg.error(err.data.msg);
                $defer.resolve();
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c')
        .factory('UIHelper', UIHelper)
        .controller('UploadWordImagesDlg', UploadWordImagesDlg)

    ;

    /** @ngInject */
    function UIHelper(ArrayHelper, $state, $rootScope, $location, deviceDetector, OS, Upload, dialogs) {
        var curExtraParam = null;
        var service = {
            getIconFromMime: getIconFromMime,
            getProgressType: getProgressType,
            isTooDark: isTooDark,
            scrollTo: scrollTo,

            tabTo: tabTo,
            loadTabs: loadTabs,
            loadTab: loadTab,
            hasTabExtra: hasTabExtra,
            getTabExtra: getTabExtra,

            onCKReady: onCKReady,
            initCKEditor: initCKEditor
        };

        return service;

        function setResponsive(el) {
            if (el.children && el.children.length > 0) {
                angular.forEach(el.children, function (child) {
                    setResponsive(child);
                });
            } else {
                if (el.name !== 'img') return;
                el.addClass('img-responsive');
            }
        }

        function initCKEditor() {
            // 响应式
            CKEDITOR.on('instanceReady', function (ev) {
                ev.editor.dataProcessor.htmlFilter.addRules({
                    elements: {
                        $: setResponsive
                    }
                });
            });
        }

        function onCKReady(editor) {
            editor = CKEDITOR.instances[editor];
            if (!editor) return;

            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function (evt) {
                    // 解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function (img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (ArrayHelper.indexOfKey(img.src, localImgList, 'src') === -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state === 1) {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os === OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function (name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('templates/upload/word_images_dlg.html', 'UploadWordImagesDlg', {
                            files: files
                        }, {
                            size: 'md'
                        }).result.then(function (result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for (i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name === 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                            editor.fire('change');
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function (evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                file.name = loader.file.name;
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function (evt) {
                    if (!loader.uploadTotal) loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function (resp) {
                    loader.responseData = resp;
                    if (resp.error && resp.error.message) {
                        loader.message = resp.error.message;
                    }
                    if (resp.result === 1) { // 错误
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        loader.url = resp.url;
                        loader.fileName = resp.fileName;
                        loader.changeStatus('uploaded');
                        editor.fire('change');
                    }
                }).error(function () {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        // for ui bootstrap 1.3.3
        function loadTabs($scope, $stateParams) {
            var vm = $scope;
            vm.curTab = $stateParams.tab;
            curExtraParam = $stateParams.data.extra;
            vm.tabSelected = tabSelected;

            $scope.$on('tabChange', function (event, pa) {
                var tab = pa.tab;
                curExtraParam = pa.extra;

                // 如果当前标签页正好是审批提醒跳转标签页,则直接发广播,触发刷新;否则改变标签页,通过tabSelected触发刷新
                if (vm.curTab === tab) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                } else {
                    vm.curTab = tab;
                }
            });

            /**
             * 记录选择的标签页，并触发该页面的重新加载事件
             * <strong>注意：这个函数必须应用的标签页上</strong>
             * @param tab
             * @param skipReloadContent 不触发标签内容更新
             */
            function tabSelected(tab, skipReloadContent) {
                $location.search('tab', tab);
                if (!skipReloadContent) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                }
            }
        }

        function loadTab($scope, tab, reloadFn) {
            var vm = $scope;
            $scope.$on("reload", function (event, data) {
                var tabTo = data.tab;
                if (tabTo === tab) {
                    if (reloadFn) {
                        if (reloadFn(data.extra)) curExtraParam = null;
                    } else {
                        vm.tableReload();
                    }
                }
            });
        }

        function hasTabExtra() {
            return curExtraParam !== null && typeof curExtraParam !== 'undefined'
                && !angular.equals(curExtraParam, {});
        }

        function getTabExtra() {
            return curExtraParam;
        }

        function tabTo(tab, extra, state) {
            if (state) {
                $state.go(state, {tab: tab, data: {extra: extra}});
            } else {
                $rootScope.$broadcast('tabChange', {tab: tab, extra: extra});
            }
        }

        function scrollTo(toElemId, scrollableBodyId, offset, duration) {
            if (angular.isUndefined(scrollableBodyId)) scrollableBodyId = '.modal-body';
            else scrollableBodyId = '#' + scrollableBodyId;
            if (angular.isUndefined(offset)) offset = 0;
            if (angular.isUndefined(duration)) duration = 200;
            var scrollableBody = angular.element(scrollableBodyId)[0];
            var toElemOffset = angular.isUndefined(toElemId) ? 0 :
                angular.element('#' + toElemId)[0].offsetTop;

            var currentTime = 0;
            var increment = 2;
            var from = scrollableBody.scrollTop;
            var to = toElemOffset - offset;
            var change = to - from;

            function __scrollTo() {
                currentTime += increment;
                scrollableBody.scrollTop = __easeInOutQuad(currentTime, from, change, duration);
                if (currentTime < duration) {
                    setTimeout(__scrollTo, increment)
                }
            }

            __scrollTo();
        }

        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        function __easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function isTooDark(color, limit) {
            if (angular.isUndefined(limit)) {
                limit = 128;
            }
            var c = color.substring(1);      // strip #
            var rgb = parseInt(c, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue

            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < limit) {
                return true;
            }
            return false;
        }

        function getIconFromMime(mime) {
            var mime2Ico = ArrayHelper.get('mime2Ico');
            var app2Ico = ArrayHelper.get('app2Ico');

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function getProgressType(index) {
            var progressTypes = ArrayHelper.get('progressTypes');
            return progressTypes[index % progressTypes.length];
        }
    }

    /** @ngInject */
    function UploadWordImagesDlg($scope, $uibModalInstance, clipboard, Upload,
                                 deviceDetector, OS, OS_VERSIONS, C, dialogs, data) {

        var canOpenMultiFile = false;
        //多个文件同时上传受到windows文件打开窗口文件路径输入框可接受字符串长度限制，现在暂时都按照逐一打开文件处理
        //if (deviceDetector.os == OS.WINDOWS) {
        //    canOpenMultiFile = [
        //        OS_VERSIONS.WINDOWS_VISTA,
        //        OS_VERSIONS.WINDOWS_7,
        //        OS_VERSIONS.WINDOWS_8_1,
        //        OS_VERSIONS.WINDOWS_8,
        //        OS_VERSIONS.WINDOWS_10
        //    ].some(function (item) {
        //            return deviceDetector.os_version == item;
        //        });
        //}
        $scope.canOpenMultiFile = canOpenMultiFile;
        var paths = '';
        if (canOpenMultiFile) {
            angular.forEach(data.files, function (file) {
                paths += '"' + file.path + '" ';
            });
        } else {
            $scope.files2Upload = data.files;
        }

        $scope.getDataFromClipboard = function (path) {
            if (path) {
                clipboard.copyText(path);
            } else {
                clipboard.copyText(paths);
            }
        };

        var result = [];
        $scope.uploadFile = function ($file, file, e) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (!$file) return;

            Upload.upload({
                url: C.URL.IMG_UPLOAD, file: $file
            }).progress(function (evt) {
                file.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        file.progress = 0;
                        file.fileName = resp.fileName;
                        result[file.name] = resp.url;
                        break;
                    case 1:
                        file.progress = 101;
                        file.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                file.progress = 102;
                file.errorInfo = '服务器错误!';
            });
        };

        //$scope.uploadFiles = function (files, e) {
        //    $scope.filesUploaded = files;
        //    if (e && e[0] && e[0].$error == 'maxSize') {
        //        dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
        //        return;
        //    }
        //
        //    if (files == null) {
        //        return;
        //    }
        //
        //    var count = 0;
        //    angular.forEach(files, function (file) {
        //        Upload.upload({
        //            url: C.URL.IMG_UPLOAD, file: file
        //        }).progress(function (evt) {
        //            file.progress = parseInt(100.0 * evt.loaded / evt.total);
        //        }).success(function (resp) {
        //            switch (resp.result) {
        //                case 0:
        //                    file.progress = 0;
        //                    result[file.name] = resp.url;
        //                    break;
        //                case 1:
        //                    file.progress = 101;
        //                    file.errorInfo = '服务器空间不足!';
        //                    break;
        //            }
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        }).error(function () {
        //            file.progress = 102;
        //            file.errorInfo = '服务器错误!';
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        });
        //    });
        //};

        $scope.ok = function () {
            $uibModalInstance.close(result);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c').factory('WxHelper', WxHelper);

    /** @ngInject */
    function WxHelper($q, $injector, $location) {
        var service = {
            getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            getWechatToken: getWechatToken,
            isWechatBrowser: isWechatBrowser,
            API_AUTH_LOGIN: '/api/wx/get_wechat_token',
            WX_API_ID: 'wx8b1cfeb176037b52',    // 云慈
            // WX_API_ID: 'wxd5f73f77dc8d5850', // 测试号
            WX_AUTH_REDIRECT_URL: 'https://oa.tcd100.cn/get_wechat_token',
            // WX_AUTH_REDIRECT_URL: 'http://cbfy.tunnel.qydev.com/get_wechat_token',
            loadWxnp: loadWxnp
        };

        var $http;


        return service;


        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        // load wx notice page
        function loadWxnp(cb) {
            var urlParams = $location.search();
            if (urlParams.wxnpId) {
                var id = urlParams.wxnpId;
                var type = urlParams.wxnpType;
                var state = urlParams.wxnpState;
                cb(id, type, state);
                $location.search('wxnpId', null);
                $location.search('wxnpType', null);
                $location.search('wxnpState', null);
            }
        }

        /**
         * 判断是否为微信浏览器
         * @returns {boolean}
         */
        function isWechatBrowser() {
            var ua = navigator.userAgent.toLowerCase();
            // 注意： 请保留双等号
            return ua.match(/MicroMessenger/i) == "micromessenger";
        }

        function getWechatToken(code, state) {
            var deferred = $q.defer();
            // 构造 url
            var url = service.API_AUTH_LOGIN + "?code=" + code + "&state=" + state;
            // 发送 get
            getHttp().get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getWechatAuthorizeUrl(toState, toParams) {
            var appId = service.WX_API_ID,
                rUrl = service.WX_AUTH_REDIRECT_URL;

            if (toState) {
                rUrl += "?toState=" + toState.name;
                if (toParams) rUrl += "&toParams=" + JSON.stringify(toParams);
            }

            rUrl = window.encodeURIComponent(rUrl);

            var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
                + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            return url;
        }

    }
})();

(function () {
    'use strict';


    angular.module('c')
        .factory('EventReminder', EventReminder);

    /** @ngInject */
    function EventReminder($http) {
        var API = '/api/v1/shared/event_reminders';
        return {
            getInstance: function (mod, events) {
                return angular.extend(events, {
                    get: function (event) {
                        return $http.get(API + '/' + mod, {params: {event: event}});
                    },
                    set: function (event, reminder) {
                        return $http.put(API + '/' + mod, {event: event, user_id: reminder});
                    },
                    mod: mod
                })
            }
        };
    }

})();

(function () {
    'use strict';


    angular.module('c')
        .factory('PdfDoc', PdfDoc);

    /** @ngInject */
    function PdfDoc($resource, serviceConfObj) {
        var API = 'api/v1/shared/pdf_docs';
        return {
            getInstance: function (mod, extend) {
                var r = $resource(API + '/' + mod + '/:id', {}, serviceConfObj);
                if (extend) r = angular.extend(extend, r);
                return r;
            }
        };
    }

})();

(function(){
    var elif = angular.module('elif', []);

    var CONDITIONALS = 'elif.conditionals';

    // This is copied from AngularJS because it is not
    // part of the public interface.
    var getBlockElements = function(nodes){
        if(!nodes || !nodes.length){
            return angular.element();
        }

        var startNode = nodes[0];
        var endNode = nodes[nodes.length - 1];

        if(startNode === endNode){
            return angular.element(startNode);
        }

        var element = startNode;
        var elements = [element];

        do {
            element = element.nextSibling;
            if(!element){
                break;
            }
            elements.push(element);
        }
        while(element !== endNode);

        return angular.element(elements);
    };

    elif.factory('elif', [
        function(){
            // By requiring the scope have it's own copy of `elif.conditionals`
            // we avoid if/else-if/else structures that span AngularJS scopes.
            var getConditionals = function(scope){
                if(angular.hasOwnProperty.call(scope, CONDITIONALS)){
                    var conditionals = scope[CONDITIONALS];
                    return conditionals[conditionals.length - 1];
                }
            };

            return {
                create: function(scope, fn, callback){
                    var conditionals = [{
                        fn: fn,
                        callback: callback || angular.identity
                    }];
                    var conditionalValues = [];

                    scope.$watch(function(){
                        // Watch the boolean conditionals; we only need
                        // to run through the if/else-if/else chain if one
                        // of them changes.  We can also take the chance to
                        // short-circuit when we've found our first true
                        // condition.
                        var i;
                        var len = conditionals.length;
                        conditionalValues.length = len;
                        for(i = 0; i < len; i++){
                            if((conditionalValues[i] = !!conditionals[i].fn())){
                                i++;
                                break;
                            }
                        }
                        for(; i < len; i++){
                            conditionalValues[i] = false;
                        }
                        return conditionalValues;
                    }, function(conditionalValues){

                        // Update each block; also find first matching if/else-if.
                        var index = -1;
                        for(var i = 0, len = conditionals.length; i < len; i++){
                            if(conditionalValues[i]){
                                conditionals[i].callback(true);
                                index = i;
                            }
                            else {
                                conditionals[i].callback(false);
                            }
                        }

                        // Handle else, if there is one.
                        conditionals.fallthrough && conditionals.fallthrough(index === -1);

                    }, true); // Deep watch; we know that it is a simple list of booleans.

                    // Keep track of if/else-if/else structures per AngularJS scope.
                    if(!angular.hasOwnProperty.call(scope, CONDITIONALS)){
                        scope[CONDITIONALS] = [];
                    }
                    scope[CONDITIONALS].push(conditionals);
                },
                extend: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.extend: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.extend: else-if after else');
                    }

                    conditionals.push({
                        fn: fn,
                        callback: callback
                    });
                },
                fallthrough: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.fallthrough: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.fallthrough: else already found at this level');
                    }
                    conditionals.fallthrough = callback;
                }
            };
        }
    ]);

    // This implementation is basically the built-in `ng-if`, hooked into the `elif` service.
    var elifDirective = function(name, method, getter){
        elif.directive(name, [
            '$animate',
            '$document',
            '$injector',
            'elif',
            function($animate, $document, $injector, elif){
                var getterFn = getter && $injector.invoke(getter);

                return {
                    transclude: 'element',
                    restrict: 'A',
                    priority: 600,
                    terminal: true,
                    link: function(scope, element, attrs, ctrls, transcludeFn){
                        var watchFn = getterFn && getterFn(scope, element, attrs);
                        var childScope;
                        var childElement;
                        var previousElements;

                        elif[method](scope, watchFn, function(value){
                            if(value){
                                if(!childScope){
                                    childScope = scope.$new();
                                    transcludeFn(childScope, function(clone){
                                        clone[clone.length + 1] = $document[0].createComment(' end ' + name + ': ' + attrs[name] + ' ');
                                        childElement = clone;
                                        $animate.enter(clone, element.parent(), element);
                                    });
                                }
                            }
                            else {
                                if(childScope){
                                    childScope.$destroy();
                                    childScope = null;
                                }
                                if(previousElements){
                                    previousElements.remove();
                                    previousElements = null;
                                }
                                if(childElement){
                                    previousElements = getBlockElements(childElement);
                                    $animate.leave(previousElements, function(){
                                        previousElements = null;
                                    });
                                    childElement = null;
                                }
                            }
                        });
                    }
                };
            }
        ]);
    };

    // Reads the attribute given by `name` and converts it to a boolean.
    var getter = function(name){
        return [
            '$parse',
            function($parse){
                return function(scope, element, attrs){
                    var testFn = $parse(attrs[name]);
                    return function(){
                        return !!testFn(scope);
                    };
                };
            }
        ];
    };

    // We rely on the built-in `ng-if` directive to actually perform
    // the transclusion, and simply tie it in to the `elif` service.
    elif.directive('ngIf', [
        '$injector',
        'elif',
        function($injector, elif){
            var getterFn = $injector.invoke(getter('ngIf'));
            return {
                priority: 600,
                link: function(scope, element, attrs){
                    var watchFn = getterFn(scope, element, attrs);
                    elif.create(scope, watchFn);
                }
            }
        }
    ]);

    // Else-if and else perform their own transclusions.
    elifDirective('ngElseIf', 'extend', getter('ngElseIf'));
    elifDirective('ngElif', 'extend', getter('ngElif'));

    // Else doesn't take an argument.
    elifDirective('ngElse', 'fallthrough');
})();
angular.module('c')
    .directive('compareTo', function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('editor', editor);

    // https://github.com/wayou/wayou.github.io/issues/5
    var ckSimpleConfig = {
        height: 120,
        toolbarGroups: [
            {name: 'basicstyles', groups: ['basicstyles']},
            {name: 'paragraph', groups: ['list', 'align']},
            {name: 'styles', groups: ['styles', 'colors']},
            {name: 'insert', groups: ['insert']},
            // {name: 'tools', groups: ['tools']}
        ],
        removeButtons: 'Subscript,Superscript,Styles,Format,JustifyBlock,ShowBlocks,' +
            'Flash,HorizontalRule,Smiley,PageBreak,Iframe,Table'
    };

    /** @ngInject */
    function editor($compile, UIHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                height: '=height'
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'editor' + (new Date()).getTime() + (Math.floor(Math.random() * 100000));
                        var ngModelCtrl = r[0], formCtrl = r[1];
                        var vm = scope;
                        vm.onReady = UIHelper.onCKReady;


                        init();


                        function init() {
                            // scope.$on('$destroy', function () {
                            //     var editor = CKEDITOR.instances[id];
                            //     if (editor) editor.destroy();
                            // });

                            scope.$watch('model', function (newValue, oldValue) {
                                if (angular.isDefined(oldValue)) ngModelCtrl.$setTouched();
                            });

                            var elem;
                            if (angular.isDefined(iAttrs.simple)) {
                                vm.ckConfig = angular.copy(ckSimpleConfig);
                                if (vm.height) vm.ckConfig.height = vm.height;
                                elem = '<div ckeditor="ckConfig" ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            } else {
                                elem = '<div ckeditor ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            checkValidity();

                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) iElement.addClass('submitted')
                                });
                            }
                        }

                        function checkValidity() {
                            var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                            ngModelCtrl.$setValidity('required', valid);
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('requireMultiple', requireMultiple);

    /** @ngInject */
    function requireMultiple($parse) {
        return {
            require: 'ngModel',
            link: function postLink(scope, element, attrs, ngModel) {
                var require = $parse(attrs.requireMultiple)();
                if (require !== false) {
                    ngModel.$validators.required = function (value) {
                        return angular.isArray(value) && value.length > 0;
                    };
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($timeout, $anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('submit', function () {
                    $timeout(function(){
                        var firstInvalid = elem[0].querySelector('.ng-invalid');

                        if (firstInvalid) {
                            if ($location.hash() !== firstInvalid.id) {
                                $location.hash(firstInvalid.id);
                            }
                            $anchorScroll();
                            firstInvalid.focus();
                        }
                    });

                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('startDate', startDate);

    function startDate() {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, element, attributes, ngModel) {
                function validateEndDate(endDate, startDate) {

                    if (endDate && startDate) {
                        startDate = new Date(startDate);
                        startDate.setHours(0, 0, 0, 0);
                        endDate = new Date(endDate);
                        endDate.setHours(0, 0, 0, 0);
                        return endDate >= startDate;
                    } else {
                        return true;
                    }
                }

                ngModel.$validators.startDate = function (modelValue) {
                    var startDate = Date.parse(attributes.startDate);
                    return validateEndDate(modelValue, startDate);
                };

                attributes.$observe('startDate', function (value) {
                    var startDate = Date.parse(value);
                    var endDate = Date.parse(ngModel.$viewValue);
                    ngModel.$setValidity("startDate", validateEndDate(endDate, startDate));
                });
            }
        };
    }
})();

// 因为点击选项造成的失去焦点，无法辨别
// (function () {
//     'use strict';
//
//     angular.module('c')
//         .directive('tagOnBlur', tagOnBlur);
//
//     /** @ngInject */
//     function tagOnBlur($timeout) {
//
//         var directive = {
//             require: 'uiSelect',
//             link: link
//         };
//
//         return directive;
//
//         function link(scope, elm, attrs, ctrl) {
//             scope.$on('uis:select', function (event, item) {
//                 ctrl.search = '';
//             });
//             ctrl.searchInput.on('blur', function (e) {
//                 if ((ctrl.items.length > 0 || ctrl.tagging.isActivated)) {
//                     $timeout(function () {
//                         ctrl.searchInput.triggerHandler('tagged');
//                         var newItem = ctrl.search;
//                         if (ctrl.tagging.fct) {
//                             newItem = ctrl.tagging.fct(newItem);
//                         }
//                         if (newItem) ctrl.select(newItem, true);
//                         ctrl.search = '';
//                     });
//                 }
//             });
//         }
//
//     }
//
// })();
angular.module('c')
    .directive('dateRange', function () {
        return {
            templateUrl: 'templates/date_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'dateRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c')
    .directive('focusMe', function ($timeout) {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.focusMe, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    });
angular.module('c')
.directive('ngIndeterminate', function($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});
(function () {
    'use strict';

    angular.module('c')
        .directive('loadingContainer', function () {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, element, attrs) {
                    if (angular.isUndefined(attrs.loadingIcon)) attrs.loadingIcon = 'fa-spinner fa-2x fa-pulse';
                    if (angular.isUndefined(attrs.loadingTitle)) attrs.loadingTitle = '加载中，请稍后...';
                    var elem = '<div class="loading d-flex align-items-center justify-content-center">' +
                        '<div><i class="fa ' + attrs.loadingIcon + ' mr-2"></i>' +
                        (attrs.loadingTitle ? '<span>' + attrs.loadingTitle + '</span></div>' : '') +
                        '</div>';
                    var loadingLayer = angular.element(elem);
                    element.append(loadingLayer);
                    element.addClass('loading-container');
                    scope.$watch(attrs.loadingContainer, function (value) {
                        loadingLayer.toggleClass('ng-hide', !value);
                    });
                }
            };
        });

})();
angular.module('c').directive('modalDraggable', function ($document) {
    "use strict";
    return function (scope, element) {
        var startX = 0,
            startY = 0,
            x = 0,
            y = 0;
        element = angular.element(document.getElementsByClassName("modal-dialog"));
        if (element.length > 0) {
            element = element.last();


        }
        element.css({
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)'
        });

        var header = element.find('.modal-header');
        //var footer = element.find('.modal-footer');
        //var body = element.find('.modal-body');
        //
        //body.css({
        //    'min-width': '300px'
        //    //'max-height': '480px',
        //    //'overflow-y': 'scroll'
        //});

        header.on('mousedown', function (event) {
            // Prevent default dragging of selected content
            event.preventDefault();
            x = element.prop('offsetLeft');
            startX = event.screenX - x;
            startY = event.screenY - y;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });


        function mousemove(event) {
            y = event.screenY - startY;
            x = event.screenX - startX;
            if (y + 60 <= 0 || y + 60 >= window.innerHeight ||
                x <= 0 || x >= window.innerWidth)
                return;

            element.css({
                top: y + 'px',
                left: x + 'px'
            });
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
        }
    };
});
angular.module('c')
    .directive('numberRange', function () {
        return {
            templateUrl: 'templates/number_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'numRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c')
    .directive('selectOnClick', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                    this.setSelectionRange(0, this.value.length)
                }
            });
        }
    };
}]);
(function () {
    'use strict';

    angular
        .module('c')
        .directive('dragScroll', DragScroll);

    DragScroll.$inject = ['$document', '$window', '$parse'];

    /* @ngInject */
    function DragScroll($document, $window, $parse) {
        //Usage:
        //<div drag-scroll>Lorem ipsum dolor sit amet</div>
        var directive = {
            restrict: 'A',
            link: function ($scope, $element, $attributes) {
                var enabled = true;
                var allowedClickOffset = 5;
                var pushed = false;
                var onDragStart = $parse($attributes.onDragStart);
                var onDragEnd = $parse($attributes.onDragEnd);
                var axis = $attributes.axis || false;
                var excludedClasses = $attributes.dragScrollExcludedClasses ? $attributes.dragScrollExcludedClasses.split(',') : [];
                var startClientX;
                var startClientY;
                var lastClientX;
                var lastClientY;

                $scope.$watch($attributes.dragScroll, function (newValue) {
                    enabled = newValue !== undefined ? newValue : true;
                });

                // Set event listeners
                $element.on('mousedown', handleMouseDown);

                // Set destroy listener
                $scope.$on('$destroy', destroy);

                /**
                 * Sets the event listeners for the mouseup and mousedown events
                 */
                function setDragListeners() {
                    angular.element($window).on('mouseup', handleMouseUp);
                    angular.element($window).on('mousemove', handleMouseMove);
                }

                /**
                 * Removes the event listeners for the mouseup and mousedown events
                 */
                function removeDragListeners() {
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Handles mousedown event
                 * @param {object} e MouseDown event
                 */
                function handleMouseDown(e) {
                    if (enabled) {
                        for (var i = 0; i < excludedClasses.length; i++) {
                            if (angular.element(e.target).hasClass(excludedClasses[i])) {
                                return false;
                            }
                        }

                        $scope.$apply(function () {
                            onDragStart($scope);
                        });

                        // Set mouse drag listeners
                        setDragListeners();

                        // Set 'pushed' state
                        pushed = true;
                        lastClientX = startClientX = e.clientX;
                        lastClientY = startClientY = e.clientY;

                        clearSelection();

                        e.preventDefault();
                        e.stopPropagation();
                    }

                }

                /**
                 * Handles mouseup event
                 * @param {object} e MouseUp event
                 */
                function handleMouseUp(e) {
                    if (enabled) {
                        var selectable = (e.target.attributes && 'drag-scroll-text' in e.target.attributes);
                        var withinXConstraints = (e.clientX >= (startClientX - allowedClickOffset) && e.clientX <= (startClientX + allowedClickOffset));
                        var withinYConstraints = (e.clientY >= (startClientY - allowedClickOffset) && e.clientY <= (startClientY + allowedClickOffset));

                        // Set 'pushed' state
                        pushed = false;

                        // Check if cursor falls within X and Y axis constraints
                        if (selectable && withinXConstraints && withinYConstraints) {
                            // If so, select the text inside the target element
                            selectText(e.target);
                        }

                        $scope.$apply(function () {
                            onDragEnd($scope);
                        });

                        removeDragListeners();
                    }

                }

                /**
                 * Handles mousemove event
                 * @param {object} e MouseMove event
                 */
                function handleMouseMove(e) {
                    if (enabled) {
                        if (pushed) {
                            if (!axis || axis === 'x') {
                                $element[0].scrollLeft -= (-lastClientX + (lastClientX = e.clientX));
                            }
                            if (!axis || axis === 'y') {
                                $element[0].scrollTop -= (-lastClientY + (lastClientY = e.clientY));
                            }
                        }

                        e.preventDefault();
                    }
                }

                /**
                 * Destroys all the event listeners
                 */
                function destroy() {
                    $element.off('mousedown', handleMouseDown);
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Selects text for a specific element
                 * @param {object} element Selected element
                 */
                function selectText(element) {
                    var range;
                    if ($window.document.selection) {
                        range = $window.document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if ($window.getSelection) {
                        range = $window.document.createRange();
                        range.selectNode(element);
                        $window.getSelection().addRange(range);
                    }
                }

                /**
                 * Clears text selection
                 */
                function clearSelection() {
                    if ($window.getSelection) {
                        if ($window.getSelection().empty) {  // Chrome
                            $window.getSelection().empty();
                        } else if ($window.getSelection().removeAllRanges) {  // Firefox
                            $window.getSelection().removeAllRanges();
                        }
                    } else if ($document.selection) {  // IE?
                        $document.selection.empty();
                    }
                }


            }
        };
        return directive;

    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('scrollPositionObserver', scrollPositionObserver);

    /** @ngInject */
    function scrollPositionObserver() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var content = element.children().first();
                element.addClass("scroll-position-left");
                element.on('scroll', function (e) {
                    var max = content.width() - element.width();
                    var offset = element.scrollLeft();
                    element.removeClass("scroll-position-left scroll-position-right scroll-position-middle");
                    if (offset === 0) {
                        element.addClass("scroll-position-left");
                    } else if (offset === max) {
                        element.addClass("scroll-position-right");
                    } else {
                        element.addClass("scroll-position-middle");
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c').directive('stickyLeft', stickyLeft);

    /** @ngInject */
    function stickyLeft() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.stickyLeft) {
                    element.addClass("position-sticky sticky-left");
                    element.css("left", attrs.stickyLeft);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c').directive('stickyRight', stickyRight);

    /** @ngInject */
    function stickyRight() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.stickyRight) {
                    element.addClass("position-sticky sticky-right");
                    element.css("right", attrs.stickyRight);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersTabCtrl', DeptMembersTabCtrl)
    ;

    /** @ngInject */
    function DeptMembersTabCtrl($scope, Auth, DeptType, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        vm.notCbAgency = Auth.getAccount().dept_type_id !== DeptType.ID.CB_AGENCY;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptPhonesCtrl', DeptPhonesCtrl)
        .controller('DeptPhoneDlgCtrl', DeptPhoneDlgCtrl)
    ;

    function DeptPhonesCtrl($scope, toaster, Api, Table, Dept, DeptPhone) {
        var vm = $scope;
        vm.deptSelectedFn = deptSelectedFn;
        vm.addEdit = addEdit;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: DeptPhone,
                params: {opt: 1}, sorting: {sorting: 'asc'},
                primaryFilter: 'dept_id',
                hideFilter: true, optColWidth: Table._3_BTN,
                cols: [
                    {title: '名称', field: 'name'}, //0
                    {title: '电话', field: 'phone'}, //1
                    {title: '短号', field: 'cornet'}, //1
                    {title: '排序', sortable: 'sorting', field: 'sorting'} //6
                ]
            };
            Table.load(vm, options);

            Dept.ov.query({opt: 6}, function (resp) {
                vm.depts = resp.depts;
                if (resp.depts && resp.depts.length > 0) {
                    deptSelectedFn(0);
                }
            });
        }

        function deptSelectedFn($index) {
            vm.dept = vm.depts[$index];
            vm.tableParams.filter({dept_id: vm.dept.id});
        }

        function addEdit(m) {
            if (vm.dept) {
                Api.addEdit(vm, 'DeptPhoneDlg.html', 'DeptPhoneDlgCtrl', m, {dept: vm.dept});
            } else {
                toaster.warning('没有相关部门');
            }
        }

        function remove(m) {
            Api.delTableItem(DeptPhone, m.id, vm, '部门电话', m.name);
        }
    }

    function DeptPhoneDlgCtrl($scope, $uibModalInstance, $q, DeptPhone, toaster, F, data) {
        var vm = $scope;
        vm.dept = data.dept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            if (id) {
                DeptPhone.get({id: id}, function (resp) {
                    var phone = resp;
                    vm.m = phone;
                });
            } else {
                vm.m = {sorting: 100, dept_id: data.dept.id};
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                validFailed = false;
                var promise;
                var pa = {
                    name: m.name, phone: m.phone, cornet: m.cornet, memo: m.memo, dept_id: m.dept_id,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = DeptPhone.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = DeptPhone.save(pa).$promise;
                }
                promise.then(function (resp) {
                    toaster.success(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }


})();

(function () {
    'use strict';

    angular.module('c')
        .controller('BulletinShowDlgCtrl', BulletinShowDlgCtrl);

    /** @ngInject */
    function BulletinShowDlgCtrl($rootScope, $scope, $sce, dialogs, $uibModalInstance, C, Auth, FileHelper, PrintHelper,
                                 SaveAs, toaster, $http, data) {
        function initData() {
            $scope.approval = data.approval;
            $http.get('/api/v1/bulletin/bulletins/' + data.id ).success(function (resp) {
                var bulletin = resp;
                $scope.article = {
                    id: bulletin.id,
                    sender: bulletin.sender,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: bulletin.dept,
                    body: bulletin.body,
                    attachment: bulletin.attachments,
                    recipient: bulletin.recipient,
                    created_at: bulletin.created_at
                };
                $scope.article.body_sce = $sce.trustAsHtml(bulletin.body);

                if (!bulletin.recipient) {
                    var params = {};
                    params['opt'] = 1;
                    params['bulletin_id'] = bulletin.id;
                    $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: bulletin.id});
                    });
                }
            });
        }

        if (data.id === 0) {
            var preview = data.preview;
            $scope.article = {
                title: preview.title,
                body_sce: $sce.trustAsHtml(preview.body),
                dept: preview.dept.name,
                sender: Auth.getAccount()
            }
        } else {
            initData();
        }

        $scope.collect = function (article) {
            var params = {};
            params['opt'] = 2;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient = {};
                article.recipient['is_collect'] = 1;
                $rootScope.$broadcast('Collect');
                toaster.success('已收藏!');
            });
        };

        $scope.cancel_collect = function (article) {
            var params = {};
            params['opt'] = 3;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient.is_collect = 0;
                $rootScope.$broadcast('CancelCollect');
                toaster.success('已取消收藏!');
            });
        };


        $scope.back = function (article) {
            dialogs.create('templates/article/back.html', 'BulletinBackDlgCtrl', {
                stage: 4
            }, {
                size: 'xs'
            }).result.then(function (params) {
                Bulletin.update({id: article.id, opt: 5}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('bulletinBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            })
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.print = function (article) {

            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">发布部门:' + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

angular.module('c').controller('ContactGroupMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, Table,
              toaster, F, ContactGroup, data) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.group = data.group;

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
            {title: '用户名', filter: {'users.username': 'text'}, field: 'username', width: '30%', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
        ];
        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['id'] = data.group.id;
                ContactGroup.index_members(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.member_id});
                    });
                    $scope.members_ids = members;
                    $defer.resolve(resp.members);
                    $scope.members = resp.members;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.add = function () {
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl',
                {
                    title: '添加' + data.group.name + '成员', multiSelect: true, existMembers: $scope.members_ids
                }, {

                    size: 'md'
                }).result.then(function (params) {
                if (params.length > 0) {
                    var members_ids = [];
                    angular.forEach(params, function (m) {
                        members_ids.push(m.id)
                    });
                    ContactGroup.attach_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        toaster.success('添加成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                }
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        if (member.is_checked) {
                            members.push(member.member_id);
                        }
                    });
                } else {
                    members.push(m.member_id);
                }
                ContactGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function () {
                        toaster.success('移除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        };

        $scope.setStop = function (m, stop) {
            ContactGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function () {
                m.is_stop = stop ? '1' : '0';
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('eventReminderDlgCtrl', eventReminderDlgCtrl);

    /** @ngInject */
    function eventReminderDlgCtrl($uibModalInstance, $q, FormHelper, Dlg, data) {
        var noneVal = {name: '空缺'};
        var vm = this;
        var reminder = data.service;
        var event = data.event;

        vm.title = data.title;
        vm.users = angular.copy(data.users);

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            vm.m = {};
            reminder.get(event).then(function (resp) {
                var reminder = resp.data;
                if (!reminder) reminder = noneVal;
                vm.m = {reminder: reminder};
            });
            vm.users.splice(0, 0, noneVal);
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var userId = !m.reminder || !m.reminder.id ? null : m.reminder.id;
                reminder.set(event, userId).then(function (resp) {
                    Dlg.s(resp.data.msg);
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('NewsShowDlgCtrl', NewsShowDlgCtrl)
    ;

    /** @ngInject */
    function NewsShowDlgCtrl($scope, $sce, $uibModalInstance, $http, C, FileHelper, Auth, SaveAs, data, PrintHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.download = download;
        vm.print = print;
        vm.isNews = true;


        init(data.id);

        function init(id) {
            if (id === 0) {
                var preview = data.preview;
                vm.article = {
                    title: preview.title,
                    body_sce: $sce.trustAsHtml(preview.body),
                    dept: preview.dept,
                    sender: Auth.getAccount()
                }
            } else {
                $http.get('/api/v1/news/news/' + id ).success(function (resp) {
                    vm.article = resp;
                    vm.article.body_sce = $sce.trustAsHtml(resp.body);
                });
            }
        }

        function download(attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.NEWS_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function () {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function print(article) {
            print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">新闻类型：' + article.type + '&nbsp;&nbsp;&nbsp;发布部门:'
                    + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        }
    }
})();

angular.module('c').controller('RichEditDlgCtrl', function ($scope, $uibModalInstance, data) {
    $scope.body = data.body;
    $scope.ok = function (body) {
        $uibModalInstance.close(body);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c').controller('SimpleDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
angular.module('c').controller('SmsShowDlgCtrl',
    function ($scope, $uibModalInstance, data) {
        $scope.sms = data.sms;

        $scope.edit = function (sms) {
            var params = {opt: 5, sms: sms};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('TransMemberCtrl', TransMemberCtrl)

    ;

    /** @ngInject */
    function TransMemberCtrl($scope, $uibModalInstance, Dlg, ArrayHelper, Dept, data, DateHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.m = {
            leave_time: new Date(),
            entry_time: new Date(),
            post: data.user.post
        };
        vm.user = data.user;
        vm.dept = data.dept;

        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        Dept.ov.query({opt: 4}, function (resp) {
            vm.depts = ArrayHelper.except(data.dept.id, resp.depts);
            vm.m['dept'] = vm.depts[0];
        });


        function ok(m) {
            if (vm.u_form.$valid) {
                var p = {};
                p['leave_time'] = DateHelper.date2Str(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = data.user.user_id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = DateHelper.date2Str(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = data.user.is_main;
                $uibModalInstance.close(p);
            } else {
                Dlg.w('表单中有错误!');
                vm.u_form.submitted = true;
            }
        }
    }
})();

(function () {
    'use strict';
    
    angular.module('c')
        .controller('PhotoImgDlgCtrl', PhotoImgDlgCtrl)
    
    /** @ngInject */
    function PhotoImgDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.m = {
            photo: data.photo
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalUserInTabCtrl', HospitalUserInTabCtrl)

    ;
    /** @ngInject */
    function HospitalUserInTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        UIHelper.loadTabs($scope, $stateParams, $rootScope);
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('CommonPhoneCtrl', CommonPhoneCtrl)
        .controller('CommonPhoneDlgCtrl', CommonPhoneDlgCtrl);

    /** @ngInject */
    function CommonPhoneCtrl ($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init () {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {phone: "text"}},
                    {field: "cornet", title: "小号", filter: {cornet: "text"}},
                    {field: "group", title: "所属组", filter: {group: "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }


        function add () {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                CommonPhone.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit (m) {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                CommonPhone.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove (m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                CommonPhone.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

    }

    /** @ngInject */
    function CommonPhoneDlgCtrl ($scope, $uibModalInstance, toaster, F, CommonPhone, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel (id) {
            if (id) {
                CommonPhone.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok (m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                    sort: m.sort,
                    is_stop: m.is_stop ? '1' : '0',
                    group: m.group ? m.group : null
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }
})();


(function () {
    'use strict';

    angular.module('c')
        .controller('OfficeDeptPhoneDlgCtrl',OfficeDeptPhoneDlgCtrl)
        .controller('OfficeDeptPhoneCtrl', OfficeDeptPhoneCtrl);

    /** @ngInject */
    function OfficeDeptPhoneCtrl(DeptPhone, $scope, Dlg, dialogs, Dept, toaster, OfficeDeptPhone) {
        var vm = $scope;
        vm.remove = remove;
        vm.add = add;
        vm.edit = edit;
        vm.typeSelectedFn = typeSelectedFn;
        vm.selectDeptPhone = selectDeptPhone;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.cancel = cancel;

        init();


        function init() {
            vm.selectTypes = [
                {id: 1, name: '部门', exAll: false, fresh: true},
            ];
            vm.curType = $scope.selectTypes[0];
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }
        function cancel() {
            vm.selectedDept = false;

        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.ov.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }


        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }


        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }
        function remove(m) {
            Dlg.confirm('确定删除该记录吗？').then(function () {
                OfficeDeptPhone.delete({
                    id: m,
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }

        function add(depts) {

            dialogs.create('OfficeDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {dept: depts}, { size: 'md'});

        }
        function edit(m) {
            dialogs.create('UpDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {id: m.id}, { size: 'md'})
                .result.then(function (pa) {
                OfficeDeptPhone.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }
    }
    function OfficeDeptPhoneDlgCtrl($scope, $uibModalInstance, toaster, Dlg, FormHelper,  OfficeDeptPhone, data) {
        var vm = $scope;
        vm.submit = submit;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    dept_id: data.dept.id,
                    phone : m.phone,
                    cornet : m.cornet,
                    // sorting: m.sorting,
                };

                OfficeDeptPhone.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });


        }

        if (data.id) {
            loadModel(data.id);
        }
        function loadModel(id) {
                OfficeDeptPhone.get({id: id}, function (resp) {
                    var m = resp;
                    vm.m = m;
                });
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }


})();



(function () {
    'use strict';

    angular.module('c')
        .controller('CommonPhoneViewCtrl', CommonPhoneViewCtrl);

    /** @ngInject */
    function CommonPhoneViewCtrl($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;

        init();

        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }
    }
})();




angular.module('c')
    .controller('ContactGroupCtrl',function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, field: 'is_public', width: '10%', show: true}, //6
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                ContactGroup.query({opt: 3}, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

angular.module('c').controller('ContactGroupDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');

        $scope.group = {is_public: false, is_stop: false};

        $scope.ok = function (group) {
            if ($scope.g_form.$valid) {
                var params = {};
                params['name'] = group.name;
                params['is_public'] = group.is_public;
                params['is_stop'] = group.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('ContactsCtrl', ContactsCtrl);

    /** @ngInject */
    function ContactsCtrl ($scope, ContactGroup, ArrayHelper, Api, DeptType, Dept, DeptPhone, $q, DeptGroup,
                           WxHelper, deviceDetector, OS, AdminGroup, User, CommonPhone, FileHelper) {
        var isWx = WxHelper.isWechatBrowser();
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.typeSelectedFn = typeSelectedFn;
        vm.clearQuery = clearQuery;
        vm.clearQueryPhone = clearQueryPhone;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleDeptGroupNode = toggleDeptGroupNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectDeptPhone = selectDeptPhone;
        vm.pageChanged = pageChanged;
        vm.selectUser = selectUser;
        vm.queryUser = queryUser;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.groupVisible = groupVisible;

        //常用电话
        vm.phoneGroupVisible = phoneGroupVisible;
        vm.togglePhoneGroupNode = togglePhoneGroupNode;


        vm.getCallUrl = getCallUrl;
        vm.hasCallUrl = hasCallUrl;

        vm.initCommonPhoneSelector = initCommonPhoneSelector;

        vm.download = download;

        init();


        function init () {
            vm.selectTypes = [
                {id: 1, name: '部门', exAll: false, fresh: true},
                {id: 3, name: '姓名/用户名', fresh: true},
                // {id: 4, name: '科管组', fresh: true},
                {id: 5, name: '群', fresh: true},
                {id: 7, name: '常用电话', fresh: true}
            ];
            vm.curType = $scope.selectTypes[0];
            vm.selected = null; //所有选中的人
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }

        function download (type) {
            var defer = $q.defer();
            var url, title;
            if (type == 1) {
                url = '/api/v1/dept_phones/download';
                title = '部门电话明细.xls'
            } else {
                url = '/api/v1/common_phones/download';
                title = '常用电话明细.xls'
            }
            FileHelper.dnExcel(url, {}, title)
                .finally(function () {
                    defer.resolve();
                });
            return defer.promise;
        }

        function phoneGroupVisible (group) {
            var visible = !vm.search.phoneGroup;
            if (!visible) {
                if (group.group) {
                    if (group.group.indexOf(vm.search.phoneGroup) !== -1) {
                        visible = true;
                    }
                } else {
                    visible = true;
                }
            }
            return visible;
        }

        function togglePhoneGroupNode (group, toggle, node) {
            CommonPhone.query({
                opt: 4,
                queryStr: vm.query.phone ? vm.query.phone : undefined,
                group_name: group.group
            }, function (resp) {
                group.members = resp.items;
                toggle(node);
            });
        }

        function getCallUrl (phone) {
            var index = phone.indexOf('转');
            if (index !== -1) phone = phone.slice(0, index);
            var url = 'tel:' + phone;
            if (isWx && deviceDetector.os !== OS.IOS) return url + '#weixin.qq.com';
            return url;
        }

        function hasCallUrl (phone) {
            return !deviceDetector.isDesktop() && phone
        }

        function typeSelectedFn ($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    initCommonPhoneSelector();
            }
            $scope.curType = toType;
        }

        function clearQuery () {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function clearQueryPhone () {
            vm.query.phone = undefined;
            initCommonPhoneSelector(vm.query.phone);
        }

        function initCommonPhoneSelector (qStr) {
            vm.loading = true;
            CommonPhone.query({
                opt: 3,
                queryStr: qStr
            }, function (resp) {
                vm.loading = false;
                vm.commonPhoneGroups = resp.items;
            }, function () {
                vm.loading = false;
            })
        }

        function queryUser (qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    op: 'search',
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.queryStr = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged () {
            queryUser(vm.query.str);
        }

        function selectDeptPhone (dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectUser (user) {
            showDetailAccordingToScreenSize();

            vm.selected = user;
            vm.selectedDept = false;
            User.get({id: user.id, op: 'contact'}, function (resp) {
                vm.contact = resp.item;
            });
        }


        function initDeptSelector () {
            vm.loading = true;
            Dept.query({op: 'contact'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function showDetailAccordingToScreenSize () {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }

        function initNameSelector () {

        }

        function initContactGroupMembersSelector () {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector () {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                vm.loading = false;
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeaderAndHide (dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function toggleDeptTypeNode (type, toggle, node) {
            if (type.depts) {
                toggle(node);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        type.depts = items;
                        tagDeptLeaderAndHide(type);
                        toggle(node);
                    }
                });
            }
        }

        function toggleDeptNode (dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);
                        toggle(node);
                    }
                });
                // Dept.getMembers(dept.id).then(function (resp) {
                //     var items = resp.data.items;
                //     if (items.length > 0) {
                //         dept.mail_recipient_id = resp.data.mail_recipient_id;
                //         dept.members = items;
                //         tagDeptLeaderAndHide(dept);
                //         toggle(node);
                //     }
                // });
            }
        }

        function toggleDeptGroupNode (toggle, node) {
            toggle(node);
        }

        function toggleContactGroupNode (group, toggle, node) {
            if (!group.members) {
                group.members = ArrayHelper.getItem(group.id, cacheGroup).members;
            }
            toggle(node);
        }

        function deptGroupVisible (group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
            && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible (group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
            && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible (type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible (dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
            && dept.name.indexOf(vm.search.dept) === -1);
        }

        function groupVisible (group) {
            return !(vm.search.group && vm.search.group.length > 0
            && group.name.indexOf(vm.search.group) === -1);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsCtrl', SmsCtrl);

    /** @ngInject */
    function SmsCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('SignedTabCtrl', SignedTabCtrl)


    ;
    /** @ngInject */
    function SignedTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('TOZRTabCtrl', TOZRTabCtrl)


    ;
    /** @ngInject */
    function TOZRTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
angular.module('c')
    .controller('PersonnelContactGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
            {title: '是否停用', data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
            {title: '创建人', field: 'creator_id', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                ContactGroup.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
            group.$creatorChanged = {id: group.creator_id, name: group.creator.name};
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                data['creator_id'] = group.$creatorChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                    group.creator = group.$creatorChanged;
                    group.creator_id = group.$creatorChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

(function () {
    'use strict';
    angular.module('c')

        .controller('MemberCtrl', MemberCtrl)
        .controller('AddMemberCtrl', AddMemberCtrl)
        .controller('DeptMemberCtrl', DeptMemberCtrl)
        .controller('LeaveMemberCtrl', LeaveMemberCtrl)
        .controller('SelectLeaderCtrl', SelectLeaderCtrl)
        .controller('SelectAgentCtrl', SelectAgentCtrl);

    /** @ngInject */
    function DeptMemberCtrl($scope, Dlg, Dept, DeptType, Table) {
        var vm = $scope;
        vm.leader = leader;
        vm.member = member;
        vm.agent = agent;

        init();


        function init() {
            DeptType.query({op: 'options'}, function (resp) {
                vm.types = resp.items;
                vm.types.splice(0, 0, {name: '全部部门'});

                var options = {
                    service: Dept,
                    params: {op: 'personnel'},
                    optColWidth: Table._3_BTN,
                    optInFront: true,
                    cols: [
                        {field: "sn", title: "序号"},
                        {field: "name", title: "部门名称", filter: {name: "text"}},
                        {field: "leader", title: "部门经理/组长", filter: {leader: "text"}},
                        {field: "hospitalLeader", title: "总经理", filter: {hospitalLeader: "text"}},
                        {field: 'members_count', title: '成员数', width: Table._2_CHAR}
                    ]
                };
                Table.load(vm, options, Table.loadItem);
            });
        }

        function leader(m) {
            Dlg.show({
                template: 'LeaderDlg.html', ctrl: 'SelectLeaderCtrl', data: {dept: m}
            }).then(function () {
                vm.tableReload();
            });
        }

        function agent(m) {
            Dlg.show({
                template: 'AgentDlg.html', ctrl: 'SelectAgentCtrl', data: {dept: m}
            }).then(function () {
                vm.tableReload();
            });
        }

        function member(m) {
            Dlg.show({
                template: 'MemberDlg.html',
                ctrl: 'MemberCtrl',
                data: {dept: m},
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }

    function MemberCtrl($scope, $uibModalInstance, Table, Dlg, ArrayHelper, UserDept, data) {
        var vm = $scope;
        vm.dept = data.dept;
        vm.edit = edit;
        vm.add = add;
        vm.leave = leave;
        vm.transfer = transfer;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {
                    op: 'dept_member',
                    dept_id: data.dept.id,
                    need_users: true
                },
                optColWidth: Table._2_BTN,
                cols: [
                    {title: '序号', field: 'sn'}, //0
                    {title: '姓名', field: 'name', filter: {name: 'text'}}, //0
                    {title: '用户名', field: 'username', filter: {username: 'text'}}, //0
                    {title: '部门内职务', field: 'post', filter: {post: 'text'}}, //6
                    {
                        title: '是否主部门', field: 'is_main', filter: {is_main: 'select'},
                        data: Table.getNgTableOpts(ArrayHelper.get('yesNo'))
                    }, //6
                    {title: '进入时间', field: 'entry_time'}, //6
                    {title: '排序', field: 'sorting'} //6

                ]
            };
            Table.load(vm, options, Table.loadItem);
        }

        function add() {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                data: {members: vm.members},
                size: 'md'
            }).then(function (params) {
                params['dept_id'] = data.dept.id;
                UserDept.save(params).$promise.then(function (resp) {
                    if (resp.result == 1) {
                        Dlg.e('部门没有对应的工会小组，请联系工会管理人员添加!');
                    } else {
                        Dlg.s('添加成功!');
                    }
                    vm.tableReload();
                }, function () {
                    Dlg.e('添加失败!');
                });
            });
        }

        function edit(user) {
            Dlg.show({
                template: 'AddMemberDlg.html',
                ctrl: 'AddMemberCtrl',
                data: {user: user},
                size: 'md'
            }).then(function (params) {
                params['dept_id'] = data.dept.id;
                params['op'] = 'edit';
                UserDept.update({id: user.id}, params).$promise.then(function () {
                    Dlg.s('修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('修改失败!');
                });
            });
        }

        function leave(user) {
            Dlg.show({
                template: 'LeaveMemberDlg.html',
                ctrl: 'LeaveMemberCtrl',
                data: {user: user},
                size: 'md'
            }).then(function (params) {
                params['op'] = 'leave';
                UserDept.update({id: user.id}, params).$promise.then(function () {
                    Dlg.s('移出成功');
                    vm.tableReload();
                }, function () {
                    Dlg.e('移出失败');
                });
            });
        }

        function transfer(m) {
            Dlg.show({
                template: 'pages/personnel/userTransferDeptDlg.html',
                ctrl: 'UserTransferDeptDlgCtrl',
                data: {user: {id: m.user_id, name: m.name}, dept: m.dept}
            }).then(function (dept) {
                vm.tableReload();
            });
        }
    }

    function LeaveMemberCtrl($scope, $uibModalInstance, $filter, toaster, data) {
        $scope.m = {leave_time: new Date()};
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            //maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function AddMemberCtrl($scope, $uibModalInstance, $filter, toaster, uibDateParser, data) {

        if (data.user) {
            $scope.$edit = true;
            var user = data.user;
            $scope.m = {
                user: {id: user.user_id, name: user.name}, is_main: user.is_main,
                entry_time: uibDateParser.parse(user.entry_time, 'yyyy-MM-dd'), post: user.post, sorting: user.sorting
            };
        } else {
            $scope.m = {is_main: false, entry_time: new Date(), sorting: 100};
            $scope.members = data.members;
        }

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if (m.user == null) {
                toaster.warning('成员未选择!');
            } else if ($scope.u_form.$valid) {
                var p = {};
                p['user_id'] = m.user.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = m.is_main;
                p['sorting'] = m.sorting;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function SelectLeaderCtrl($uibModalInstance, $q, Dlg, Dept, data) {
        var none = {id: null, name: '空缺'};
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.dept);


        function init(m) {
            vm.m = {
                id: m.id, name: m.name,
                leader: m.leader ? m.leader : none, hospital_leader: m.hospital_leader
            };
            Dept.getMembers(m.id).then(function (resp) {
                var members = resp.data.items;
                members.splice(0, 0, {id: null, name: '空缺'});
                vm.members = members;
            });
        }

        function ok(m) {
            var defer = $q.defer();
            var pa = {
                op: 'set_leader',
                leader_id: m.leader.id,
                hospital_leader_id: m.hospital_leader ? m.hospital_leader.id : null,
            };

            Dept.update({id: m.id}, pa).$promise.then(
                function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

    function SelectAgentCtrl($uibModalInstance, $q, Dlg, Dept, data, DeptAgent) {
        var none = {id: null, name: '空缺'};
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.dept);


        function init(m) {
            vm.m = {
                id: m.id, name: m.name,
                leader: m.leader ? m.leader : none, hospital_leader: m.hospital_leader
            };
            Dept.query({op: 'led_by', with_agent: true, dept_id: m.id}).$promise.then(
                function (rep) {
                    vm.m.email_agent = none;
                    vm.m.doc_agent = none;
                    if (rep.items[0].dept_agent) {
                        if (rep.items[0].dept_agent.doc_agent) {
                            vm.m.doc_agent = rep.items[0].dept_agent.doc_agent;
                        }
                        if (rep.items[0].dept_agent.email_agent) {
                            vm.m.email_agent = rep.items[0].dept_agent.email_agent;
                        }
                    }
                    Dept.getMembers(m.id).then(function (resp) {
                        var members = resp.data.items;
                        members.splice(0, 0, {id: null, name: '空缺'});
                        vm.members = members;
                    });
                });

        }

        function ok(m) {

            var defer = $q.defer();
            var pa = {
                email_agent_id: m.email_agent.id,
                doc_agent_id: m.doc_agent.id,
                dept_id: m.id
            };

            DeptAgent.save(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close();
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }
})();


(function () {
    'use strict';

    angular.module('c')
        .controller('DeptRecordDlgCtrl', DeptRecordDlgCtrl);

    /** @ngInject */
    function DeptRecordDlgCtrl($scope, $uibModalInstance, dialogs, toaster, NgTableParams,
                               UserDept, data) {

        $scope.user = data.user;
        $scope.cols = [
            {title: '部门名称', field: 'name', show: true}, //0
            {title: '部门内职务', field: 'post', show: true}, //6
            {title: '是否主部门', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true}, //6
        ];
        $scope.hideFilter = true;
        if (data.hideOpt) {
            $scope.hideOpt = true;
        } else {
            $scope.optColWidth = 56;
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.user.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.depts, function (m) {
                        m.is_main = m.is_main === 1;
                    });
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.delete = function (dept) {
            dialogs.confirm('删除部门记录', '确定要删除<strong>' + dept.name + '</strong>的部门记录吗?')
                .result.then(function () {
                UserDept.delete({id: dept.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('部门记录删除成功!');
                            break;
                        case 1:
                            toaster.warning('这是员工当前所在的主部门记录,无法直接删除');
                            break;
                    }
                    $scope.tableReload();
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('部门记录删除失败!');
                });
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserInfoCtrl', UserInfoCtrl);

    /** @ngInject */
    function UserInfoCtrl($scope, $state, $q, Dlg, Auth, User, UserOnType, Table, ArrayHelper) {
        var options, hideOpt = false;
        var account = Auth.getAccount();
        var vm = $scope;
        var eduBgs = User.getEduBgList();
        var eduBgOpts = Table.getNgTableOpts(eduBgs);
        var enLvs = User.getEnLvList();
        var enLvOpts = Table.getNgTableOpts(enLvs);
        var yesNoOpts = Table.getNgTableOpts(User.getYesNos());
        var titles = User.getTitles();
        var checker = null;
        vm.visibleOptions = [
            {name: '基本信息', value: 0x01},
            // {name: '账户信息', value: 0x02},
            {name: '教育背景', value: 0x04},
            {name: '联系方式', value: 0x08},
            {name: '工作相关1', value: 0x10},
            {name: '工作相关2', value: 0x20},
            //{divider: true},
            {name: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;
        // vm.exportDn = exportDn;
        vm.edit = edit;
        vm.changeType = changeType;
        vm.changeRecord = changeRecord;
        vm.changePwd = changePwd;
        vm.remove = remove;
        vm.transfer = transfer;
        vm.passChecked = passChecked;
        vm.exportDn = exportDn;
        vm.bindDingTalk = bindDingTalk;
        vm.switchPartTime = switchPartTime;
        vm.clearWxBind = clearWxBind;
        vm.batch = batch;
        vm.option = {name: '基本信息', value: 1};
        vm.optSticky = true;

        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                vm.statuses = respArray[0].items.statuses;
                vm.types = respArray[0].items.types;
                vm.political_statuses = respArray[0].items.political_statuses;
                setupOption();
                var optionFn = Table.load(vm, options, function (resp, startSn) {
                    Table.loadItem(resp, startSn, function (item, i) {
                        item.edu_bg = ArrayHelper.getItem(item.edu_bg, eduBgs);
                        item.en_lv = ArrayHelper.getItem(item.en_lv, enLvs);
                        item.pt_edu_bg = ArrayHelper.getItem(item.pt_edu_bg, eduBgs);
                        item.pt_en_lv = ArrayHelper.getItem(item.pt_en_lv, enLvs);
                        item.title = ArrayHelper.getItem(item.title_id, titles);
                    });
                }).options;

                optionSelectedFn(vm.option);

                checker = Table.loadMultiSelectedFn(vm);
            })
        }

        function setupOption() {
            options = {
                service: User,
                params: {op: 'personnel_info'},
                filter: {confirm_state: '9'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                sorting: {created_at: 'asc'},
                count: 15,
                counts: [15, 30, 50],
                hideOpt: $state.current.name === 'app.main_users_info',
                cols: [
                    { // 0
                        title: '序号',
                        field: 'sn',
                        type: 0xff,
                        width: Table._1_CHAR
                    },
                    { // 1
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 100,
                        type: 0xff,
                        stickLeft: "90px"
                    },
                    { // 2
                        title: '主部门',
                        filter: {dept: 'text'},
                        field: 'dept',
                        type: 0x01,
                        stickLeft: "230px"
                    },
                    { // 2
                        title: '部门组',
                        filter: {group: 'text'},
                        field: 'group',
                        type: 0x01,
                        stickLeft: "320px"
                    },
                    { // 3
                        title: '用户名',
                        filter: {username: 'text'},
                        field: 'username',
                        type: 0x01,
                        stickLeft: "410px"
                    },
                    {
                        title: '调查对象',
                        field: 'is_hospital_respondent',
                        type: 0x01
                    },
                    { // 4
                        title: '头像',
                        filter: {photo: 'checkbox'},
                        data: '未传',
                        field: 'photo',
                        type: 0x01
                    },
                    { // 4
                        title: '籍贯',
                        filter: {native_place: 'text'},
                        field: 'native_place',
                        type: 0x01
                    },
                    { // 4
                        title: '户籍',
                        filter: {domicile: 'text'},
                        field: 'domicile',
                        type: 0x01
                    },
                    { // 4
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        data: Table.getNgTableOpts(vm.political_statuses),
                        field: 'political_status_id',
                        type: 0x01
                    },
                    { // 11
                        title: '入党时间',
                        filter: {party_time: 'date_range'},
                        field: 'party_time',
                        type: 0x01
                    },
                    /*教育背景*/
                    { //9
                        title: '全日制毕业学校',
                        filter: {graduate_school: 'text'},
                        field: 'graduate_school',
                        width: 200,
                        type: 0x04
                    },
                    { //9
                        title: '全日制专业',
                        filter: {major: 'text'},
                        field: 'major',
                        type: 0x04
                    },
                    {  //12
                        title: '全日制学历',
                        filter: {edu_bg: 'select'},
                        data: eduBgOpts,
                        field: 'edu_bg',
                        type: 0x04
                    },
                    {
                        title: '全日制学位',
                        filter: {degree: 'text'},
                        field: 'degree',
                        width: 140,
                        type: 0x04
                    },//13
                    { //14
                        title: '全日制英语等级',
                        filter: {en_lv: 'select'},
                        data: enLvOpts,
                        field: 'en_lv',
                        type: 0x04
                    },
                    { //9
                        title: '非全日制毕业学校',
                        filter: {pt_graduate_school: 'text'},
                        field: 'pt_graduate_school',
                        width: 200,
                        type: 0x04
                    },
                    { //9
                        title: '非全日制专业',
                        filter: {pt_major: 'text'},
                        field: 'pt_major',
                        type: 0x04
                    },
                    {  //12
                        title: '非全日制学历',
                        filter: {pt_edu_bg: 'select'},
                        data: eduBgOpts,
                        field: 'pt_edu_bg',
                        type: 0x04
                    },
                    {
                        title: '非全日制学位',
                        filter: {pt_degree: 'text'},
                        field: 'pt_degree',
                        width: 140,
                        type: 0x04
                    },//13
                    { //14
                        title: '非全日制英语等级',
                        filter: {pt_en_lv: 'select'},
                        data: enLvOpts,
                        field: 'pt_en_lv',
                        type: 0x04
                    },

                    /* 联系方式 */
                    {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x0a}, // 5
                    {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},// 6
                    {// 7
                        title: '办公室电话',
                        filter: {office_phone: 'text'},
                        field: 'office_phone',
                        type: 0x08
                    },
                    {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},// 8
                    {title: '邮箱', filter: {email: 'text'}, field: 'email', type: 0x08},// 8
                    {title: '地址', filter: {address: 'text'}, field: 'address', type: 0x08},// 8
                    /* 工作相关 */
                    { // 9
                        title: '编制类型',
                        filter: {status_id: 'select'},
                        field: 'status_id',
                        data: Table.getNgTableOpts(vm.statuses),
                        type: 0x10
                    },
                    { // 10
                        title: '类别',
                        filter: {type_id: 'select'},
                        data: Table.getNgTableOpts(vm.types),
                        field: 'type_id', type: 0x10
                    },
                    { // 10
                        title: '工资卡号',
                        filter: {salary_card: 'text'},
                        // data: Table.getNgTableOpts(vm.types),
                        field: 'salary_card', type: 0x10
                    },
                    { // 10
                        title: '所属银行',
                        filter: {card_bank: 'text'},
                        // data: Table.getNgTableOpts(vm.types),
                        field: 'card_bank', type: 0x10
                    },
                    { // 11
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x10
                    },
                    { // 12
                        title: '入职时间',
                        filter: {entry_time: 'date_range'},
                        field: 'entry_time',
                        type: 0x10
                    },
                    { // 13
                        title: '干部',
                        filter: {is_cadre: 'select'},
                        data: yesNoOpts,
                        field: 'is_cadre', type: 0x20
                    },
                    { // 14
                        title: '职称',
                        filter: {title_id: 'select'},
                        data: Table.getNgTableOpts(titles),
                        field: 'title', type: 0x20
                    },
                    { // 15
                        title: '职务',
                        filter: {post: 'text'},
                        field: 'post', type: 0x20
                    },
                    { // 16
                        title: '钉钉号',
                        filter: {dd_user_id: 'checkbox'},
                        data: '有（参与考勤）',
                        field: 'dd_user_id', type: 0x20
                    }
                ]
            };
        }

        function optionSelectedFn(option) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        }

        function exportDn() {
            Dlg.show({
                template: 'pages/personnel/userInfo/exportDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        }

        function edit(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: user.id,
                    confirm_state: User.CONFIRM.PERSONNEL
                }, size: 'lg'
            }).then(function () {
                if (user.id === account.id) {
                    account.confirm_state = User.CONFIRM.PERSONNEL; //3表示人事部已确认
                    Auth.setAccount(account);
                }
                vm.tableReload();
            });
        }

        // 修改编制
        function changeType(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changeOnTypeDlg.html',
                ctrl: 'UserChangeTypeCtrl',
                data: {user: user, statuses: vm.statuses}
            }).then(function (resp) {
                UserOnType.save(resp).$promise.then(function () {
                    Dlg.s('用户编制信息修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('用户编制信息修改失败!');
                });
            });
        }

        // 查看编制修改记录
        function changeRecord(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changeTypeRecord.html',
                ctrl: 'ChangeTypeRecordCtrl',
                data: {user: user}
            });
        }

        function changePwd(user) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的员工记录吗？', function (resp) {
                User.ov.delete({id: user.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('员工记录删除成功!');
                            break;
                        case 1:
                            Dlg.w('该员工属于部门成员,无法直接删除');
                            break;
                    }
                    vm.tableReload();
                }, function (error) {
                    Dlg.e('员工记录删除失败!');
                });
            }, '删除员工记录');
        }

        function transfer(user) {
            Dlg.show({
                template: 'pages/personnel/deptRecordDlg.html',
                ctrl: 'DeptRecordDlgCtrl',
                data: {user: user, hideOpt: false},
                size: 'lg'
            });
        }

        function passChecked() {
            var userIds = checker.getCheckedIds();
            if (userIds.length === 0) {
                checker.clearChecked();
                Dlg.w("请至少选择一条待确认记录");
                return;
            }
            // 检查是否有更正请求的
            var users = checker.getChecked();
            for (var i = 0; i < users.length; i++) {
                var user = users[i];
                if (user.change_note) {
                    Dlg.notify(user.name + "有信息更正请求，请先单独处理(点铅笔图标进入详情对话框)");
                    return;
                }
            }

            var defer = $q.defer();
            User.update({id: '-'}, {op: 'personnel_confirm', userIds: userIds})
                .$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (err) {
                if (err.data.msg) Dlg.error(err.data.msg);
                checker.clearChecked();
            }).finally(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function batch(option) {
            var checker = Table.loadMultiSelectedFn($scope);
            var batchIds = [];
            var items = checker.getChecked($scope.tableParams.settings().$scope.$data);
            if (items.length == 0) {
                Dlg.w('请选择处理对象');
                return;
            }
            items.forEach(function (item) {
                batchIds.push(item.id);
            })
            User.update({id: Auth.getAccount().id},
                {op: 'batch_respondent', ids: batchIds, option: option}).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
                checker.clearChecked();
            })
        }

        function bindDingTalk(m) {
            Dlg.comment({title: '绑定钉钉号(空置解绑)', label: '钉钉号', notRequired: true}, function (ddId) {
                User.update({id: m.id}, {
                    op: 'bind_ding_talk', dd_user_id: ddId ? ddId : null
                }).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            });
        }

        function switchPartTime(m) {
            User.update({id: m.id}, {
                op: 'switch_part_time', part_time: (!m.part_time) ? 1 : 0
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                m.part_time = resp.part_time;
            }, function (error) {
                Dlg.e(error.msg);
            });
        }

        function clearWxBind(m) {
            User.update({id: m.id}, {
                op: 'clear_wx_bind'
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                Dlg.e(error.msg);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserLeaveCtrl', PersonnelUserLeaveCtrl);

    /** @ngInject */
    function PersonnelUserLeaveCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();


(function () {
    'use strict';

    angular.module('c')
        .controller('UserRegCtrl', UserRegCtrl);

    /** @ngInject */
    function UserRegCtrl($scope, Dlg, $q, FormHelper, DeptGroup, User, DateHelper) {
        var copy;
        var vm = this;
        var required = {
            status: true, entryTime: false, startedWork: true, annualDays: true, title: true
        };
        var helper = User.formHelper;

        vm.stateSelected = stateSelected;
        vm.deptChange = deptChange;

        vm.submit = submit;
        vm.reset = reset;

        init();


        function init() {
            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    dept: false
                },
                enableTransferDept: false,
                hideUpdateAnnualChecker: true,
                hideChangeNote: true,
                required: required,
                eduBgBodyStyle: {height: '326px'}
            };

            // todo: annual_days 0.5倍数检查
            var m = {
                id: '-', // 上传头像需要检查id
                sex: 1,
                edu_bg: vm.edu_bgs[8],
                degree: vm.degree_types[3],
                en_lv: vm.en_lvs[5],
                entry_time: new Date(),
                started_work: new Date(),
                annual_days: 0,
                update_annual_num: true,
                confirm_state: User.CONFIRM.PERSONNEL.toString()
            };
            // vm.degrees = User.getDegrees(m.degree.id);
            // m.degree = vm.degrees[0];
            //
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                helper.bindAsyncOptions(vm, respArray[0]);
                //
                m.type = vm.types[0];
                m.political_status = vm.political_statuses[0];

                vm.m = m;
                copy = angular.copy(m);
            });
        }

        function deptChange(dept) {
            DeptGroup.query({op: 'option', dept_id: dept.id}, function (resp) {
                vm.groups = resp.items;
            });
        }

        function stateSelected(m) {
            var state = parseInt(m.newState);
            switch (state) {
                case User.CONFIRM.PERSONNEL:
                case User.CONFIRM.DEPT:
                    vm.cfg.required = required;
                    break;
                default:
                    vm.cfg.required = {status: true};
            }
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(copy);
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m, 'reg');
                pa.dept_id = m.dept.id;
                pa.company_id = m.company.id;
                if (m.photo) pa.photo = m.photo;
                if (m.work_photo) pa.work_photo = m.work_photo;
                pa.confirm_state = m.confirm_state;
                if (m.group) pa.group_id = m.group.id;
                if (m.title) pa.title_id = m.title.id;
                if (m.birthday) pa.birthday = DateHelper.date2Str(m.birthday);

                User.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    reset();
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('UserTransferDeptDlgCtrl', UserTransferDeptDlgCtrl);

    function UserTransferDeptDlgCtrl($uibModalInstance, FormHelper, User, Dlg, data, DateHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.user, data.dept);


        function init(user, dept) {
            vm.user = user;
            vm.dept = dept; // 原部门

            vm.m = {
                leave_time: new Date(),
                entry_time: new Date(),
                post: user.post
            };
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                User.transferDept(vm.user.id, vm.dept.id,  {
                    dept_id: m.dept.id, post: m.post,
                    leave_time: DateHelper.date2Str(m.leave_time),
                    entry_time: DateHelper.date2Str(m.entry_time)
                }).then(function (resp) {
                    if (resp.data) Dlg.s(resp.data.msg);
                    $uibModalInstance.close(m.dept);
                }, function (err) {
                    if (err.data.msg) Dlg.error(err.data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ArticleCtrl', ArticleCtrl);

    /** @ngInject */
    function ArticleCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var isNews = $stateParams.type === 'news';
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            var path = isNews ? 'news/news' : 'bulletin/bulletins';
            $http.get('/api/v1/' + path + '/' + id).then(function (resp) {
                var article = resp.data;
                article.body = $sce.trustAsHtml(article.body);
                vm.article = article;
            }, function (e) {
                if (path === 'news/news') {
                    if (e.data.msg) {
                        vm.error = e.data.msg;
                    } else {
                        vm.error2 = '没有找到该新闻';
                    }
                } else if (path === 'bulletin/bulletins') {
                    if (e.data.msg) {
                        vm.error = e.data.msg;
                    } else {
                        vm.error2 = '没有找到该公告';
                    }
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.BULLETIN_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('AttendanceAbnormalDayCtrl', AttendanceAbnormalDayCtrl);

    /** @ngInject */
    function AttendanceAbnormalDayCtrl ($scope, $stateParams, $http, NgTableParams, Dlg) {
        var vm = $scope;


        init($stateParams.day);

        function init (day) {
            vm.hideFilter = true;
            vm.hideOpt = true;
            vm.showSn = true;
            vm.cols = [
                {field: "dept", title: "所在部门", show: true},
                {field: "name", title: "姓名", show: true},
                {field: "abnormal_numbers", title: "异常次数", show: true}
            ];
            vm.tableParams = new NgTableParams({page: 1, count: 10, sorting: {}}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['op'] = 'AbnormalDay';
                    url['day'] = day;
                    $http({
                        method: 'GET',
                        url: '/api/v1/attendance/attendances',
                        params: url
                    }).then(function (resp) {
                        var data = resp.data;
                        params.total(data.total);
                        $defer.resolve(data['items']);
                    }, function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                        $defer.resolve();
                    });
                }
            });
        }
    }

})();






(function () {
    'use strict';

    angular.module('c')
        .controller('EmailShowCtrl', EmailShowCtrl);

    /** @ngInject */
    function EmailShowCtrl($stateParams, $http, $sce, C, WxHelper, FileHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/emails/' + id).then(function (resp) {
                var m = resp.data.mail;
                m.body = $sce.trustAsHtml(m.body);
                vm.m = m;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该邮件';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MAIL_DOWNLOAD, attachment);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('MeetingPreviewCtrl', MeetingPreviewCtrl);

    /** @ngInject */
    function MeetingPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/meeting/meetings/' + id).then(function (resp) {
                var meeting = resp.data.meeting;
                meeting.content = $sce.trustAsHtml(meeting.content);
                meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                vm.meeting = meeting;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                } else {
                    vm.error2 = '没有找到该会议';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('MeetingCommentCtrl', MeetingCommentCtrl);

    /** @ngInject */
    function MeetingCommentCtrl(FormHelper, $http, Dlg, $timeout, $window, $stateParams) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);


        function init(id) {
            $http.get('api/v1/meeting/meeting_attendances/query_meeting/' + id)
                .success(function (resp) {
                    vm.m = {
                        msg: resp.msg,
                        meeting: resp.meeting,
                        id: id
                    };
                }).error(function (err) {
                if (err.msg) Dlg.e(err.msg);
            });
            vm.satLvs = [
                {id: 1, name: '非常不满意'},
                {id: 2, name: '不满意'},
                {id: 3, name: '较满意'},
                {id: 4, name: '满意'},
                {id: 5, name: '非常满意'}
            ];
        }

        function close() {
            if (typeof(WeixinJSBridge) != "undefined") {
                WeixinJSBridge.invoke('closeWindow');
            } else {
                $window.location.href = 'about:blank ';
                $window.close();
            }
        }

        function ok(m) {
            if (!m.rate) {
                Dlg.e('请在1-5分中选择一个！');
            } else {
                FormHelper.handleSubmit(vm, function () {
                    $http.post('api/v1/meeting/meeting_attendances/comment', {id: m.id, rate: m.rate, note: m.note})
                        .success(function (resp) {
                            Dlg.s(resp.msg);
                            $timeout(function () {
                                close();
                            }, 2000);
                        }).error(function (err) {
                        if (err.msg) Dlg.e(err.msg);
                        $timeout(function () {
                            close();
                        }, 2000);
                    });
                });
            }

        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('MissionPreviewCtrl', MissionPreviewCtrl);

    /** @ngInject */
    function MissionPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {

        var vm = this;
        vm.download = download;

        init($stateParams.id);

        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/mission/missions/' + id).then(function (resp) {
                var mission = resp.data.mission;
                mission.content = $sce.trustAsHtml(mission.content);
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
                vm.mission = mission;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                }
                else {
                    vm.error2 = '没有找到该任务';
                }
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('PreviewShowDlgCtrl', PreviewShowDlgCtrl);

    /** @ngInject */
    function PreviewShowDlgCtrl($uibModalInstance, $sce, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.url);


        function init(url) {
            vm.url = $sce.trustAsResourceUrl(url);
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TopicPreviewCtrl', TopicPreviewCtrl);

    /** @ngInject */
    function TopicPreviewCtrl ($stateParams, $http, $sce, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init (id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/topic/topics/' + id).then(function (resp) {
                var topic = resp.data.item;
                topic.body = $sce.trustAsHtml(topic.body);
                vm.topic = topic;
            }, function (e) {
                if (e.data.msg) {
                    vm.error = e.data.msg;
                } else {
                    vm.error2 = '没有找到该议题';
                }
            });
        }

        function download (attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1('/api/v1/topic/topics/attachment/download', attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('appCfgCtrl', appCfgCtrl)
    ;

    function appCfgCtrl($scope, toaster, Setting) {
        $scope.reload = function () {
            Setting.query(function (resp) {
                var setting = {};
                angular.forEach(resp, function (s) {
                    setting[s.name] = s.value;
                    if (s.name === 'duty_count_disable') {
                        setting[s.name] = s.value === '1';
                    }
                });
                $scope.setting = setting;
                $scope.backup = angular.copy(setting);
                $scope.params_diff = false;
            });
            $scope.tab = 1;
        };

        $scope.submit = function (setting) {
            var params = {};
            var params_check = $scope.params_check;
            for (var k in params_check) {
                params[k] = setting[k];
            }

            Setting.update({id: 0}, params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('应用配置修改成功!');
                        $scope.reload();
                        break;
                    case 1:
                        toaster.warning('应用配置修改失败,因为参数格式错误!');
                        break;
                }
            }, function () {
                toaster.error('应用配置修改失败!');
            });
        };

        $scope.reset = $scope.reload;
        $scope.reload();

        $scope.params_check = {};
        $scope.$watch('setting', function (newVal, oldVal, scope) {
            scope.params_diff = false;
            for (var k in newVal) {
                if (!angular.equals(newVal[k], scope.backup[k])) {
                    scope.params_check[k] = true;
                    scope.params_diff = true;
                } else {
                    delete scope.params_check[k];
                }
            }
        }, true);
    }


})();
(function () {
    'use strict';

    angular.module('c')
        .controller('AuthorityCtrl', AuthorityCtrl)
        .controller('RoleUsersCtrl', RoleUsersCtrl)
        .controller('PermSetDlgCtrl', PermSetDlgCtrl)
        .controller('RoleAddDlgCtrl', RoleAddDlgCtrl)
    ;

    /** @ngInject */
    function AuthorityCtrl($scope, Dlg, Table, Role) {
        var vm = $scope;
        vm.maxProtectId = 2;
        vm.addEdit = addEdit;
        // vm.edit = edit;
        vm.roleUsers = roleUsers;
        vm.setPerms = setPerms;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'sys'/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "角色名称", filter: {name: "text"}},
                    {field: "description", title: "备注"}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.roles = [];
                angular.forEach(resp.items, function (i) {
                    vm.roles.push(i.name);
                })
            });
        }

        function addEdit(m) {
            var pa = {roles: vm.roles};
            if (m) {
                pa.id = m.id;
                pa.name = m.name;
            }
            Dlg.show({
                template: 'RoleAddDlg.html',
                ctrl: 'RoleAddDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的角色吗？', function (resp) {
                Role.delete({id: m.id, op: 'sys'}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除角色');
        }

        function setPerms(m) {
            Dlg.show({
                template: 'PermSetDlg.html',
                ctrl: 'PermSetDlgCtrl',
                data: {
                    role: m
                }
            }).then(function (params) {
                params['op'] = 'setPerms';
                Role.update({id: m.id}, params).$promise.then(function (success) {
                    Dlg.s(m.display_name + '权限设置成功!');
                }, function (error) {
                    Dlg.e(m.display_name + '权限设置失败!');
                });
            });
        }


        function roleUsers(m) {
            Dlg.show({
                template: 'RoleUsersDlg.html',
                ctrl: 'RoleUsersCtrl',
                data: {
                    role: m
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function RoleUsersCtrl($scope, $uibModalInstance, Table, Dlg, Role, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.add = add;
        vm.remove = remove;
        vm.members = [];


        init(data.role.id);

        function init(id) {
            var options = {
                service: Role,
                params: {op: 'member', role_id: id},
                optColWidth: Table._1_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "用户名", filter: {username: "text"}},
                    {field: "roles", title: "角色"}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    vm.members.push({id: item.id});
                })
            });
        }

        function add() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '添加' + data.role.name + '用户', multiSelect: true, existMembers: vm.members
                }
            }).then(function (members) {
                if (members.length > 0) {
                    var params = {};
                    params['op'] = 'attachUsers';
                    params['members'] = members;
                    //为角色添加用户
                    Role.update({id: data.role.id}, params).$promise.then(function (resp) {
                        Dlg.s('添加成功!');
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的<strong>' + data.role.name + '</strong>角色吗？', function (resp) {
                var params = {};
                params['op'] = 'detachUsers';
                params['members'] = [{id: user.id}];
                Role.update({id: data.role.id}, params).$promise.then(function () {
                    Dlg.s('角色移除成功!');
                    vm.tableReload();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                });
            }, '去掉员工角色');
        }
    }

    /** @ngInject */
    function PermSetDlgCtrl($uibModalInstance, Permission, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.setCheckedAll = setCheckedAll;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.loading = true;

        var setParentOfChildren = function (node) {
            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        };

        Permission.get({id: data.role.id}).$promise.then(function (data) {
            setParentOfChildren(data[1]);
            vm.data = data[1];
        }, function (error) {
        }).finally(function () {
            vm.loading = false;
        });

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            setCheckedChildren(node);
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    setCheckedChildren(child);
                });
            }
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
        }

        function ok(data) {
            var perms = [];

            function setPerms(node) {
                if (node.is_checked) {
                    perms.push({id: node.permission.id});
                }
                if (node.children != null && node.children.length > 0) {
                    angular.forEach(node.children, function (child) {
                        setPerms(child);
                    });
                }
            }

            setPerms(data);
            $uibModalInstance.close({permissions: perms});
        }
    }

    /** @ngInject */
    function RoleAddDlgCtrl($uibModalInstance, data, Dlg, Role, $q, FormHelper) {
        var vm = this;
        vm.roles = data.roles;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            if (id) {
                Role.get({id: id, op: 'sys'}, function (resp) {
                    vm.role = resp;
                });
            } else {
                vm.role = {};
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    name: m.name,
                    display_name: m.name,
                    description: m.description,
                    op: 'sys'
                };
                var promise;
                if (m.id) {
                    promise = Role.update({id: m.id}, pa).$promise;
                } else {
                    promise = Role.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                }).finally(function () {
                    defer.resolve();
                });
            }

            return defer.promise;
        }
    }


})();
angular.module('c')
    .controller('BasicCtrl', ['$scope', BasicCtrl]);

function BasicCtrl($scope) {

}


angular.module('c')
    .controller('HelpCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                      HelpPage, HelpContent, Table) {
        $scope.cols = [
            {title: '标题', filter: {title: 'text'}, show: true}, //0
            {title: '链接', width: '55%', show: true}
        ];

        $scope.optColWidth = 73;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.pages) {
                    HelpPage.query(function (data) {
                        angular.forEach(data, function (page) {
                            page.items = [];
                        });
                        $scope.pages = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.pages;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.pages = null;
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.save(page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.edit = function (page) {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {page: page}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.update({id: page.id}, page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.delete = function (page) {
            dialogs.confirm('删除页面', '确定要删除页面<strong>' + page.title + '</strong>吗?')
                .result.then(function () {
                HelpPage.delete({id: page.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.visible = function (item, query) {
            return !(query && query.length > 0
            && item.title.indexOf(query) == -1);
        };

        function convert2MenuItem(items, menu) {
            angular.forEach(items, function (item) {
                var menuItem = {page_id: item.id, subject: item.title};
                menu.children.push(menuItem);
                if (item.items && item.items.length > 0) {
                    menuItem.children = [];
                    convert2MenuItem(item.items, menuItem);
                }
            });
        }

        $scope.save = function (content) {
            var menu = {children: []};
            convert2MenuItem(content, menu);
            HelpContent.save({menu: menu}, function (content) {
                toaster.success('保存成功');
            });
        };

        function convert2Item(menus, content) {
            angular.forEach(menus, function (menu) {
                var item = {id: menu.page.id, title: menu.page.title, items: []};
                content.push(item);
                if (menu.children && menu.children.length > 0) {
                    convert2Item(menu.children, item.items);
                }
            });
        }

        $scope.contentReload = function () {
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                var content = [];
                if (resp.root && resp.root['1']) {
                    var children = resp.root['1'].children;
                    convert2Item(children, content);
                }
                $scope.content = content;
            });
        };

        $scope.contentReload();
    });


angular.module('c').controller('PageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $http, toaster, data) {
        if (data.page) {
            $scope.page = data.page;
            var url = $sce.getTrustedResourceUrl(data.page.url);
            $http.get(url + "?" + new Date().toString()).success(function (resp) {
                $scope.page.body = resp;
            });
            $scope.$edit = true;
        } else {
            $scope.page = {title: ''};
        }

        $scope.ok = function (page) {
            if (page.title == '') {
                toaster.warning('标题不能为空');
            } else if (page.body == '') {
                toaster.warning('内容不能为空');
            } else {
                $uibModalInstance.close(page);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('MajorCtrl', MajorCtrl)

    ;


    function MajorCtrl($scope, $q, Api, dialogs, Major) {
        var vm = $scope;
        vm.add = add;
        vm.ok = ok;
        vm.save = save;
        vm.rmItem = rmItem;
        vm.reload = reload;
        //vm.remove = remove;

        init();


        function init() {
            vm.types = [];
            vm.op = {};
            reload();
        }

        function add(parent) {
            var nItem = {name: '新专业', children: []};
            nItem.nameChange = nItem.name;
            vm.op.eItem = nItem;
            if (angular.isDefined(parent)) {
                parent.children.push(nItem);
            } else {
                vm.types.push(nItem);
            }
        }

        function ok(item) {
            if (item.nameChange) {
                item.name = item.nameChange;
                vm.op.eItem = null;
            }
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                delete type.nameChange;
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
        }

        function save(types) {
            var defer = $q.defer();
            vm.op.eItem = null;
            convert(types);
            Major.save(types, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;

                Api.s(resp.msg);

                defer.resolve();
            });
            return defer.promise;
        }

        function rmItem(item, rmFn, self) {
            if (item.id) {
                dialogs.confirm('删除专业类型', '确定要删除<strong>' + item.name + '</strong>类型吗？')
                    .result.then(function () {
                    Major.delete({id: item.id}, function (resp) {
                        if (resp.result != 0) {
                            Api.w(resp.msg);
                        } else {
                            rmFn(self);
                        }
                    });
                });
            }
            else {
                rmFn(self);
            }
        }

        function reload() {
            var defer = $q.defer();
            Major.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                defer.resolve();
            });
            return defer.promise;
        }


    }


})();


(function () {
    'use strict';
    angular.module('c')
        .controller('SignCtrl', SignCtrl)
        .controller('SealDlgCtrl', SealDlgCtrl)
        .controller('SignDlgCtrl', SignDlgCtrl);

    function SignCtrl($scope, Dlg, User, UserType, Table, FileHelper, PrintHelper) {
        var vm = $scope;
        vm.setSign = setSign;
        vm.setSeal = setSeal;
        vm.print = print;
        vm.export = exportAllDepts;

        init();


        function init() {
            var options = {
                service: User,
                params: {op: 'sys_sign'},
                optColWidth: Table._2_BTN,
                hideOpt: true,
                cols: [{field: 'sn', title: '序号', width: Table._1_CHAR},
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "用户名", filter: {username: "text"}},
                    {field: "type", title: "类别", filter: {type_id: "select"}, width: Table._1_CHAR},
                    {field: "dept", title: "部门", filter: {dept: "text"}, width: Table._3_CHAR},
                    {field: "sign", title: "签名", filter: {no_sign: "checkbox"}, data: '未传', width: Table._5_CHAR},
                    {field: "seal", title: "印鉴", filter: {no_seal: "checkbox"}, data: '未传', width: Table._5_CHAR}
                ]
            };

            var optionFn = Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    if (item.signature) {
                        item.sign = item.signature.sign;
                        item.seal = item.signature.seal;
                    }
                });
            }).options;

            UserType.query(function (resp) {
                optionFn().cols[3].data = Table.getNgTableOpts(resp);
            });
        }

        function setSign(m) {
            Dlg.show({
                template: 'SignDlg.html', ctrl: 'SignDlgCtrl',
                data: {id: m.id}
            }).then(function (sign) {
                m.sign = sign;
            });
        }

        function setSeal(m) {
            Dlg.show({
                template: 'SealDlg.html', ctrl: 'SealDlgCtrl',
                data: {id: m.id}
            }).then(function (seal) {
                m.seal = seal;
            });
        }

        function exportAllDepts(justSign) {
            FileHelper.dnExcel(User.urls.EXPORT_DEPT_NOT_SIGN, {justSign: justSign}, '全公司核算部门未签名名单.xls');
        }

        function print() {
            PrintHelper.print(window.open(), PrintHelper.STYLE.TEMP2, function () {
                var html = '<html><body><table><tbody>';
                html += '<tr><td>用户名</td>';
                html += '<td>姓名</td>';
                html += '<td>签名</td>';
                html += '<td>印章</td></tr>';
                angular.forEach(vm.tableParams.settings().$scope.$data, function (user) {
                    html += '<tr>';
                    html += '<td>' + user.username + '</td>';
                    html += '<td>' + user.name + '</td>';

                    if (user.sign) {
                        html += '<td><img height="50" width="160" src="' + user.sign + '"/></td>';
                    } else {
                        html += '<td></td>';
                    }
                    if (user.seal) {
                        html += '<td><img height="50" width="160" src="' + user.seal + '"/></td>';
                    } else {
                        html += '<td></td>';
                    }
                    html += '</tr>';
                });
                html += '</tbody></table></body></html>';
                return html;
            });
        }

    }

    function SignDlgCtrl($scope, $uibModalInstance, User, Dlg, data) {
        var vm = $scope;
        vm.image = {croppedDataUrl: ''};
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(image) {
            User.update({id: data.id}, {
                op: 'sys_sign',
                sign: image.croppedDataUrl
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close(image.croppedDataUrl);
            }, function (err) {
                if (err.data.msg) Dlg.e(err.data.msg);
            });
        }
    }

    function SealDlgCtrl($scope, $uibModalInstance, User, Dlg, data) {
        var vm = $scope;
        vm.image = {croppedDataUrl: ''};
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(image) {
            User.update({id: data.id}, {
                op: 'sys_seal',
                seal: image.croppedDataUrl
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close(image.croppedDataUrl);
            }, function (err) {
                if (err.data.msg) Dlg.e(err.data.msg);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptRecordCtrl', DeptRecordCtrl);

    /** @ngInject */
    function DeptRecordCtrl($scope, Table, UserDept) {
        var vm = $scope;

        init();


        function init() {
            var options = {
                service: UserDept,
                params: {opt: '3'},
                hideOpt: true,
                showSn: true,
                sorting: {entry_time: 'desc'},
                items: 'depts',
                cols: [
                    {title: '部门名称', field: 'name'},
                    {title: '部门内职务', field: 'post'},
                    {title: '是否主部门', field: 'is_main'},
                    {title: '进入时间', field: 'entry_time', sortable: 'entry_time'},
                    {title: '离开时间', field: 'leave_time', sortable: 'leave_time'}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.depts, function (m) {
                    m.is_main = m.is_main == '1';
                });
            });
        }
    }

})();




angular.module('c')
    .controller('UserHelpCtrl', function ($scope, $sce, $http,
                                          HelpPage, HelpContent, DateHelper, F) {

        HelpPage.query(function (data) {
            $scope.pages = data;
            if (data.length > 0) {
                var page = data[0];
                $scope.selectPage(page);
            }
        });

        HelpContent.get({id: 1}).$promise.then(function (resp) {
            if (resp.root && resp.root['1']) {
                $scope.content = resp.root['1'].children;
            }
        });

        $scope.selectPage = function (page) {
            var time = DateHelper.datetime2Str(new Date(), 'yyMMddHHmmss');
            var url = $sce.getTrustedResourceUrl(page.url + "?" + time);
            $http.get(url).success(function (resp) {
                $scope.curPage.body = $sce.trustAsHtml(resp);
            });
            $scope.curPage = page;
        }

    });


(function() {
    'use strict';

    angular.module('c')
        .controller('ProfileCtrl', ProfileCtrl)
        .controller('ContactInfoCtrl', ContactInfoCtrl)
        .controller('PasswordDlgCtrl', PasswordDlgCtrl);

    /** @ngInject */
    function ProfileCtrl($rootScope, $stateParams, $scope, User, Auth, Dlg, ArrayHelper) {
        var account = Auth.getAccount();
        var vm = $scope;
        vm.reload = reload;
        vm.addUserPhoto = addUserPhoto;
        vm.changePasswd = changePasswd;
        vm.editContact = editContact;

        init($stateParams.data.requireChangePasswd);


        function init(requireChangePasswd) {
            reload(requireChangePasswd);
        }

        function reload(requireChangePasswd) {
            User.get({id: '-'}, function(resp) {
                var user = resp.item;
                user.edu_bg = ArrayHelper.getItem(user.edu_bg, User.getEduBgList());
                user.en_lv = ArrayHelper.getItem(user.en_lv, User.getEnLvList());
                user.pt_edu_bg = ArrayHelper.getItem(user.pt_edu_bg, User.getEduBgList());
                user.pt_en_lv = ArrayHelper.getItem(user.pt_en_lv, User.getEnLvList());
                if (user.title_id) user.title = ArrayHelper.getItem(user.title_id, User.getTitles());
                if (user.signature) user.sign = user.signature.sign;
                vm.user = user;

                if (requireChangePasswd) {
                    Dlg.show({
                        template: 'password_dlg.html',
                        ctrl: 'PasswordDlgCtrl',
                        data: {id: '-', requireChangePasswd: requireChangePasswd}
                    });
                }
            });
        }

        function addUserPhoto(user) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: user.id}
            }).then(function(resp) {
                account.photo = user.photo = resp[0];
                $rootScope.header.account = account;
                Auth.setAccount(account);
            });
        }

        function changePasswd() {
            Dlg.show({
                template: 'password_dlg.html',
                ctrl: 'PasswordDlgCtrl',
                data: {id: '-'}
            });
        }

        function editContact(user) {
            Dlg.show({
                template: 'pages/user/profile/contactInfoDlg.html',
                ctrl: 'ContactInfoCtrl',
                data: {user_id: user.id},
                size: 'md'
            }).then(function() {
                reload();
            });
            // account.more_contact_info = false;
            // Auth.setAccount(account);
        }
    }

    /** @ngInject */
    function PasswordDlgCtrl($uibModalInstance, Dlg, data, FormHelper, User) {

        var vm = this;
        vm.m = {id: data.id};
        vm.requireChangePasswd = data.requireChangePasswd;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                User.update({id: m.id}, {password: m.password, op: 'password'})
                    .$promise.then(function(resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                    // if (m.toUserInfoChangeDoc) {
                    //     // 4 表示“个人信息纠正申请”公文，金堂专属
                    //     UIHelper.tabTo('new', {op: 'loadType', type: 4}, 'app.coop_doc');
                    // }
                }, function(error) {
                    if (error.data.msg) Dlg.e(error.data.msg);
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }

    /** @ngInject */
    function ContactInfoCtrl(FormHelper, $uibModalInstance, Dlg, User, data, $q, ArrayHelper,
                             DeptGroup, DateHelper, $scope) {
        var vm = this;
        vm.ok = ok;
        var helper = User.formHelper;
        vm.cancel = $uibModalInstance.dismiss;
        var required = {
            status: true, entryTime: true, startedWork: false, annualDays: true
        };
        init();


        function init() {
            helper.init(vm, $scope);

            vm.cfg = {
                disable: {
                    dept: true,
                    company: true,
                    phone: true,
                    status: true,
                    post: true,
                    cardre: true,
                },
                enableTransferDept: false,
                hideUpdateAnnualChecker: true,
                hideChangeNote: false,
                required: required
                // contactBodyStyle: {height: '280px'} // 下面再设置
            };

            $q.all([
                User.get({id: data.user_id, op: 'default'}).$promise,
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function(respArray) {
                var m = respArray[0].item;
                helper.bindAsyncOptions(vm, respArray[1]);

                m.edu_bg = ArrayHelper.getItem(m.edu_bg, vm.edu_bgs);
                m.degree = User.getDegree(m.degree);
                m.en_lv = ArrayHelper.getItem(m.en_lv, vm.en_lvs);
                m.entry_time = DateHelper.str2Date(m.entry_time);
                m.started_work = DateHelper.str2Date(m.started_work);

                m.pt_edu_bg = ArrayHelper.getItem(m.pt_edu_bg, vm.edu_bgs);
                m.pt_degree = User.getDegree(m.pt_degree);
                m.pt_en_lv = ArrayHelper.getItem(m.pt_en_lv, vm.en_lvs);
                if (m.party_time) m.party_time = DateHelper.str2Date(m.party_time);
                if (m.title_id) m.title = ArrayHelper.getItem(m.title_id, vm.titles);

                vm.calcAnnualTotal(m);

                vm.cfg.workBodyStyle = {height: '100%'};
                console.log(123);
                DeptGroup.query({op: 'option', dept_id: m.dept_id}, function(resp) {
                    var groups = resp.items;
                    groups.splice(0, 0, {id: null,name: '无'});
                    vm.groups = groups;
                });
                vm.m = m;
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var pa = helper.loadParams(m, 'contact_info');

                if (m.group) pa.group_id = m.group.id;
                if (m.title) pa.title_id = m.title.id;

                User.update({id: m.id}, pa).$promise.then(function(resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function(error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('adminGroupSelector', adminGroupSelector);

    /** @ngInject */
    function adminGroupSelector(AdminGroup) {
        return {
            templateUrl: 'directives/form/admin-group-selector/groupSelector.html',
            restrict: 'E',
            // replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;

                init();


                function init() {
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    AdminGroup.query({op: 'option'}).$promise.then(function (resp) {
                        vm.groups = resp.items;
                    });
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model, clear) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }

                function checkValidity() {
                    var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .directive('deptSelector', deptSelector)
        .controller('DeptSelectCtrl', DeptSelectCtrl);

    /** @ngInject */
    function deptSelector(Dlg) {
        return {
            templateUrl: 'directives/form/dept-selector/dept-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                updateMod: '=?', // 是否修改模式，否则是追加模式
                multiSelect: '=?',
                existDepts: '=?',
                placeHolder: '@',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    vm.updateMod = angular.isDefined(iAttrs.updateMod);

                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                            return !vm.model || vm.model.length === 0;
                        } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.updateMod)) vm.updateMod = false;
                    if (angular.isUndefined(vm.multiSelect)) vm.multiSelect = false;
                    if (angular.isUndefined(vm.existDepts)) vm.existDepts = [];
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择部门';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectDeptFn(multiSelect, existDepts) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/dept-selector/dept_selector_dlg.html',
                        ctrl: 'DeptSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existDepts: existDepts,
                            updateMod: vm.updateMod
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (vm.updateMod) {
                                    vm.model = params;
                                } else {
                                    angular.forEach(params, function (dept) {
                                        vm.model.push(dept);
                                    });
                                }
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function DeptSelectCtrl($scope, $uibModalInstance, ArrayHelper, DeptType, Dept, data) {
        var vm = $scope;
        var updateMod;
        vm.selectTypes = [
            {id: 1, name: '按部门选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.typeSelectedFn = typeSelectedFn;
        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.selectTypeDepts = selectTypeDepts;
        vm.selectDepts = selectDepts;
        vm.removeSelected = removeSelected;
        vm.clearQuery = clearQuery;
        vm.queryDept = queryDept;
        vm.selectDept = selectDept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '部门选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.updateMod)) {
                updateMod = false;
            } else {
                updateMod = data.updateMod;
            }
            if (angular.isUndefined(data.existDepts)) {
                data.existDepts = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) data.model = [];
            }
            if (vm.multiSelect && updateMod) {
                vm.selected = angular.copy(data.model);
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        //
        function selectDept(dept) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(dept.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(dept);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, dept);
                } else {
                    vm.selected.push(dept);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'option'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        tagHideIfInExist(items);
                        type.depts = items;
                        toggle(node);
                    }
                });
            }
        }

        function selectTypeDepts(type, $event) {
            $event.stopPropagation();
            if (type.depts) {
                vm.selectDepts(type.depts);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        tagHideIfInExist(items);
                        type.depts = items;
                        vm.selectDepts(type.depts);
                    }
                });
            }
        }

        function selectDepts(depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function clearQuery() {
            vm.depts = [];
            vm.filterName = '';
        }

        function queryDept(name) {
            if (name && name.length > 0) {
                vm.filterName = name;
                vm.loading = true;
                Dept.ov.query({opt: 4, name: name}, function (resp) {
                    var depts = resp.depts;
                    tagHideIfInExist(depts);
                    vm.depts = depts;
                }).$promise.finally(function () {
                    vm.loading = false;
                });
            } else {
                // toaster.warning('请输入部门名称');
                clearQuery();
            }
        }

        function tagHideIfInExist(depts) {
            angular.forEach(depts, function (dept) {
                if (ArrayHelper.indexOfKey(dept.id, data.existDepts) !== -1 ||
                    (!updateMod && vm.multiSelect && ArrayHelper.indexOfKey(dept.id, data.model) !== -1)) {
                    dept.hide = true;
                }
            });
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();
angular.module('c')
    .directive('formInputDate', function () {
        return {
            templateUrl: 'directives/form/form-input-date/form-input-date.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'minMode':'@',
                'mode':'@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.minMode)) {
                    $scope.minMode = 'day';
                }

                if (angular.isUndefined($scope.mode)) {
                    $scope.mode = 'year';
                }

                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c')
    .directive('formInputDatetime', function () {
        return {
            templateUrl: 'directives/form/form-input-datetime/form-input-datetime.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c')
    .directive('formInputFloat', function () {
        return {
            templateUrl: 'directives/form/form-input-float/form-input-float.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'decimal': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'labelTip': '@',
                'tip': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }
            }
        }
    });
angular.module('c')
    .directive('formInputNumber', function () {
        return {
            templateUrl: 'directives/form/form-input-number/form-input-number.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@',
                'labelCol': '@',
                'formCol': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }

                if ($scope.labelCol == undefined || $scope.labelCol == null) {
                    $scope.labelCol = "col-md-4 control-label";
                }

                if ($scope.formCol == undefined || $scope.formCol == null) {
                    $scope.formCol = "col-md-6";
                }
            }
        }
    });
angular.module('c')
    .directive('formInputText', function () {
        return {
            templateUrl: 'directives/form/form-input-text/form-input-text.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'maxLen': '@',
                'minLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@'
            }

        }
    });
// function inputTableItemPaste(e) {
//     var scope = angular.element(e.srcElement).scope();
//     scope.itemsPaste(e, scope.$parent.$index, scope.$index);
//     e.preventDefault = true;
//     return false;
// }

(function () {
    'use strict';

    angular.module('c')
        .directive('inputTable', inputTable);

    function inputTable() {
        return {
            templateUrl: 'directives/form/inputTable/inputTable.html',
            // replace: true,
            restrict: 'EA',
            scope: {
                cols: '=',
                rows: '=',
                $data: '=ngModel',
                changed: '&',
                params: '='
            },
            require: ['^ngModel', '?^form'],
            link: link
        }
    }


    function link(scope, iElement, iAttrs, r) {
        var ngModelCtrl = r[0], formCtrl = r[1];
        var vm = scope;
        var rowCnt = vm.rows;
        var colCnt = vm.cols.length;
        vm.rowCnt = new Array(rowCnt);

        // vm.itemsPaste = itemsPaste;

        init();


        function init() {
            if (angular.isUndefined(vm.$data)) {
                vm.$data = {};
            } else {
                for (var key in vm.$data) {
                    if (isNaN(parseInt(key))) {
                        delete vm.$data[key];
                    }
                }
            }

            if (formCtrl) {
                scope.$watch(function () {
                    return formCtrl.$submitted;
                }, function (submitted) {
                    if (submitted) {
                        checkValidity(vm.$data);
                        iElement.addClass('submitted')
                    }
                });
            }
        }

        // function updateData(row, col, data) {
        //     for (var nr in data) {
        //         for (var nc in data[nr]) {
        //             var r = parseInt(row) + parseInt(nr);
        //             var c = parseInt(col) + parseInt(nc);
        //             if (c < colCnt && r < rowCnt) {
        //                 if (!vm.$data[r]) vm.$data[r] = {};
        //                 vm.$data[r][c] = data[nr][nc];
        //             }
        //         }
        //     }
        // }
        //
        // function itemsPaste(e, row, col) {
        //     if (e && e.clipboardData && e.clipboardData.getData) {
        //         var text = e.clipboardData.getData('text/plain');
        //         var data = [];
        //         var rows = text.split("\n");
        //         for (var r in rows) {
        //             data.push(rows[r].split("\t"));
        //         }
        //         updateData(row, col, data);
        //     }
        //     return false;
        // }

        function checkValidity($data) {
            var valid = true;
            if (!!iAttrs.required) {
                valid = !angular.equals($data, {});
            }
            ngModelCtrl.$setValidity('required', valid);
        }


        scope.$watch('$data', function ($data) {
            for (var i = 0; i < rowCnt; i++) {
                if ($data[i]) {
                    for (var j = 0; j < colCnt; j++) {
                        if ($data[i][j] === "") {
                            delete $data[i][j];
                        }
                    }
                    if (angular.equals($data[i], {})) {
                        delete $data[i];
                    }
                }
            }

            checkValidity($data);
            ngModelCtrl.$setTouched();
            if (vm.changed) {
                vm.changed({params: vm.params});
            }

        }, true);

    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('userSelector', userSelector)
        .controller('UserSelectCtrl', UserSelectCtrl);

    /** @ngInject */
    function userSelector(ArrayHelper, Dlg) {
        return {
            templateUrl: 'directives/form/user-selector/user-selector.html',
            restrict: 'E',
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                min: "=?",
                max: '=?',
                maxLimit: '@', // 限制只能选择max人，多的自动截取
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                disabled: '=?',
                showDutyGroupMember: '=?',
                // showMeetingAbsentUser: '=?',
                // meetingId: '=?',
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;
                vm.removeAll = removeAll;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.showDutyGroupMember)) {
                        vm.showDutyGroupMember = false;
                    }
                    // if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                    //     vm.showMeetingAbsentUser = false;
                    // }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        var min = vm.min > 0 ? vm.min : 0;
                        var max = angular.isDefined(vm.max) ? vm.max : 9999;
                        var minValid, maxValid;
                        if (iAttrs.required) {
                            if (ngModelCtrl.$viewValue) {
                                minValid = ngModelCtrl.$viewValue.length >= min;
                                maxValid = ngModelCtrl.$viewValue.length <= max;
                            } else {
                                minValid = maxValid = true;
                            }
                            valid = ngModelCtrl.$viewValue.length > 0;
                        } else {
                            valid = true;
                        }
                        if (min > 0) ngModelCtrl.$setValidity('min', minValid);
                        if (angular.isDefined(vm.max)) ngModelCtrl.$setValidity('max', maxValid);
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/user-selector/user_selector_dlg.html',
                        ctrl: 'UserSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                            showDutyGroupMember: vm.showDutyGroupMember,
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (angular.isDefined(vm.maxLimit) && vm.max > 0 && params.length > vm.max) {
                                    vm.model = params.splice(0, vm.max);
                                    scope.$emit('userSelector.maxLimit', {id: iAttrs.id, max: vm.max});
                                } else vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }

                function removeAll($event) {
                    $event.stopPropagation();
                    vm.model = ArrayHelper.filter(vm.model, function (item) {
                        return item._fixed;
                    });
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function UserSelectCtrl($scope, $uibModalInstance, $localStorage, ArrayHelper, Api, DeptType, Dept, User,
                            AdminGroup, ContactGroup, data, $q, DeptGroup) {
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.selectTypes = [
            {id: 1, name: '部门', exAll: false, fresh: true},
            {id: 3, name: '姓名/用户名', fresh: true},
            // {id: 4, name: '科管组', fresh: true},
            {id: 5, name: '群', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleDeptTypeNode = toggleDeptTypeNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleDeptGroupNode = toggleDeptGroupNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectDeptMembers = selectDeptMembers;
        vm.selectTypeMembers = selectTypeMembers;
        vm.selectContactGroupMembers = selectContactGroupMembers;

        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;
        vm.removeSelected = removeSelected;
        vm.removeAll = removeAll;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;

        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;


        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '员工选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }

            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];
            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            // if (angular.isUndefined(data.showMeetingAbsentUser)) {
            //     vm.showMeetingAbsentUser = false;
            // } else {
            //     vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            // }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            // if (data.showMeetingAbsentUser) {
            //     vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            // }
            var initIdx = $localStorage.userSelectTypeIdx;
            vm.curTypeId = initIdx ? initIdx : 0;
            vm.typeSelectedFn(vm.curTypeId);
        }

        function typeSelectedFn($index) {
            $localStorage.userSelectTypeIdx = $index;
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    op: 'search',
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.queryStr = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                    tagHideIfInExistMembers(vm.users);
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({op: 'contact'}, function (resp) {
                vm.depts = resp.items;
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                        tagHideIfInExistMembers(item.group.members);
                    }
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                cacheGroup = resp.groups;
                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }).$promise.finally(function () {
                vm.loading = false;
            });
        }

        function tagDeptLeaderAndHide(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
            tagHideIfInExistMembers(dept.members);
        }

        function toggleDeptTypeNode(type, toggle, node) {
            if (type.depts) {
                toggle(node);
            } else {
                DeptType.getDepts(type.id).then(function (resp) {
                    var items = resp.data.items;
                    if (items.length > 0) {
                        type.depts = items;
                        toggle(node);
                    }
                });
            }
        }

        function toggleDeptGroupNode(toggle, node) {
            toggle(node);
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);
                        toggle(node);
                    }
                });
                // Dept.getMembers(dept.id).then(function (resp) {
                //     var items = resp.data.items;
                //     if (items.length > 0) {
                //         dept.members = items;
                //         dept.mail_recipient_id = resp.data.mail_recipient_id;
                //         tagDeptLeaderAndHide(dept);
                //         toggle(node);
                //     }
                // });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            toggle(node);
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                $q.all([
                    DeptGroup.query({op: 'option', dept_id: dept.id}).$promise,
                    Dept.getMembers(dept.id)
                ]).then(function (respArray) {
                    var items = respArray[1].data.items;
                    if (items.length > 0) {
                        vm.selectUsers(items);

                        var groups = []; // 部门小组
                        var no = [];     // 没有部门小组的人员
                        if (respArray[0].items.length > 0) {
                            angular.forEach(respArray[0].items, function (group) {
                                var array1 = [];  // 有部门小组的人
                                var array2 = [];  // 没有...
                                angular.forEach(items, function (item) {
                                    if (item.group_id) {
                                        if (item.group_id === group.id) {
                                            if (item.id == group.user_id) {
                                                array1.unshift(item)
                                            } else {
                                                array1.push(item);
                                            }
                                        }
                                    } else {
                                        array2.push(item);
                                    }
                                });
                                groups.push({
                                    group: group,
                                    members: array1
                                });
                                no = array2;
                            });
                            dept.members = no.concat(groups);
                        } else {
                            dept.members = items;
                        }

                        dept.mail_recipient_id = respArray[1].data.mail_recipient_id;
                        tagDeptLeaderAndHide(dept);

                    }
                })
            }
        }

        function selectTypeMembers(type, $event) {
            angular.forEach(type.depts, function (dept) {
                $event.stopPropagation();
                if (dept.members) {
                    vm.selectUsers(dept.members);
                } else {
                    Dept.getMembers(dept.id).then(function (resp) {
                        var items = resp.data.items;
                        if (items.length > 0) {
                            dept.members = items;
                            dept.mail_recipient_id = resp.data.mail_recipient_id;
                            tagDeptLeaderAndHide(dept);
                            vm.selectUsers(dept.members);
                        }
                    });
                }
            });

        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                tagHideIfInExistMembers(members);
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (m.members && m.members.length > 0) {
                    angular.forEach(m.members, function (user) {
                        if (!user.hide) selectUser(user);
                    });
                } else {
                    if (!m.hide) selectUser(m);
                }
            });
        }

        function tagHideIfInExistMembers(members) {
            if (data.existMembers && data.existMembers.length > 0) {
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                        m.hide = true;
                    }
                });
            }
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();

angular.module('c')
    .directive('advice', function () {
        return {
            templateUrl: 'directives/main/advice/advice.html',
            restrict: 'E',
            replace: true,
            scope: {
                'warning': '@',
                'danger': '@'
            }
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('baseData', baseData)
        .controller('BaseDataDlgCtrl', BaseDataDlgCtrl);


    function baseData() {
        return {
            templateUrl: 'directives/main/base-data/base-data.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'service': '@',
                'maxProtectId': '@'
            },
            controller: baseDataCtrl
        };
    }


    /** @ngInject */
    function baseDataCtrl($scope, $injector, Api, Table) {
        var vm = $scope;
        var service = $injector.get(vm.service);
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();

        function init() {
            if (angular.isUndefined(vm.maxProtectId)) {
                vm.maxProtectId = 0;
            } else {
                vm.maxProtectId = parseInt(vm.maxProtectId);
            }

            Table.load(vm, {
                service: service,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                hideFilter: true,
                optInFront: true,
                cols: [
                    {field: "name", title: "名称"},
                    {field: "sorting", title: "排序"}
                ]
            });
        }

        function remove(m) {
            Api.delTableItem(service, m.id, vm, vm.title, m.name);
        }

        function setStop(m) {
            Api.setStop(service, m);
        }

        function addEdit(m) {
            Api.addEdit(vm, 'BaseDataDlg', 'BaseDataDlgCtrl', m, {service: service, title: vm.title});
        }
    }

    function BaseDataDlgCtrl($scope, $uibModalInstance, $q, Dlg, data) {
        var vm = $scope;
        var service = data.service;
        vm.title = data.title;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);


        function loadModel(id) {
            if (id) {
                vm.m = service.get({id: id});
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                Dlg.w('表单中有错误!');
                vm.Form.submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();

angular.module('c')
    .directive('basicDataTable', function () {
        var controller = function ($rootScope, $scope, $filter, $injector, dialogs, toaster, NgTableParams, Table) {
            var Data = $injector.get($scope.serverName);
            if (angular.isUndefined($scope.maxProtectId)) {
                $scope.maxProtectId = 0;
            } else {
                $scope.maxProtectId = parseInt($scope.maxProtectId);
            }
            var item = $scope.title;

            $scope.optColWidth = 56;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10,
                sorting: {
                    sorting: 'asc'
                }
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    if (!$scope.cachedData) {
                        Data.query(function (data) {
                            $scope.cachedData = data;
                            angular.forEach(data, function (data) {
                                data.sorting = parseInt(data.sorting);
                                data.id = parseInt(data.id)
                            });
                            if (data.length > 0 && typeof data[0]['is_stop'] != 'undefined') {
                                $scope.has_stop = true;
                            }
                            Table.getTableData(data, $defer, params, $filter);
                        });
                    } else {
                        Table.getTableData($scope.cachedData, $defer, params, $filter);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.add = function () {
                dialogs.create('directives/main/basic-data-table/dataDlg.html', 'BasicDataDlgCtrl', {title: $scope.title}, {
                    size: 'md'
                }).result.then(function (data) {
                    Data.save(data).$promise.then(function (data) {
                        toaster.success(item + '添加成功!');
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '添加失败!');
                    })
                });
            };

            $scope.edit = function (data) {
                data.$edit = true;
                data.$nameChanged = data.name;
                data.$sortingChanged = data.sorting;
            };

            $scope.save = function (data) {
                data.$edit = false;
                if (data.$nameChanged == "") {
                    toaster.error(item + '名称不能为空!');
                } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged) {
                    var params = {};
                    params['name'] = data.$nameChanged;
                    params['sorting'] = data.$sortingChanged;
                    Data.update({id: data.id}, params).$promise.then(function () {
                        toaster.success(item + '修改成功!');
                        data.name = data.$nameChanged;
                        data.sorting = parseInt(data.$sortingChanged);
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function (error) {
                        toaster.error(item + '修改失败!');
                    });
                }
            };

            $scope.delete = function (data) {
                dialogs.confirm('删除' + item, '确定要删除<strong>' + data.name + '</strong>' + item + '吗?')
                    .result.then(function () {
                    Data.delete({id: data.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success(item + '删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该' + item + '的员工记录,因此无法删除该分类!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '删除失败!');
                    });
                });
            };
        };

        return {
            templateUrl: 'directives/main/basic-data-table/basic-data-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'serverName': '@',
                'maxProtectId': '@'
            },
            controller: controller
        }
    });
angular.module('c')
    .directive('breadcrumb', function () {
        return {
            templateUrl: 'templates/cache/breadcrumb.html',
            restrict: 'E',
            replace: true,
            scope: {
                'current': '@',
                'parent': '@'
            }
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('footer', footer);

    /** @ngInject */
    function footer(Auth) {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true,
            link: function (scope) {
                scope.vc = Auth.getVisitCnt();
            }
        }
    }
})();

/*angular.module('c')
    .directive('footer', function () {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true
        }
    });*/

(function () {
    'use strict';
    angular.module('c')
        .directive('header', function () {
            return {
                templateUrl: 'templates/cache/header.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'header'
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope, $state, $stateParams, $timeout, $http, $q, dialogs, C,
                  ArrayHelper, Auth, Email, Sidebar, toaster, $ocLazyLoad) {
        var vm = $rootScope.header = this;
        vm.toggleSidebar = Sidebar.toggle;
        //header-notification
        vm.mails = [];
        vm.tasks = [];
        vm.missions = [];
        vm.missionNote = '';
        vm.account = Auth.getAccount();
        var taskFnList = {
            23001: meetingLeaveFn,
            13009: carFillFn
        };
        var firstToggle = true;

        vm.toggleTaskD = toggleTaskD;
        vm.reloadTask = reloadTask;
        vm.reloadMail = reloadMail;
        vm.showMission = showMission;
        vm.reloadMission = reloadMission;
        vm.editMission = editMission;
        vm.saveMission = saveMission;
        vm.missionComplete = missionComplete;
        vm.toTask = toTask;
        vm.readMail = readMail;
        vm.logout = logout;

        init();


        function init() {
            $scope.$on(C.P + 'mail.withdraw', function (event, data) {
                var mail = data.data.mail;

                var i = ArrayHelper.indexOfKey(mail.id, vm.mails);
                if (i >= 0) {
                    vm.mails.splice(i, 1);
                }
            });

            $scope.$on('mail.send', function (event, data) {
                var mail = data;
                vm.mails.splice(0, 0, {id: mail.id, subject: mail.subject, created_at: mail.created_at});
            });

            $scope.$on('mailRead', function (event, data) {
                vm.mails = ArrayHelper.except(data, vm.mails);
            });

            $scope.$on('mailDel', function (event, data) {
                if (data) {
                    var id = data;
                    var i = ArrayHelper.indexOfKey(id, vm.mails);
                    if (i >= 0) {
                        vm.mails.splice(i, 1);
                    }
                } else {
                    loadUnreadMail();
                }
            });

            // $scope.$on('openTaskD', function () {
            //     vm.showArrow = true;
            // });

            $scope.$on('newTask', function (evt, data) {
                var task = data.task;

                if (firstToggle) {
                    firstToggle = false;
                    $http.post('/api/v1/task_all', {}).success(function (tasks) {
                        vm.tasks = tasks;
                        vm.hasTask = tasks.length > 0;
                        addTask(task);
                    });
                } else {
                    addTask(task);
                }

                function addTask(task) {
                    var index = ArrayHelper.indexOfKey(task.type, vm.tasks, 'type');
                    if (index === -1) {
                        task.isNew = true;
                        vm.tasks.unshift(task);
                    } else {
                        vm.tasks[index].isNew = true;
                        var tmp = vm.tasks[index];
                        vm.tasks[index] = vm.tasks[0];
                        vm.tasks[0] = tmp;
                    }
                    vm.hasTask = vm.tasks.length > 0;

                    document.getElementById('msgTone2').play();
                    vm.shakePoint = true;
                    $timeout(function () {
                        vm.shakePoint = false;
                    }, 2000);
                }

            });

            // 到main.js中统一加载
            $rootScope.$broadcast('headerLoaded');

            if ($stateParams.pendingDlgOpen === 'true') {
                vm.openTaskD = true;
                toggleTaskD();
            }
        }

        function meetingLeaveFn() {
            dialogs.create(C.T + 'meeting/leave.html', 'MeetingLeaveCtrl', {},
                {size: 'lg'});
        }

        function carFillFn() {
            dialogs.create('pages/dlg/car_manage/carFillDlg.html', 'CarFillCtrl', {},
                {size: 'lg'});
        }

        ////////////////////////////////////////////////////////////////////////
        ////////////////////////header-notification

        function toggleTaskD() {
            if (firstToggle) {
                reloadTask();
                firstToggle = false;
            }
        }

        function reloadMail() {
            var defer = $q.defer();
            vm.mailLoading = true;
            $http.get('/api/v1/emails', {params: {opt: 1}}).success(function (resp) {
                vm.mails = resp.mails;
                defer.resolve();
            }).finally(function () {
                vm.mailLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function showMission(m) {
            $ocLazyLoad.load('/ocLazyLoad/mod/mission.js').then(function () {
                dialogs.create('pages/dlg/mission/missionShowDlg.html', 'NewMissionShowDlgCtrl', {id: m.id}, {size: 'lg'}, 'vm');
            });
        }

        function reloadMission() {
            var defer = $q.defer();
            vm.missionLoading = true;
            $http.get('/api/v1/mission/missions', {params: {op: 'quick'}}).success(function (resp) {
                var items = resp.items;
                items.forEach(function (item) {
                    item.is_complete = false;
                });
                vm.missions = items;
                defer.resolve();
            }).finally(function () {
                vm.missionLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function editMission(m) {
            dialogs.create('pages/dialogs/comment/commentDlg.html', 'CommentDlgCtrl', {
                title: '修改任务名称',
                label: '任务名称'
            }, {size: 'md'}, 'vm')
                .result.then(function (msg) {
                $http.put('/api/v1/mission/missions/' + m.id, {
                    op: "edit_name",
                    name: msg
                }).success(function (resp) {
                    m.name = msg;
                    toaster.success('修改成功!');
                });
            });
        }

        function saveMission() {
            if (vm.missionAdding) return;
            var defer = $q.defer();
            if (angular.isUndefined(vm.missionNote) || vm.missionNote === '') {
                toaster.error('任务内容为空!');
                return;
            }

            vm.missionAdding = true;
            $http.post('/api/v1/mission/missions/quick', {
                params: {
                    op: 'quick',
                    note: vm.missionNote
                }
            }).success(function (resp) {
                toaster.success('添加成功!');
                vm.missionNote = '';
                reloadMission();
                defer.resolve();
            }).finally(function () {
                vm.missionAdding = false;
                defer.reject();
            });
            return defer.promise;
        }

        function missionComplete(m) {
            if (vm.missionLoading) return;
            console.log(m.is_complete);
            var state = m.state == 2 ? 3 : 2;
            $http.put('/api/v1/mission/missions/' + m.id, {
                op: "state_change",
                state_id: state
            }).success(function (resp) {
                m.state = resp.state;
                toaster.success('记录成功!');
            });
        }

        function reloadTask() {
            var defer = $q.defer();
            vm.taskLoading = true;
            $http.post('/api/v1/task_all', {}).success(function (tasks) {
                vm.tasks = tasks;
                vm.hasTask = tasks.length > 0;
                defer.resolve();
            }).finally(function () {
                vm.taskLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function loadUnreadMail() {
            // 只会拿最多10个
            Email.query({opt: 1}, function (resp) {
                vm.mails = resp.mails;
            });
        }

        function toTask(task, index) {
            //
            var pa = {tab: task.tag};
            vm.tasks.splice(index, 1);
            vm.hasTask = vm.tasks.length > 0;
            if (task.state) {
                if ($state.current.name === task.state) {
                    $rootScope.$broadcast("tabChange", pa);
                } else {
                    $state.go(task.state, pa);
                }
            } else {
                //function list
                var fn = taskFnList[task.type];
                if (fn) fn();
                else alert("该事件没有处理方法");
            }
        }

        function readMail(mail, $index) {
            if (mail.withdraw == 1) {
                dialogs.notify('确认', '该邮件已经被发送者撤回!');
            } else {
                dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                    {size: 'lg'}).result.then(function (params) {
                    switch (params.opt) {
                        case 1:
                            $state.go('app.message_email', {
                                tab: 'write',
                                data: {
                                    op: 'mailReply',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 2:
                            $state.go('app.message_email', {
                                tab: 'write',
                                data: {
                                    op: 'mailForward',
                                    mail: params.mail
                                }
                            });
                            break;
                        case 3:
                            Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                function () {
                                    vm.mails.splice($index, 1);
                                    $rootScope.$broadcast('mailDel', mail.id);
                                });
                            break;
                    }
                });
            }

        }

        function logout() {
            Auth.logout(function () {
                $state.go('login');
            });
        }
    }
})();

angular.module('c').
    directive('inputFloat', function ($filter) {
        var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
        var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
        var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
        var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }
                var decimal_digit = scope.$eval(attrs.inputFloat);

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var minus = val[0] == '-';
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (minus)
                        clean = '-' + clean;

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        }
    });
angular.module('c').
    directive('inputNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('messageRecipient', messageRecipient);

    function messageRecipient() {
        return {
            templateUrl: 'directives/main/message-recipient/message-recipient.html',
            restrict: 'E',
            scope: {
                // 表明是哪个部门的短信提醒人
                'type': '@',
                'title': '@',
                'desc': '@'
            },
            controller: controller
        }
    }

    /** @ngInject */
    function controller($scope, $q, toaster, MessageRecipient) {
        $scope.title = $scope.title ? $scope.title : '请假提醒人';
        $scope.desc = $scope.desc ? $scope.desc : '设置相应的短信提醒人';

        $scope.reload = function () {
            MessageRecipient.get({id: $scope.type}, function (resp) {
                var r = resp.item;
                if (!r) r = {id: $scope.type};
                $scope.r = r;
            });
        };

        $scope.submit = function (r) {
            var defer = $q.defer();
            if (r.id) {
                var params = {user_id: r.user ? r.user.id : null};
                MessageRecipient.update({id: r.id}, params).$promise.then(function () {
                    toaster.success('设置成功');
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    }

})();









(function () {
    'use strict';

    angular.module('c')
        .directive('sidebar', function () {
            return {
                templateUrl: 'templates/cache/sidebar.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'sidebar'
            }
        });

    /** @ngInject */
    function ctrl($scope, $rootScope, $state, Sidebar, Dlg) {
        var STATE = Sidebar.STATE;
        var lastWidth = window.innerWidth;
        var vm = this;
        vm.menuHeight = window.innerHeight - 50;
        vm.firstLvVisible = firstLvVisible;
        vm.secondLvVisible = secondLvVisible;
        vm.check = check;
        vm.subItemCollapse = subItemCollapse;
        vm.mouseOverMenuItem = mouseOverMenuItem;
        vm.mouseLeaveMenuItem = mouseLeaveMenuItem;
        vm.mouseWheelSubItem = mouseWheelSubItem;
        vm.clickSubItem = clickSubItem;

        init();


        function init() {
            $scope.$on('$destroy', function () {
                $(window).off('resize', _onWindowResize);
            });

            Sidebar.initState();

            Sidebar.bindState($scope);

            Sidebar.getMenuItems(function (menuItems) {
                vm.menuItems = menuItems;
            });

            $(window).on('resize', _onWindowResize);
        }

        function clickSubItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var subItem = angular.element(event.currentTarget);
            var wrapper = subItem.closest('.sub-item-wrapper');
            wrapper.hide();
        }

        function mouseWheelSubItem($event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            $event.stopPropagation();
        }

        function mouseOverMenuItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var menuItem = angular.element(event.currentTarget);
            var menuItemPos = menuItem.position();
            var submenuWrapper = $('> .sub-item-wrapper', menuItem);
            var height = submenuWrapper.outerHeight();
            var winHeight = window.innerHeight - 50;

            var secondUl = $('> .nav-second-level', submenuWrapper);
            if (height + 20 > winHeight) {
                height = winHeight - 20;
                secondUl.css({'height': height});
            } else {
                secondUl.css({'height': ""});
            }

            var top = menuItemPos.top - 26;
            if (top + height > winHeight) {
                top = winHeight - height;
            }
            submenuWrapper.css({
                top: top,
                left: menuItemPos.left + Math.round(menuItem.outerWidth() * 0.8),
                display: 'block'
            });
        }

        function mouseLeaveMenuItem(event) {
            if (Sidebar.getState() !== Sidebar.STATE.ICON_ONLY) return;
            var subItem = angular.element(event.currentTarget);
            var submenuWrapper = $('> .sub-item-wrapper', subItem);
            submenuWrapper.hide();
        }

        function subItemCollapse(index) {
            return Sidebar.getState() !== Sidebar.STATE.ICON_ONLY && $rootScope.collapseVar !== index
        }

        function _onWindowResize() {
            var newMenuHeight = window.innerHeight - 50;
            if (vm.menuHeight !== newMenuHeight) vm.menuHeight = newMenuHeight;

            var width = window.innerWidth;
            if (lastWidth < 1200 && width >= 1200) {
                Sidebar.updateState(STATE.VISIBLE);
            } else if (
                (lastWidth >= 1200 && width < 1200) ||
                (lastWidth < 992 && width >= 992)) {
                Sidebar.updateState(STATE.ICON_ONLY);
            } else if (lastWidth >= 568 && width < 568) {
                Sidebar.updateState(STATE.HIDDEN);
            }
            lastWidth = width;
        }

        function check(x) {
            if (x === $rootScope.collapseVar) {
                $rootScope.collapseVar = 0;
            } else {
                $rootScope.collapseVar = x;
            }
        }

        function firstLvVisible(item) {
            var search = vm.search;
            if (!search) return true;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) {
                if (secondLv) {  // 二级菜单检索
                    for (var i = 0; i < item.children.length; i++) {
                        var subItem = item.children[i];
                        if (subItem.display_name.indexOf(search) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                } else {
                    visible = item.display_name.indexOf(search) !== -1
                }
            }
            return visible;
        }

        function secondLvVisible(item) {
            var search = vm.search;
            if (!search) return item.state;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) { // 有输入
                visible = secondLv ? item.display_name.indexOf(search) !== -1 : true;
            }
            return visible && item.state;
        }

    }

})();

(function () {
    'use strict';

    angular.module('c').factory('Sidebar', Sidebar);

    function Sidebar($rootScope, $state, $timeout, $http, $q, ArrayHelper, Dlg) {
        var curState, cachedMenuItems, menuItemRequesting, menuReqDefers = [];
        var STATE = {
            HIDDEN: 0,
            ICON_ONLY: 1,
            VISIBLE: 2
        };

        return {
            STATE: STATE,
            updateState: updateState,
            toggle: toggle,
            bindState: bindState,
            initState: initState,
            getState: function () {
                return curState;
            },
            setupMenuItems: setupMenuItems,
            getMenuItems: getMenuItems,
            hasMenuItems: function () {
                return cachedMenuItems;
            }
        };

        function getMenuItems(successFn, failedFn) {
            if (cachedMenuItems) {
                if (successFn) successFn(cachedMenuItems);
            } else if (menuItemRequesting) {
                var defer = $q.defer();
                menuReqDefers.push(defer);
                defer.promise.then(function () {
                    if (successFn) successFn(cachedMenuItems);
                }, function (err) {
                    if (failedFn) failedFn(err);
                });
            } else {
                menuItemRequesting = true;
                $http.get('/api/v1/menu_items')
                    .success(function (menuItems) {
                        setupMenuItems(menuItems);
                        if (successFn) successFn(menuItems);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.resolve(menuItems);
                        });
                    })
                    .error(function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                        if (failedFn) failedFn(err);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.reject(err);
                        });
                    })
                    .finally(function () {
                        menuItemRequesting = false;
                        menuReqDefers = [];
                    });
            }
        }

        function setupMenuItems(menuItems) {
            var states = $state.get();
            angular.forEach(states, function (s) {
                s.can = angular.isUndefined(s.params);
            });

            var index = 0;
            angular.forEach(menuItems, function (item) {
                index++;
                angular.forEach(item.children, function (m) {
                    m.state = ArrayHelper.getItem(m.id, states, 'perm');
                    if (m.state) {
                        m.state.can = true;
                        m.state.index = index;
                    } else {
                        console.error('未注册菜单:', m.id);
                    }
                });
            });

            cachedMenuItems = menuItems;
        }

        function bindState(scope) {
            scope.$on('sidebarState', function (event, state) {
                $timeout(function () {
                    scope.sidebarState = state;
                });
            });
        }

        function toggle() {
            var width = window.innerWidth;
            if (width > 768) {
                if (curState === STATE.VISIBLE) {
                    updateState(STATE.ICON_ONLY);
                } else {
                    updateState(STATE.VISIBLE);
                }
            } else {
                if (curState === STATE.HIDDEN) {
                    updateState(STATE.VISIBLE);
                } else {
                    updateState(STATE.HIDDEN);
                }
            }
        }

        function updateState(state, force) {
            if (force || curState !== state) {
                curState = state;
                $rootScope.$broadcast('sidebarState', curState);
                var nav = $('#sidebar-nav');
                if (state === STATE.ICON_ONLY) {
                    $('.sub-item-wrapper', nav).css("display", "none");
                } else {
                    $('.nav-second-level', nav).css("height", "");
                    $('.sub-item-wrapper', nav).css("display", "");
                }
            }
        }

        function initState() {
            var state;
            var width = window.innerWidth;
            if (width > 768 && width <= 1200) {
                state = STATE.ICON_ONLY;
            } else if (width > 1200) {
                state = STATE.VISIBLE;
            } else {
                state = STATE.HIDDEN;
            }
            updateState(state, true);
        }
    }
})();

angular.module('c')
    .directive('tabInclude', [function ($parse) {
        var selfIndex = function (element) {
            var arr = element.parent().children();
            var val = element[0];
            var i = arr.length;
            while (i--) {
                if (val == arr[i]) return i;
            }
            return -1
        };

        return {
            require: ['^uibTab', '^uibTabset'],
            restrict: 'A',
            priority: 100,
            compile: function (element, attrs, transclude) {

                var elem = angular.element('<div></div>');
                elem.attr('ng-include', '$include[' + (attrs.ngRepeat ? '$index' : selfIndex(element)) + ']');
                element.append(elem);

                return function postLink(scope, element, attrs) {
                    if (scope.$include == null) {
                        scope.$include = [];
                    }
                    scope.$include.push('');
                    var isolatedScope = scope.$$childTail;
                    // element.isolateScope().$watch('active',
                    isolatedScope.$watch('active',
                        function (newValue) {

                            if (newValue) {
                                scope.$include[scope.$index ? scope.$index : selfIndex(element)] = attrs.tabInclude;
                            }
                        }
                    );
                };
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('tableOptionTab', tableOptionTab);

    function tableOptionTab() {
        return {
            templateUrl: 'directives/table/tableOptionTab/tableOptionTab.html',
            restrict: 'E',
            scope: {
                options: '=',
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@',
                redDot: '@',
                optionSelect: '&',
                noDataDesc: '@'
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope) {
        var parentCtrl = scope.$parent;
        scope.optionSelected = optionSelected;

        function optionSelected(option) {
            if (scope.optionSelect()) {
                scope.optionSelect()(option);
            } else {
                var filter = parentCtrl.tableParams.filter();
                scope.curOptionId = filter[scope.filterName] = option.id;
                if (!option.id) delete filter[scope.filterName];
                parentCtrl.tableParams.filter(filter);
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentDownload', attachmentDownload);

    /** @ngInject */
    function attachmentDownload($compile, Dlg, WxHelper, FileHelper, deviceDetector) {
        return {
            restrict: 'EA',
            scope: {
                attachmentDownload: '=attachmentDownload', // 作为属性时用这个，作为元素时用下面的model
                model: '=ngModel',
                customClass: '@customClass',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@'    // 模块名称
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {

                        var vm = scope;
                        var att = scope.model ? scope.model : scope.attachmentDownload;
                        var url;

                        vm.download = download;

                        init();


                        function init() {
                            if (scope.attachmentDownload) {
                                $(iElement).click(function () {
                                    download();
                                });
                            } else {
                                var original = iElement.html().trim();
                                if (!original) original = '下载';
                                var elem = '<span>' +
                                    '<a ng-class="customClass" ng-click="download()">' + original;
                                if (angular.isUndefined(iAttrs.hideLoading)) {
                                    elem += '<span ng-show="model.downloading" class="fa fa-circle-o-notch fa-spin text-muted"></span>';
                                }
                                elem += '</a></span>';

                                var layer = angular.element(elem);
                                var el = $compile(layer.contents())(scope);
                                iElement.replaceWith(el);
                            }


                            if (scope.url) {
                                url = scope.url;
                            } else {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "download";
                            }
                        }

                        function download() {
                            if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                                Dlg.show({
                                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                                    ctrl: 'attachmentDownloadDlgCtrl',
                                    data: {attachment: att, name: scope.name},
                                    size: 'sm'
                                });
                            } else {
                                var rename = scope.name ? {name: scope.name} : {};
                                FileHelper.download1(url, att, rename);
                            }
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('attachmentDownloadDlgCtrl', attachmentDownloadDlgCtrl);

    /** @ngInject */
    function attachmentDownloadDlgCtrl($scope, $uibModalInstance, UIHelper, $http, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.attachment, data.name);


        function init(att, name) {
            var attachment = {
                name: name ? name : att.name,
                filename: att.filename,
                mime: att.mime,
                size: att.size,
            };

            attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            attachment.size = parseInt(attachment.size);

            vm.attachment = attachment;

            $http.post('api/v1/file/download/mk_pub_link', {filename: attachment.filename})
                .success(function (resp) {
                    vm.url = resp;
                });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($compile, $http, ArrayHelper, Dlg, deviceDetector, OS) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];


        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                name: '@attachFieldName',
                customClass: '@customClass',
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var vm = scope;
                        vm.op = {};
                        vm.preview = preview;
                        var type = null;
                        var att = scope.model;
                        var name = scope.name ? att[scope.name] : att.name;

                        init();


                        function init() {
                            var original = iElement.html().trim();
                            if (!original) original = '预览';
                            // var elem =
                            //     '<span>' +
                            //     '<script type="text/ng-template" id="priviewLinkPopover.html">' +
                            //     '<div>苹果阻止了预览弹窗，点击<a ng-href="{{op.url}}" target="_blank">这里</a>进入</div>' +
                            //     '</script>' +
                            //     '<a ng-class="customClass" ng-if="type" ng-click="preview(op)" uib-popover-template="' +
                            //     "'priviewLinkPopover.html'" + '" popover-trigger="outsideClick" ' +
                            //     'popover-is-open="op.priviewLinkOpen">' + original + '</a></span>';
                            var elem =
                                '<span>' +
                                '<a class="attachment-preview" ng-class="customClass" ' +
                                'ng-if="type" ng-click="preview(op)"' + 'popover-trigger="outsideClick">' + original + '</a></span>';


                            var layer = angular.element(elem);
                            var el = $compile(layer.contents())(scope);
                            iElement.replaceWith(el);


                            // vm.ios = deviceDetector.os === OS.IOS;
                            // vm.os = deviceDetector.os;

                            if (!att.filename) return;
                            var extension = att.filename.split('.').pop().toLowerCase();
                            if (ArrayHelper.inArray(extension, office) !== -1) {
                                type = 1;  // office
                            } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                                type = 2;  // pdf
                            } else if (ArrayHelper.inArray(extension, img) !== -1) {
                                type = 3;  // img
                            }
                            vm.type = type;
                        }

                        function preview() {
                            $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                                .success(function (resp) {
                                    var docFullUrl = location.protocol + "//" + location.host + resp;
                                    var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl :
                                        "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + name;
                                    Dlg.show({
                                        template: 'pages/preview/showDlg.html',
                                        ctrl: 'PreviewShowDlgCtrl',
                                        data: {url: url},
                                        backdrop: false, size: 'full'
                                    });
                                }).error(function (err) {
                                if (err.msg) Dlg.e(err.msg);
                            });
                            // var windowReference;
                            // if (!vm.ios) {
                            //     windowReference = window.open();
                            //     op.priviewLinkOpen = false;
                            // }
                            // $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                            //     .success(function (resp) {
                            //         var url = "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + name;
                            //         if (vm.ios) {
                            //             // todo: 测试这句是否必须
                            //             op.priviewLinkOpen = true;
                            //             op.url = url;
                            //         } else {
                            //             windowReference.location = url;
                            //             op.priviewLinkOpen = false;
                            //         }
                            //     }).error(function (err) {
                            //     if (err.msg) Dlg.e(err.msg);
                            //     op.priviewLinkOpen = false;
                            //     windowReference.close();
                            // });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('backTop', backTop)
        .directive('contentBackTop', contentBackTop)
    ;

    /** @ngInject */
    function contentBackTop(UIHelper) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var e = element[0];

                var backTopIcon = '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>';
                backTopIcon = angular.element(backTopIcon);
                backTopIcon.css('position', 'fixed');
                backTopIcon.css('bottom', '80px');
                element.append(backTopIcon);
                backTopIcon.bind('click', function () {
                    UIHelper.scrollTo(undefined, e.id === '' ? undefined : e.id);
                });

                element.bind('scroll', function () {
                    var top = e.scrollTop;
                    if (top > 200) {
                        backTopIcon.fadeIn();
                    } else {
                        backTopIcon.fadeOut();
                    }
                });
            }
        };
    }

    /** @ngInject */
    function backTop() {
        return {
            restrict: 'E',
            template: '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>',
            controller: function () {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('dateSpinner', dateSpinner);

    /** @ngInject */
    function dateSpinner ($compile, DateHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                maxDate: '=',
                minDate: '=',
                mode: '@',
                maxDateToday: '@',
                onChange: '&'
            },
            require: ['^ngModel'],
            compile: function () {
                return {
                    pre: function prelink (scope, iElement, iAttrs, r) {
                        var mode = iAttrs.mode;
                        var maxDateToday = angular.isDefined(iAttrs.maxDateToday);
                        var vm = scope;
                        vm.prev = prev;
                        vm.next = next;
                        vm.testPrev = testPrev;
                        vm.testNext = testNext;

                        init();


                        function init () {
                            switch (mode) {
                                case 'day':
                                case 'month':
                                case 'year':
                                    vm.dateOptions = {datepickerMode: mode, minMode: mode};
                                    break;
                                default:
                                    vm.dateOptions = {datepickerMode: 'day'};
                                    if (mode !== 'week') mode = 'day';
                            }

                            if (maxDateToday) vm.dateOptions.maxDate = new Date();
                            else if (angular.isDefined(vm.maxDate)) vm.dateOptions.maxDate = vm.maxDate;

                            if (angular.isDefined(vm.minDate)) vm.dateOptions.minDate = vm.minDate;

                            if (!vm.model) vm.model = new Date();

                            scope.$watch('model', function (newValue) {
                                if (newValue) {
                                    // vm.dateText = getDateText(newValue, mode);
                                    var dateText = getDateText(newValue, mode);
                                    if (vm.dateText !== dateText) {
                                        if (vm.onChange) {
                                            vm.onChange({date: newValue, dateText: dateText});
                                        }
                                        vm.dateText = dateText;
                                    }
                                }
                            });

                            var elem =
                                '<span><div class="btn-group mr-2">' +
                                '<button ng-click="prev(model)" class="btn btn-default btn-sm btn-narrow" ng-disabled="!testPrev(model)">' +
                                '<i class="fa fa-angle-left text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="opened=true" class="btn btn-default btn-sm"' +
                                ' uib-datepicker-popup datepicker-popup-template-url="directives/ui/dateSpinner/temp.html"' +
                                ' datepicker-options="dateOptions"' +
                                ' ng-model="model" is-open="opened">' +
                                '<i class="fa fa-calendar text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="next(model)" style="margin-left:-1px" ' +
                                'class="btn btn-default btn-sm btn-narrow" ng-disabled="!testNext(model)">' +
                                '<i class="fa fa-angle-right text-muted"></i>' +
                                '</button>' +
                                '</div><span class="text-muted">{{dateText}}</span></span>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }

                        function getDateText (d, mode) {
                            switch (mode) {
                                case 'day':
                                    return DateHelper.date2Str(d, 'yyyy-MM-dd EEEE');
                                case 'week':
                                    var day = d.getDay();
                                    var dd = angular.copy(d);
                                    var monday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? -6 : 1)));
                                    var sunday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? 0 : 7)));
                                    return DateHelper.date2Str(monday) + ' - ' + DateHelper.date2Str(sunday);
                                case 'month':
                                    return DateHelper.date2Str(d, 'yyyy-MM');
                                case 'year':
                                    return DateHelper.date2Str(d, 'yyyy') + '年';
                            }
                        }

                        function prev (curr) {
                            vm.model = getPrev(curr);
                        }

                        function next (curr) {
                            vm.model = getNext(curr);
                        }

                        function testPrev (curr) {
                            if (angular.isUndefined(vm.dateOptions.minDate)) return true;
                            return getPrev(curr) >= vm.dateOptions.minDate;
                        }

                        function testNext (curr) {
                            if (angular.isUndefined(vm.dateOptions.maxDate)) return true;
                            return getNext(curr) <= vm.dateOptions.maxDate;
                        }

                        function getPrev (curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() - 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() - 6;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() - 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() - 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }

                        function getNext (curr) {
                            curr = angular.copy(curr);
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() + 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() + 8;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() + 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() + 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            return newDate;
                        }
                    }
                }
            }
        }
    }
})();

/*
 * Hamster.js v1.1.2
 * (c) 2013 Monospaced http://monospaced.com
 * License: MIT
 */

(function(window, document){
    'use strict';

    /**
     * Hamster
     * use this to create instances
     * @returns {Hamster.Instance}
     * @constructor
     */
    var Hamster = function(element) {
        return new Hamster.Instance(element);
    };

// default event name
    Hamster.SUPPORT = 'wheel';

// default DOM methods
    Hamster.ADD_EVENT = 'addEventListener';
    Hamster.REMOVE_EVENT = 'removeEventListener';
    Hamster.PREFIX = '';

// until browser inconsistencies have been fixed...
    Hamster.READY = false;

    Hamster.Instance = function(element){
        if (!Hamster.READY) {
            // fix browser inconsistencies
            Hamster.normalise.browser();

            // Hamster is ready...!
            Hamster.READY = true;
        }

        this.element = element;

        // store attached event handlers
        this.handlers = [];

        // return instance
        return this;
    };

    /**
     * create new hamster instance
     * all methods should return the instance itself, so it is chainable.
     * @param   {HTMLElement}       element
     * @returns {Hamster.Instance}
     * @constructor
     */
    Hamster.Instance.prototype = {
        /**
         * bind events to the instance
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         * @returns {Hamster.Instance}
         */
        wheel: function onEvent(handler, useCapture){
            Hamster.event.add(this, Hamster.SUPPORT, handler, useCapture);

            // handle MozMousePixelScroll in older Firefox
            if (Hamster.SUPPORT === 'DOMMouseScroll') {
                Hamster.event.add(this, 'MozMousePixelScroll', handler, useCapture);
            }

            return this;
        },

        /**
         * unbind events to the instance
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         * @returns {Hamster.Instance}
         */
        unwheel: function offEvent(handler, useCapture){
            // if no handler argument,
            // unbind the last bound handler (if exists)
            if (handler === undefined && (handler = this.handlers.slice(-1)[0])) {
                handler = handler.original;
            }

            Hamster.event.remove(this, Hamster.SUPPORT, handler, useCapture);

            // handle MozMousePixelScroll in older Firefox
            if (Hamster.SUPPORT === 'DOMMouseScroll') {
                Hamster.event.remove(this, 'MozMousePixelScroll', handler, useCapture);
            }

            return this;
        }
    };

    Hamster.event = {
        /**
         * cross-browser 'addWheelListener'
         * @param   {Instance}    hamster
         * @param   {String}      eventName
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         */
        add: function add(hamster, eventName, handler, useCapture){
            // store the original handler
            var originalHandler = handler;

            // redefine the handler
            handler = function(originalEvent){

                if (!originalEvent) {
                    originalEvent = window.event;
                }

                // create a normalised event object,
                // and normalise "deltas" of the mouse wheel
                var event = Hamster.normalise.event(originalEvent),
                    delta = Hamster.normalise.delta(originalEvent);

                // fire the original handler with normalised arguments
                return originalHandler(event, delta[0], delta[1], delta[2]);

            };

            // cross-browser addEventListener
            hamster.element[Hamster.ADD_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

            // store original and normalised handlers on the instance
            hamster.handlers.push({
                original: originalHandler,
                normalised: handler
            });
        },

        /**
         * removeWheelListener
         * @param   {Instance}    hamster
         * @param   {String}      eventName
         * @param   {Function}    handler
         * @param   {Boolean}     useCapture
         */
        remove: function remove(hamster, eventName, handler, useCapture){
            // find the normalised handler on the instance
            var originalHandler = handler,
                lookup = {},
                handlers;
            for (var i = 0, len = hamster.handlers.length; i < len; ++i) {
                lookup[hamster.handlers[i].original] = hamster.handlers[i];
            }
            handlers = lookup[originalHandler];
            handler = handlers.normalised;

            // cross-browser removeEventListener
            hamster.element[Hamster.REMOVE_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

            // remove original and normalised handlers from the instance
            for (var h in hamster.handlers) {
                if (hamster.handlers[h] == handlers) {
                    hamster.handlers.splice(h, 1);
                    break;
                }
            }
        }
    };

    /**
     * these hold the lowest deltas,
     * used to normalise the delta values
     * @type {Number}
     */
    var lowestDelta,
        lowestDeltaXY;

    Hamster.normalise = {
        /**
         * fix browser inconsistencies
         */
        browser: function normaliseBrowser(){
            // detect deprecated wheel events
            if (!('onwheel' in document || document.documentMode >= 9)) {
                Hamster.SUPPORT = document.onmousewheel !== undefined ?
                    'mousewheel' : // webkit and IE < 9 support at least "mousewheel"
                    'DOMMouseScroll'; // assume remaining browsers are older Firefox
            }

            // detect deprecated event model
            if (!window.addEventListener) {
                // assume IE < 9
                Hamster.ADD_EVENT = 'attachEvent';
                Hamster.REMOVE_EVENT = 'detachEvent';
                Hamster.PREFIX = 'on';
            }

        },

        /**
         * create a normalised event object
         * @param   {Function}    originalEvent
         * @returns {Object}      event
         */
        event: function normaliseEvent(originalEvent){
            var event = {
                // keep a reference to the original event object
                originalEvent: originalEvent,
                target: originalEvent.target || originalEvent.srcElement,
                type: 'wheel',
                deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
                deltaX: 0,
                deltaZ: 0,
                preventDefault: function(){
                    if (originalEvent.preventDefault) {
                        originalEvent.preventDefault();
                    } else {
                        originalEvent.returnValue = false;
                    }
                },
                stopPropagation: function(){
                    if (originalEvent.stopPropagation) {
                        originalEvent.stopPropagation();
                    } else {
                        originalEvent.cancelBubble = false;
                    }
                }
            };

            // calculate deltaY (and deltaX) according to the event

            // 'mousewheel'
            if (originalEvent.wheelDelta) {
                event.deltaY = - 1/40 * originalEvent.wheelDelta;
            }
            // webkit
            if (originalEvent.wheelDeltaX) {
                event.deltaX = - 1/40 * originalEvent.wheelDeltaX;
            }

            // 'DomMouseScroll'
            if (originalEvent.detail) {
                event.deltaY = originalEvent.detail;
            }

            return event;
        },

        /**
         * normalise 'deltas' of the mouse wheel
         * @param   {Function}    originalEvent
         * @returns {Array}       deltas
         */
        delta: function normaliseDelta(originalEvent){
            var delta = 0,
                deltaX = 0,
                deltaY = 0,
                absDelta = 0,
                absDeltaXY = 0,
                fn;

            // normalise deltas according to the event

            // 'wheel' event
            if (originalEvent.deltaY) {
                deltaY = originalEvent.deltaY * -1;
                delta  = deltaY;
            }
            if (originalEvent.deltaX) {
                deltaX = originalEvent.deltaX;
                delta  = deltaX * -1;
            }

            // 'mousewheel' event
            if (originalEvent.wheelDelta) {
                delta = originalEvent.wheelDelta;
            }
            // webkit
            if (originalEvent.wheelDeltaY) {
                deltaY = originalEvent.wheelDeltaY;
            }
            if (originalEvent.wheelDeltaX) {
                deltaX = originalEvent.wheelDeltaX * -1;
            }

            // 'DomMouseScroll' event
            if (originalEvent.detail) {
                delta = originalEvent.detail * -1;
            }

            // Don't return NaN
            if (delta === 0) {
                return [0, 0, 0];
            }

            // look for lowest delta to normalize the delta values
            absDelta = Math.abs(delta);
            if (!lowestDelta || absDelta < lowestDelta) {
                lowestDelta = absDelta;
            }
            absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
            if (!lowestDeltaXY || absDeltaXY < lowestDeltaXY) {
                lowestDeltaXY = absDeltaXY;
            }

            // convert deltas to whole numbers
            fn = delta > 0 ? 'floor' : 'ceil';
            delta  = Math[fn](delta / lowestDelta);
            deltaX = Math[fn](deltaX / lowestDeltaXY);
            deltaY = Math[fn](deltaY / lowestDeltaXY);

            return [delta, deltaX, deltaY];
        }
    };

    if (typeof window.define === 'function' && window.define.amd) {
        // AMD
        window.define('hamster', [], function(){
            return Hamster;
        });
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = Hamster;
    } else {
        // Browser global
        window.Hamster = Hamster;
    }

})(window, window.document);
angular.module('c')
    .directive('msdWheel', ['$parse', function ($parse) {
        return {
            restrict: 'A, C',
            link: function (scope, element, attr) {
                var expr = $parse(attr['msdWheel']),
                    fn = function (event, delta, deltaX, deltaY) {
                        scope.$apply(function () {
                            expr(scope, {
                                $event: event,
                                $delta: delta,
                                $deltaX: deltaX,
                                $deltaY: deltaY
                            });
                        });
                    },
                    hamster;

                if (typeof Hamster === 'undefined') {
                    // fallback to standard wheel event
                    element.bind('wheel', function (event) {
                        scope.$apply(function () {
                            expr(scope, {
                                $event: event
                            });
                        });
                    });
                    return;
                }

                // don't create multiple Hamster instances per element
                if (!(hamster = element.data('hamster'))) {
                    hamster = Hamster(element[0]);
                    element.data('hamster', hamster);
                }

                // bind Hamster wheel event
                hamster.wheel(fn);

                // unbind Hamster wheel event
                scope.$on('$destroy', function () {
                    hamster.unwheel(fn);
                });
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('pdfPreviewer', pdfPreviewer);

    /** @ngInject */
    function pdfPreviewer($compile) {
        return {
            restrict: 'E',
            scope: {
                pdfUrl: '=url'
                // height: '=height'
            },
            require: [],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'pdf';// + (new Date()).getTime() + (Math.floor(Math.random() * 100000));

                        init();


                        function init() {
                            var elem = '<div class="pdf-wrapper" fullscreen="isFullscreen" loading-container="loading">' +
                                '<ng-pdf template-url="directives/ui/pdfPreviewer/temp.html" canvasid="' + id + '" scale="page-fit">' +
                                '</ng-pdf></div>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                            scope.loading = true;
                            scope.onLoad = function () {
                                scope.loading = false;
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('c')
        .directive('richTextRender', richTextRender)
        .directive('rtrGallery', rtrGallery)
    ;

    function rtrGallery() {
        return {
            priority: 10,
            link: function(scope, element, attrs) {
                var pswpElement = document.getElementById('pswp');
                var imgItems = [];

                scope.$watch(attrs.ngBindHtml, function(newvalue) {
                    if (newvalue) {
                        imgItems = [];
                        var imgList = element[0].querySelectorAll('img');
                        for(var i = 0; i < imgList.length; i++) {
                            var img = imgList[i];
                            img.onload = function() {
                                var img = this;
                                var jqueryImg = $(this);
                                var imgWidth = img.naturalWidth,
                                    imgHeight = img.naturalHeight;
                                if (imgWidth > 50 && imgHeight > 50) {
                                    img.onclick = onThumbnailsClick;
                                    img.setAttribute('idx', imgItems.length);
                                    img.className = 'img-responsive';
                                    jqueryImg.css({margin: 'auto'});
                                    jqueryImg.addClass("fadeInDown");
                                    if (imgWidth < 576) {
                                        imgWidth *= 2;
                                        imgHeight *= 2;
                                    } else if (imgWidth >= 576 && imgWidth < 992) {
                                        imgWidth = 992;
                                        imgHeight = imgHeight * 992 / imgWidth;
                                    }
                                    imgItems.push({src: img.src, w: +imgWidth, h: +imgHeight, el: img});
                                }
                            };
                        }
                    }
                });

                function onThumbnailsClick(e) {
                    if (imgItems.length > 0) {
                        e = e || window.event;
                        e.preventDefault ? e.preventDefault() : e.returnValue = false;
                        var eTarget = e.target || e.srcElement;
                        openGallery(+eTarget.getAttribute('idx'));
                    }
                }

                function openGallery(index) {
                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, imgItems, {
                        index: index,
                        getThumbBoundsFn: function(index) {
                            var thumbnail = imgItems[index].el;
                            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                            var rect = thumbnail.getBoundingClientRect();
                            return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                        }
                    });
                    gallery.init();
                }
            }
        };
    }

    /** @ngInject */
    function richTextRender($compile) {
        return {
            restrict: 'E',
            scope: {
                html: '=',
                text: '='
            },
            require: [],
            compile: function() {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        init();


                        function init() {
                            var elem = '<div oc-lazy-load=["/ocLazyLoad/PhotoSwipe/photoswipe.min.js",' +
                                '"/ocLazyLoad/PhotoSwipe/photoswipe.css","/ocLazyLoad/PhotoSwipe/photoswipe-ui-default.min.js",' +
                                '"/ocLazyLoad/PhotoSwipe/default-skin/default-skin.css"]>';

                            if (angular.isUndefined(iAttrs.html)) {
                                elem += '<div ng-bind-html="text | safeHtml" rtr-gallery></div></div>';
                            } else {
                                elem += '<div ng-bind-html=html rtr-gallery></div></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }
                    }
                }
            }
        }
    }
})();

/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.8
 *
 */
(function(e){e.fn.extend({slimScroll:function(f){var a=e.extend({width:"auto",height:"250px",size:"7px",color:"#000",position:"right",distance:"1px",start:"top",opacity:.4,alwaysVisible:!1,disableFadeOut:!1,railVisible:!1,railColor:"#333",railOpacity:.2,railDraggable:!0,railClass:"slimScrollRail",barClass:"slimScrollBar",wrapperClass:"slimScrollDiv",allowPageScroll:!1,wheelStep:20,touchScrollStep:200,borderRadius:"7px",railBorderRadius:"7px"},f);this.each(function(){function v(d){if(r){d=d||window.event;
var c=0;d.wheelDelta&&(c=-d.wheelDelta/120);d.detail&&(c=d.detail/3);e(d.target||d.srcTarget||d.srcElement).closest("."+a.wrapperClass).is(b.parent())&&n(c,!0);d.preventDefault&&!k&&d.preventDefault();k||(d.returnValue=!1)}}function n(d,g,e){k=!1;var f=b.outerHeight()-c.outerHeight();g&&(g=parseInt(c.css("top"))+d*parseInt(a.wheelStep)/100*c.outerHeight(),g=Math.min(Math.max(g,0),f),g=0<d?Math.ceil(g):Math.floor(g),c.css({top:g+"px"}));l=parseInt(c.css("top"))/(b.outerHeight()-c.outerHeight());g=
l*(b[0].scrollHeight-b.outerHeight());e&&(g=d,d=g/b[0].scrollHeight*b.outerHeight(),d=Math.min(Math.max(d,0),f),c.css({top:d+"px"}));b.scrollTop(g);b.trigger("slimscrolling",~~g);w();p()}function x(){u=Math.max(b.outerHeight()/b[0].scrollHeight*b.outerHeight(),30);c.css({height:u+"px"});var a=u==b.outerHeight()?"none":"block";c.css({display:a})}function w(){x();clearTimeout(B);l==~~l?(k=a.allowPageScroll,C!=l&&b.trigger("slimscroll",0==~~l?"top":"bottom")):k=!1;C=l;u>=b.outerHeight()?k=!0:(c.stop(!0,
!0).fadeIn("fast"),a.railVisible&&m.stop(!0,!0).fadeIn("fast"))}function p(){a.alwaysVisible||(B=setTimeout(function(){a.disableFadeOut&&r||y||z||(c.fadeOut("slow"),m.fadeOut("slow"))},1E3))}var r,y,z,B,A,u,l,C,k=!1,b=e(this);if(b.parent().hasClass(a.wrapperClass)){var q=b.scrollTop(),c=b.siblings("."+a.barClass),m=b.siblings("."+a.railClass);x();if(e.isPlainObject(f)){if("height"in f&&"auto"==f.height){b.parent().css("height","auto");b.css("height","auto");var h=b.parent().parent().height();b.parent().css("height",
h);b.css("height",h)}else"height"in f&&(h=f.height,b.parent().css("height",h),b.css("height",h));if("scrollTo"in f)q=parseInt(a.scrollTo);else if("scrollBy"in f)q+=parseInt(a.scrollBy);else if("destroy"in f){c.remove();m.remove();b.unwrap();return}n(q,!1,!0)}}else if(!(e.isPlainObject(f)&&"destroy"in f)){a.height="auto"==a.height?b.parent().height():a.height;q=e("<div></div>").addClass(a.wrapperClass).css({overflow:"hidden",width:a.width,height:a.height});b.css({overflow:"hidden",
width:a.width,height:a.height});var m=e("<div></div>").addClass(a.railClass).css({width:a.size,height:"100%",position:"absolute",top:0,display:a.alwaysVisible&&a.railVisible?"block":"none","border-radius":a.railBorderRadius,background:a.railColor,opacity:a.railOpacity,zIndex:90}),c=e("<div></div>").addClass(a.barClass).css({background:a.color,width:a.size,position:"absolute",top:0,opacity:a.opacity,display:a.alwaysVisible?"block":"none","border-radius":a.borderRadius,BorderRadius:a.borderRadius,MozBorderRadius:a.borderRadius,
WebkitBorderRadius:a.borderRadius,zIndex:99}),h="right"==a.position?{right:a.distance}:{left:a.distance};m.css(h);c.css(h);b.wrap(q);b.parent().append(c);b.parent().append(m);a.railDraggable&&c.bind("mousedown",function(a){var b=e(document);z=!0;t=parseFloat(c.css("top"));pageY=a.pageY;b.bind("mousemove.slimscroll",function(a){currTop=t+a.pageY-pageY;c.css("top",currTop);n(0,c.position().top,!1)});b.bind("mouseup.slimscroll",function(a){z=!1;p();b.unbind(".slimscroll")});return!1}).bind("selectstart.slimscroll",
function(a){a.stopPropagation();a.preventDefault();return!1});m.hover(function(){w()},function(){p()});c.hover(function(){y=!0},function(){y=!1});b.hover(function(){r=!0;w();p()},function(){r=!1;p()});b.bind("touchstart",function(a,b){a.originalEvent.touches.length&&(A=a.originalEvent.touches[0].pageY)});b.bind("touchmove",function(b){k||b.originalEvent.preventDefault();b.originalEvent.touches.length&&(n((A-b.originalEvent.touches[0].pageY)/a.touchScrollStep,!0),A=b.originalEvent.touches[0].pageY)});
x();"bottom"===a.start?(c.css({top:b.outerHeight()-c.outerHeight()}),n(0,!0)):"top"!==a.start&&(n(e(a.start).position().top,null,!0),a.alwaysVisible||c.hide());window.addEventListener?(this.addEventListener("DOMMouseScroll",v,!1),this.addEventListener("mousewheel",v,!1)):document.attachEvent("onmousewheel",v)}});return this}});e.fn.extend({slimscroll:e.fn.slimScroll})})(jQuery);
angular.module('c').directive('slimscroll', function () {
    'use strict';

    return {
        restrict: 'A',
        link: function ($scope, $elem, $attr) {
            var off = [];
            var option = {};

            var refresh = function () {
                if ($attr.slimscroll) {
                    option = $scope.$eval($attr.slimscroll);
                } else if ($attr.slimscrollOption) {
                    option = $scope.$eval($attr.slimscrollOption);
                }

                $($elem).slimScroll({destroy: true});

                $($elem).slimScroll(option);
            };

            var registerWatch = function () {
                if ($attr.slimscroll && !option.noWatch) {
                    off.push($scope.$watchCollection($attr.slimscroll, refresh));
                }

                if ($attr.slimscrollWatch) {
                    off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
                }

                if ($attr.slimscrolllistento) {
                    off.push($scope.$on($attr.slimscrolllistento, refresh));
                }
            };

            var destructor = function () {
                $($elem).slimScroll({destroy: true});
                off.forEach(function (unbind) {
                    unbind();
                });
                off = null;
            };

            off.push($scope.$on('$destroy', destructor));

            registerWatch();
        }
    };
});

(function () {
    'use strict';

    angular.module('c')
        .controller('deptMemberConfirmDlgCtrl', deptMemberConfirmDlgCtrl);

    /** @ngInject */
    function deptMemberConfirmDlgCtrl($scope, $uibModalInstance, User,
                                      data, $q, Dlg, FormHelper, DateHelper) {
        var vm = this;
        var helper = User.formHelper;
        var required = {
            status: true, entryTime: false, startedWork: true, annualDays: true
        };


        vm.ok = ok;

        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    username: true
                },
                enableTransferDept: false,
                // hideUpdateAnnualChecker: true,
                required: required
            };

            $q.all([
                User.get({id: data.id, op: 'default'}).$promise,
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                var m = respArray[0].item;

                if (m.username && m.name && m.dept && m.type && m.status && m.entry_time && m.started_work) {
                    vm.cfg.disable = {
                        username: true, name: true, dept: true, type: true, status: true,
                        entryTime: false, startedWork: true, sex: true
                    }
                }

                helper.bindAsyncOptions(vm, respArray[1]);

                m.entry_time = DateHelper.str2Date(m.entry_time);
                m.started_work = DateHelper.str2Date(m.started_work);

                m.update_annual_num = true;
                vm.m = m;
            });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m, 'dept_confirm');
                if (m.change_note) pa.change_note = m.change_note;
                else pa.change_note = null;

                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptAgentCtrl', DeptAgentCtrl);

    /** @ngInject */
    function DeptAgentCtrl(Dlg, FormHelper, DeptAgent, Dept) {
        var none =  {id: null, name: '空缺'};
        var vm = this;

        vm.submit = submit;
        vm.optionSelectFn = optionSelectFn;

        init();


        function init() {
            Dept.query({op: 'led_by', with_agent: true}).$promise.then(
                function (resp) {
                    vm.depts = resp.items;
                }
            );
            vm.m = {};
        }


        function optionSelectFn(option) {
            if (!option.members) {
                Dept.getMembers(option.id).then(function (resp) {
                    option.members = resp.data.items;
                    option.members.splice(0, 0, none);

                    option.email_agent = none;
                    option.doc_agent = none;
                    if (option.dept_agent) {
                        if (option.dept_agent.doc_agent) {
                            option.doc_agent = option.dept_agent.doc_agent;
                        }
                        if (option.dept_agent.email_agent) {
                            option.email_agent = option.dept_agent.email_agent;
                        }
                    }
                });
            }
            vm.m = option;
        }

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    email_agent_id: m.email_agent.id,
                    doc_agent_id: m.doc_agent.id,
                    dept_id: m.id
                };

                DeptAgent.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                }).finally(function () {
                    defer.resolve();
                });

            });
        }
    }

})();









(function () {
    'use strict';

    angular.module('c')
        .controller('DeptUserEditDlgCtrl', DeptUserEditDlgCtrl);

    /** @ngInject */
    function DeptUserEditDlgCtrl ($scope, $uibModalInstance, $q, User, UserStatus, ArrayHelper,
                                  data, Dlg, FormHelper) {
        var vm = this;
        var helper = User.formHelper;
        var required = {status: true, eduBg: true};

        vm.cancel = $uibModalInstance.dismiss;

        vm.ok = ok;

        init(data.id);


        function init (id) {
            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    dept: true,
                    company: data.disableCompany ? false : true,
                },
                hideUpdateAnnualChecker: true,
                hideChangeNote: true,
                hideEntryTime: true,
                hideStartedWork: true,
                required: required,
                workBodyStyle: {height: '543px'} // 下面再设置
            };

            if (id) {
                $q.all([
                    User.get({id: id, op: 'default'}).$promise,
                    User.get({id: '-', op: 'form_options'}).$promise
                ]).then(function (respArray) {
                    var m = respArray[0].item;
                    helper.bindAsyncOptions(vm, respArray[1]);
                    m.edu_bg = ArrayHelper.getItem(m.edu_bg, vm.edu_bgs);
                    m.degree = User.getDegree(m.degree);
                    m.en_lv = ArrayHelper.getItem(m.en_lv, vm.en_lvs);
                    // vm.statuses = ArrayHelper.filter(vm.statuses, function (s) {
                    //     return s.id === UserStatus.ID.OTHER || s.id === UserStatus.ID.DIRECT;
                    // });
                    vm.m = m;
                });
            } else {
                vm.m = {
                    id: '-', // 上传头像需要检查id,
                    sex: 1, dept: data.dept
                };
                User.get({id: '-', op: 'form_options'}).$promise.then(
                    function (resp) {
                        helper.bindAsyncOptions(vm, resp);
                        // vm.statuses = ArrayHelper.filter(vm.statuses, function (s) {
                        //     return s.id === UserStatus.ID.OTHER || s.id === UserStatus.ID.DIRECT;
                        // });
                        vm.m.type = vm.types[0];
                        vm.m.status = vm.statuses[0];
                    }
                );
            }
        }

        function ok (m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var promise;
                var pa = helper.loadParams(m, m.id === '-' ? 'dept_reg' : 'dept_edit');
                pa.dept_id = m.dept.id;
                if (m.id === '-') {
                    if (m.photo) pa.photo = m.photo;
                    if (m.work_photo) pa.work_photo = m.work_photo;
                    promise = User.save(pa).$promise;
                } else {
                    promise = User.update({id: m.id}, pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersInCtrl', DeptMembersInCtrl)
    ;

    /** @ngInject */
    function DeptMembersInCtrl ($scope, $q, Auth, User, UserDept, Dlg, Table, ArrayHelper, UIHelper, Api, Dept, DeptType) {
        var vm = $scope;
        vm.edit = edit;
        vm.confirm = confirm;

        vm.add = add;
        vm.editUserInfo = editUserInfo;
        vm.changePwd = changePwd;
        vm.leave = leave;

        init();


        function init () {
            UIHelper.loadTab(vm, 'in');

            vm.notCbAgency = Auth.getAccount().dept_type_id !== DeptType.ID.CB_AGENCY;

            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise,
                Dept.query({op: 'led_by', with_unconfirmed_cnt: true}).$promise
            ]).then(function (respArray) {
                var typeOpts = Table.getNgTableOpts(respArray[0].items.types);
                var statusOpts = Table.getNgTableOpts(respArray[0].items.statuses);

                loadDepts(respArray[1].items);

                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_led_by'},
                    optColWidth: vm.notCbAgency ? Table._4_BTN : Table._1_BTN,
                    optInFront: true,
                    // showSn: true,
                    cols: [
                        {field: "sorting", title: "顺序号", width: Table._2_CHAR},
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "用户名", filter: {username: "text"}},
                        // {field: "type", title: "岗位", filter: {type_id: "select"}, data: typeOpts},
                        {field: "status", title: "编制", filter: {status_id: "select"}, data: statusOpts},
                        // {field: "title", title: "职称", filter: {title: "text"}},
                        {field: "entry_time", title: "入部门时间", width: Table._3_CHAR},
                        // {field: "office", title: "部门", filter: {'user_depts.office': "text"}},
                        {field: "post", title: "职务", filter: {'user_depts.post': "text"}}
                    ]
                };

                Table.load(vm, options, Table.loadItem);
                vm.clearFilters = function () {
                    vm.tableParams.filter({'user_depts.dept_id': vm.tableParams.filter()['user_depts.dept_id']});
                }
            });
        }

        function loadDepts (depts) {
            vm.depts = depts;
            // load has unconfirmed
            for (var i = 0; i < vm.depts.length; i++) {
                var dept = vm.depts[i];
                if (dept.membersUnconfirmedCount > 0) {
                    vm.hasUnconfirmed = true;
                    break;
                }
            }
        }

        function add () {
            if (vm.deptId) {
                var dept = ArrayHelper.getItem(vm.deptId, vm.depts);
                Dlg.show({
                    template: 'pages/dept_leader/members/deptUserEditDlg.html',
                    ctrl: 'DeptUserEditDlgCtrl', size: 'lg',
                    data: {dept: dept, disableCompany: true}
                }).then(function (resp) {
                    vm.tableReload();
                });
            }
        }

        function edit (m) {
            Api.addEdit(vm, 'pages/dept_leader/members/inEditDlg.html', 'deptMemberInDlgCtrl', m);
        }

        function editUserInfo (m) {
            Dlg.show({
                template: 'pages/dept_leader/members/deptUserEditDlg.html',
                ctrl: 'DeptUserEditDlgCtrl', size: 'lg',
                data: {id: m.user_id}
            }).then(function (resp) {
                vm.tableReload();
            });
        }

        function changePwd (m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/changePasswordDlg.html',
                ctrl: 'changePasswordDlgCtrl',
                data: {user: {id: m.user_id}}
            }).then(function () {
                vm.tableReload();
            });
        }

        function leave (m) {
            Dlg.show({
                template: 'pages/personnel/userLeave/userLeaveDlg.html',
                ctrl: 'PersonnelUserLeaveDlgCtrl',
                data: {
                    id: m.user_id
                }
            }).then(function () {
                vm.tableReload();
            });
        }

        function confirm (m) {
            Dlg.show({
                template: 'pages/dept_leader/members/confirmDlg.html',
                ctrl: 'deptMemberConfirmDlgCtrl',
                data: {id: m.user_id}
            }).then(function (resp) {
                Dept.query({op: 'led_by', with_unconfirmed_cnt: true}).$promise.then(
                    function (resp) {
                        loadDepts(resp.items);
                    }
                );
                vm.tableReload();
            });
        }
    }


})();

(function () {
    'use strict';

    angular.module('c')
        .controller('deptMemberInDlgCtrl', deptMemberInDlgCtrl);

    /** @ngInject */
    function deptMemberInDlgCtrl($uibModalInstance, Dlg, FormHelper, UserDept, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
           UserDept.get({id: id}).$promise.then(function (resp) {
               vm.m = {
                   id: id,
                   post: resp.post,
                   // office: resp.office,
                   sorting: resp.sorting
               };
           });
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                UserDept.update({id: m.id, op: 'by_leader'}, {
                    post: m.post,
                    // office: m.office,
                    sorting: m.sorting,
                }).$promise.then(
                    function (resp) {
                        Dlg.s(resp.msg);
                        vm.close();
                    }, function (error) {
                        var resp = error.data;
                        Dlg.error(resp.msg);
                    }).finally(function () {
                    defer.resolve();
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptLeavedUserCtrl', DeptLeavedUserCtrl)
    ;

    /** @ngInject */
    function DeptLeavedUserCtrl($scope, UIHelper, User, Table, $q, ArrayHelper,
                                     LeaveReason, Dlg) {
        var vm = $scope;
        vm.recover = recover;

        init();


        function init() {
            UIHelper.loadTab(vm, 'leave');

            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise,
                LeaveReason.query().$promise
            ]).then(function (respArray) {
                vm.types = respArray[0].items.types;
                vm.reasons = respArray[1];

                var options = {
                    service: User,
                    params: {op: 'dept_user_leave'},
                    optInFront: true,
                    optColWidth: Table._1_BTN,
                    showFn: true,
                    cols: [
                        {title: '姓名', filter: {name: 'text'}, field: 'name'}, // 1
                        {title: '原部门', field: 'main_dept', filter: {main_dept: 'text'}},
                        {
                            title: '类别',
                            filter: {type_id: 'select'},
                            field: 'type',
                            data: Table.getNgTableOpts(vm.types)
                        },
                        {
                            title: '入职时间',
                            filter: {entry_time: 'date_range'},
                            field: 'entry_time'
                        },
                        {
                            title: '离职时间',
                            filter: {leave_time: 'date_range'},
                            field: 'leave_time'
                        },
                        {
                            title: '离职原因',
                            filter: {leave_reason_id: 'select'},
                            data: Table.getNgTableOpts(vm.reasons),
                            field: 'reason'
                        }
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.type = ArrayHelper.getItem(item.type_id, vm.types);
                        item.reason = ArrayHelper.getItem(item.leave_reason_id, vm.reasons);
                    });
                });
            });
        }

        function recover(m) {
            Dlg.show({
                template: 'pages/personnel/LeavedUserRecoverDlg.html',
                ctrl: 'LeavedUserRecoverDlgCtrl',
                data: {id: m.id}
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptMembersOutCtrl', DeptMembersOutCtrl);

    /** @ngInject */
    function DeptMembersOutCtrl($scope, UIHelper, $q, UserDept, Table, Dept) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab(vm, 'out');

            $q.all([
                Dept.query({op: 'led_by'}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[0].items;
                var options = {
                    service: UserDept,
                    params: {op: 'dept_member_out'},
                    hideOpt: true,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {title: '姓名', filter: {name: 'text'}, field: 'name'},
                        {title: '用户名', filter: {username: 'text'}, field: 'username'},
                        {title: '入部门时间', filter: {entry_time: 'date_range'}, field: 'entry_time'},
                        {title: '离部时间', filter: {leave_time: 'date_range'}, field: 'leave_time'},
                        {title: '职务', filter: {post: 'text'}, field: 'post'}
                    ]
                };

                Table.load(vm, options, Table.loadItem);
            });
        }
    }

})();



angular.module('c').controller('BasicDataDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.data = {title: data.title};
    $scope.ok = function (data) {
        if ($scope.data_form.$valid) {
            $uibModalInstance.close(data);
        } else {
            $scope.data_form.submitted = true;
            toaster.warning('表单中有错误!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c').controller('FloatDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.pa = {title: data.title, label: data.label, icon: data.icon, label_time: data.label_time};

    $scope.put_int = data.put_int;
    $scope.ok = function (pa) {
        if ($scope.c_form.$valid) {
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('请填写数值!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
(function () {
    'use strict';

    angular.module('c')
        .controller('CommentDlgCtrl', CommentDlgCtrl);

    /** @ngInject */
    function CommentDlgCtrl($uibModalInstance, FormHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            vm.params = {
                title: data.title,
                label: data.label ? data.label : '理由',
                icon: data.icon ? data.icon : 'edit',
                withRate: data.withRate,
                notRequired: data.notRequired
            };
            if (data.withRate) {
                vm.satLvs = [
                    {id: 1, name: '非常不满意'},
                    {id: 2, name: '不满意'},
                    {id: 3, name: '较满意'},
                    {id: 4, name: '满意'},
                    {id: 5, name: '非常满意'}
                ];
            }
            if (data.text) {
                vm.m.opinion = data.text;
            }
        }

        function ok(m) {
            FormHelper.handleSubmit(vm, function () {
                if (data.withRate) {
                    vm.close(m);
                } else {
                    vm.close(m.opinion);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c').controller('EDRCtrl', EDRCtrl);

    /** @ngInject */
    function EDRCtrl($uibModalInstance, FormHelper, FileHelper, DateHelper, data) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                FileHelper.dnExcel(data.url, pa, pa.start + '到' + pa.end + data.title + '.xls', function () {
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($scope, $uibModalInstance, toaster, FileHelper, C, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.width = data.width;
        vm.height = data.height;
        vm.m = {toUrl: FileHelper.urls.IMG_UPLOAD, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            FileHelper.uploadCroppedImage(m).then(function (url) {
                $uibModalInstance.close(url);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

//angular.module('c').controller('UploadImageDlg',
//    function ($scope, $uibModalInstance, Upload, C, dialogs) {
//        $scope.image = {progress: 0, height: 240};
//
//        $scope.upload = function (file, image, e) {
//            if (e && e[0] && e[0].$error == 'maxSize') {
//                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
//                return;
//            }
//
//            if (file == null) {
//                return;
//            }
//
//            Upload.upload({
//                url: C.URL.IMG_UPLOAD, file: file
//            }).progress(function (evt) {
//                image.progress = parseInt(100.0 * evt.loaded / evt.total);
//            }).success(function (resp) {
//                switch (resp.result) {
//                    case 0:
//                        image.progress = 0;
//                        image.link = resp.link;
//                        image.height = resp.height * 320 / resp.width;
//                        break;
//                    case 1:
//                        image.progress = 101;
//                        image.errorInfo = '服务器空间不足!';
//                        break;
//                }
//            }).error(function () {
//                image.progress = 102;
//                image.errorInfo = '服务器错误!';
//            });
//        };
//
//        $scope.insert = function (image) {
//            $uibModalInstance.close(image.link);
//        };
//
//        $scope.cancel = function () {
//            $uibModalInstance.dismiss('cancel');
//        };
//    });
angular.module('c').controller('UploadUserpicDlg',
    function ($scope, $uibModalInstance, Upload, C, data) {
        $scope.image = {progress: 0, croppedDataUrl: ''};

        $scope.upload = function (image) {
            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (!file.$error) {
                Upload.upload({
                    url: C.URL.IMG_UPLOAD, data: {file: file, is_user_photo: true, user_id: data.user_id}
                }).progress(function (evt) {
                    image.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            image.progress = 0;
                            image.url = resp.url;
                            $uibModalInstance.close(image.url);
                            break;
                        case 1:
                            image.progress = 101;
                            image.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    image.progress = 102;
                    image.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeFinishCtrl', HospitalBadgeFinishCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeFinishCtrl($scope, Table, User, UIHelper, Dlg, FileHelper) {
        var vm = $scope;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;

        init();

        function init() {
            UIHelper.loadTab(vm, 'finish');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.FINISH},
                optColWidth: Table._2_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeMakingCtrl', HospitalBadgeMakingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeMakingCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.made = made;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.zoomIn = zoomIn;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'making');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.MAKING},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function made(m) {
            var pa = {
                op: 'badge',
                badge: User.BADGE.RECEIVE
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌制作完成了吗？', function (resp) {
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '胸牌制作');

        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.RECEIVE
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgePendingCtrl', HospitalBadgePendingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgePendingCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.making = making;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'pending');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.PENDING},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function making(m) {
            if (m.work_photo) {
                Dlg.confirm('开始制作<strong>' + m.name + '</strong>的胸牌了吗？', function (resp) {
                    var pa = {
                        op: 'badge',
                        badge: User.BADGE.MAKING
                    };
                    User.update({id: m.id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '制作胸牌');
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.MAKING
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('HospitalBadgeReceiveCtrl', HospitalBadgeReceiveCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeReceiveCtrl($scope, Table, User, UIHelper, Dlg, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.finish = finish;
        vm.zoomIn = zoomIn;
        vm.dnWorkPhoto = dnWorkPhoto;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'receive');

            var options = {
                service: User,
                params: {op: 'Badge', badge: User.BADGE.RECEIVE},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '用户名', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '部门', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function finish(m) {
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌已经领取了吗？', function (resp) {
                var pa = {
                    op: 'badge',
                    badge: User.BADGE.FINISH
                };
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '胸牌领取');

        }

        function zoomIn(m) {
            if (m.work_photo) {
                Dlg.show({
                    template: 'pages/hospital_office/badge/preview.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function dnWorkPhoto(m) {
            var pa = {
                name: m.dept.name + '-' + m.name + '-' + m.username + '.jpg',
                filename: m.work_photo,
                mime: 'image/jpg'
            };
            FileHelper.download1(User.urls.DN_WORK_PHOTO, pa);
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: User.BADGE.FINISH
            };
            User.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('SmsHistoryController', SmsHistoryController);

    /** @ngInject */
    function SmsHistoryController($scope, Table, UIHelper, ArrayHelper, Sms, Dlg, $q) {
        var vm = $scope;
        vm.show = show;
        vm.remove = remove;
        vm.removeChecked = removeChecked;
        var checker = null;
        var successOrNotOpts = Table.getNgTableOpts(ArrayHelper.get('successOrNot'));


        init();

        function init() {
            UIHelper.loadTab($scope, 'history');

            var options = {
                service: Sms,
                params: {op: 'default'},
                optColWidth: Table._2_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {title: '收件人', filter: {recipient: 'text'}, field: 'recipients'},
                    {title: '内容', filter: {content: 'text'}, field: 'content'},
                    {
                        title: '时间',
                        filter: {updated_at: 'date_range'},
                        field: 'updated_at'
                    },
                    {
                        title: '状态',
                        field: 'result_info',
                        filter: {result_info: 'select'},
                        data: successOrNotOpts
                    }
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var sms = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个短信!");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                sms.push(item.id);
            });
            Sms.batchRemove({sms: sms}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function remove(m) {
            Sms.delete({id: m.id}).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/message/temp/show_dlg.html',
                ctrl: 'SmsShowDlgCtrl',
                data: {
                    sms: m,
                    is_outbox: true
                }
            }).then(function (resp) {
                switch (resp.opt) {
                    case 5:     //再次编辑
                        UIHelper.tabTo('send', resp.sms);
                        break;
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SmsSendController', SmsSendController);

    /** @ngInject */
    function SmsSendController($rootScope, $scope, UIHelper, Auth, Dlg, Sms) {
        var vm = $scope;
        vm.mustKnow = mustKnow;
        vm.send = send;
        vm.reset = reset;
        $scope.$on('missionSms', function (ev, sms) {
            vm.sms['recipients'] = sms;
        });

        UIHelper.loadTab(vm, 'send', function (sms) {
            var content = sms.content.substr(sms.sign.length, sms.content.length - sms.sign.length);
            var sign = sms.sign.substr(1, sms.sign.length - 2);
            vm.sms = {sign: sign, content: content, recipients: sms.recipients};
        });

        var account = Auth.getAccount();

        function mustKnow() {
            Dlg.show({
                template: 'pages/message/temp/must_know_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function send(sms) {
            if (sms.sign == null || sms.sign == "") {
                Dlg.w('短信签名不能为空!');
            } else if (sms.recipients == null || sms.recipients.length == 0) {
                Dlg.w('请填写收件人!');
            } else if (sms.content == null || sms.content.length == 0) {
                Dlg.w('短信内容不能为空!');
            } else {
                var params = {};
                params['sign'] = '【云慈科技】';
                params['content'] = sms.content;
                params['content'] += '(' + account.name + account.phone + ')';
                params['recipients'] = [];
                angular.forEach(sms.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Sms.send(params, function (resp) {
                    if (resp.phoneNull) {
                        Dlg.notify(resp.msg)
                    } else {
                        Dlg.s('短信请求成功!');
                        vm.reset();
                    }
                    $rootScope.$broadcast('smsSend');
                }, function (resp) {
                    Dlg.e('短信请求失败!');
                });
            }
        }

        reset();

        function reset() {
            vm.sms = {recipients: [], sign: account.name};
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkSignedCtrl', PartyWorkSignedCtrl)


    ;
    /** @ngInject */
    function PartyWorkSignedCtrl($scope, $q, User, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signed');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkSigned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkSigningCtrl', PartyWorkSigningCtrl)


    ;

    /** @ngInject */
    function PartyWorkSigningCtrl($scope, $q, User, Dlg, Table, UIHelper) {
        var vm = $scope;
        vm.sign = sign;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signing');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkSigning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function sign(m) {
            var pa = {
                signed: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的承诺书已签订？', function (resp) {
                User.update({id: m.id, op: 'party_sign'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认承诺书已签订');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkTurnedCtrl', PartyWorkTurnedCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurnedCtrl($scope, $q, User, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turned');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkTurned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('PartyWorkTurningCtrl', PartyWorkTurningCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurningCtrl($scope, $q, User, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.turn = turn;
        init();

        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turning');

                var options = {
                    service: User,
                    params: {op: 'PartyWorkTurning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "用户名", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "部门", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function turn(m) {
            var pa = {
                turned: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的党组织关系已转？', function (resp) {
                User.update({id: m.id, op: 'party_turn'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认党组织关系已转');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('UserChangeTypeCtrl', UserChangeTypeCtrl);

    /** @ngInject */
    function UserChangeTypeCtrl($scope, $uibModalInstance, toaster, data) {
        var user = data.user;
        $scope.statuses = data.statuses;
        $scope.user = {id: user.id, username: user.username, status: user.status, time: new Date()};
        $scope.ok = function (user) {
            if ($scope.otype_form.$valid) {
                var pa = {};
                pa['username'] = user.username;
                pa['status_id'] = user.status.id;
                pa['user_id'] = user.id;
                pa['time'] = user.time;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.otype_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('changePasswordDlgCtrl', changePasswordDlgCtrl);

    /** @ngInject */
    function changePasswordDlgCtrl($uibModalInstance, Dlg, data, User,
                                   FormHelper, $q) {
        var vm = this;
        vm.m = data.user;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.password_form.$valid) {
                FormHelper.handleError('#password_form', vm.password_form);
                defer.reject();
            } else {
                User.update({id: m.id}, {
                    password: m.password,
                    op: 'password'
                }).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('ChangeTypeRecordCtrl', ChangeTypeRecordCtrl);

    /** @ngInject */
    function ChangeTypeRecordCtrl($scope, $uibModalInstance, NgTableParams, UserOnType, Table, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                Table.query(UserOnType, url, $defer, params, 'onTypes');
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserEditCtrl', PersonnelUserEditCtrl);

    /** @ngInject */
    function PersonnelUserEditCtrl($scope, $uibModalInstance, User, ArrayHelper, DeptGroup,
                                   data, $q, Dlg, FormHelper, DateHelper) {
        var vm = this;
        var helper = User.formHelper;
        var required = {
            status: true, entryTime: false, startedWork: true, annualDays: true
        };

        vm.cancel = $uibModalInstance.dismiss;

        vm.transfer = transfer;

        vm.cancelChange = cancelChange;
        vm.newStateSelected = newStateSelected;
        vm.ok = ok;

        init();


        function init() {
            helper.init(vm, $scope);

            // form config
            vm.cfg = {
                disable: {
                    dept: true,
                    // company: true,
                },
                enableTransferDept: true,
                hideUpdateAnnualChecker: false,
                hideChangeNote: true,
                required: required,
                // contactBodyStyle: {height: '280px'} // 下面再设置
            };

            $q.all([
                User.get({id: data.id, op: 'default'}).$promise,
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                var m = respArray[0].item;
                helper.bindAsyncOptions(vm, respArray[1]);

                m.edu_bg = ArrayHelper.getItem(m.edu_bg, vm.edu_bgs);
                m.degree = User.getDegree(m.degree);
                m.en_lv = ArrayHelper.getItem(m.en_lv, vm.en_lvs);
                m.entry_time = DateHelper.str2Date(m.entry_time);
                m.started_work = DateHelper.str2Date(m.started_work);

                m.pt_edu_bg = ArrayHelper.getItem(m.pt_edu_bg, vm.edu_bgs);
                m.pt_degree = User.getDegree(m.pt_degree);
                m.pt_en_lv = ArrayHelper.getItem(m.pt_en_lv, vm.en_lvs);
                if (m.party_time) m.party_time = DateHelper.str2Date(m.party_time);
                if (m.title_id) m.title = ArrayHelper.getItem(m.title_id, vm.titles);
                if (m.birthday) m.birthday = DateHelper.str2Date(m.birthday);

                vm.calcAnnualTotal(m);

                vm.cfg.workBodyStyle = {height: '100%'};

                if (m.change_note) m.changed = true;

                if (m.confirm_state !== User.CONFIRM.PERSONNEL) {
                    m.editState = true;
                    // m.newState = User.CONFIRM.PERSONNEL.toString();
                    m.newState = m.confirm_state.toString();
                    m.update_annual_num = true;
                    m.tagConfirmed = true;
                }
                loadDeptGroup(m, m.dept_id);
                vm.m = m;
            });
            if (data.is_show){
                vm.is_show=data.is_show;
                document.getElementsByTagName("input").readonly="true";
            }
        }

        function loadDeptGroup(m, dept_id) {
            DeptGroup.query({op: 'option', dept_id: dept_id}, function (resp) {
                var groups = resp.items;
                groups.splice(0, 0, {id: null,name: '无'});
                vm.groups = groups;
                if (m.group_id) {
                    if (ArrayHelper.indexOfKey(m.group_id, vm.groups) === -1) {
                        m.group = null;
                        m.group_id = null;
                    }
                }
            });
        }

        function cancelChange(m) {
            m.editState = false;
            m.newState = m.confirm_state.toString();
            newStateSelected(m);
        }

        function transfer(m) {
            Dlg.show({
                template: 'pages/personnel/userTransferDeptDlg.html',
                ctrl: 'UserTransferDeptDlgCtrl',
                data: {user: m, dept: m.dept}
            }).then(function (dept) {
                if (dept.id != m.dept.id) {
                    m.group = null;
                    m.group_id = null;
                    loadDeptGroup(m, dept.id);
                }
                m.dept = dept;
            });
        }

        function newStateSelected(m) {
            var state = parseInt(m.newState);
            switch (state) {
                case User.CONFIRM.PERSONNEL:
                case User.CONFIRM.DEPT:
                    vm.cfg.required = required;
                    break;
                default:
                    vm.cfg.required = {status: true};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = helper.loadParams(m, 'personnel_confirm');

                if (m.editState && m.newState) pa.confirm_state = m.newState;
                if (m.changed) pa.change_note = null;
                pa.company_id = m.company.id;
                if (m.group) {
                    pa.group_id = m.group.id;
                } else {
                    pa.group_id = null;
                }
                if (m.title) {
                    pa.title_id = m.title.id;
                } else {
                    pa.title_id = null;
                }
                if (m.birthday) pa.birthday = DateHelper.date2Str(m.birthday);

                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .controller('ExportUserInfoDlgCtrl', ExportUserInfoDlgCtrl);

    /** @ngInject */
    function ExportUserInfoDlgCtrl($uibModalInstance, User, FileHelper, $q) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                console.log('respArray', respArray);
                vm.types = respArray[0].items.types;
                vm.statuses = respArray[0].items.statuses;
                vm.political_statuses = respArray[0].items.political_statuses;
            });
        }

        function ok(m) {
            var pa = {
                phoneNull: m.phoneNull,
                not_confirm: m.not_confirm,
                not_photo: m.not_photo,
                depts: [],
                types: [],
                status: [],
                political_status: []
            };

            angular.forEach(m.dept, function (dept) {
                pa.depts.push(dept.id)
            });
            angular.forEach(m.type, function (type) {
                pa.types.push(type.id)
            });
            angular.forEach(m.status, function (status) {
                pa.status.push(status.id)
            });
            angular.forEach(m.political_status, function (political_status) {
                pa.political_status.push(political_status.id)
            });

            FileHelper.dnExcel(User.urls.EXPORT_USER_INFO, pa, '员工信息表.xls', function () {
                vm.close();
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelIncumbencyUserCtrl', PersonnelIncumbencyUserCtrl);

    /** @ngInject */
    function PersonnelIncumbencyUserCtrl($scope, Dlg, Table, UIHelper, User, $q, ArrayHelper) {
        var vm = $scope;
        vm.leave = leave;

        init();


        function init() {
            UIHelper.loadTab(vm, 'incumbency');

            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise
            ]).then(function (respArray) {
                vm.statuses = respArray[0].items.statuses;
                vm.types = respArray[0].items.types;

                var options = {
                    service: User,
                    params: {op: 'personnel_user_leave', leaved: 0},
                    optInFront: true,
                    optColWidth: Table._1_BTN,
                    showFn: true,
                    cols: [
                        {title: '姓名', filter: {name: 'text'}, field: 'name'}, //1
                        {title: '主部门', field: 'main_dept', filter: {main_dept: 'text'}},
                        {
                            title: '编制类型',
                            filter: {status_id: 'select'},
                            field: 'status',
                            data: Table.getNgTableOpts(vm.statuses)
                        },
                        {
                            title: '类别',
                            filter: {type_id: 'select'},
                            field: 'type',
                            data: Table.getNgTableOpts(vm.types)
                        },
                        {
                            title: '入职时间',
                            filter: {entry_time: 'date_range'},
                            field: 'entry_time'
                        }
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.status = ArrayHelper.getItem(item.status_id, vm.statuses);
                        item.type = ArrayHelper.getItem(item.type_id, vm.types);
                    });
                });
            });
        }

        function leave(m) {
            Dlg.show({
                template: 'pages/personnel/userLeave/userLeaveDlg.html',
                ctrl: 'PersonnelUserLeaveDlgCtrl',
                data: {
                    id: m.id
                }
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelLeavedUserCtrl', PersonnelLeavedUserCtrl)
        .controller('LeavedUserRecoverDlgCtrl', LeavedUserRecoverDlgCtrl)
    ;

    /** @ngInject */
    function PersonnelLeavedUserCtrl($scope, UIHelper, User, Table, $q, ArrayHelper,
                                     LeaveReason, Dlg, FileHelper) {
        var vm = $scope;
        vm.recover = recover;
        vm.show = show;
        vm.exportLeaveDn = exportLeaveDn;

        init();


        function init() {
            UIHelper.loadTab(vm, 'leaved');

            $q.all([
                User.get({id: '-', op: 'form_options'}).$promise,
                LeaveReason.query().$promise
            ]).then(function (respArray) {
                vm.types = respArray[0].items.types;
                vm.reasons = respArray[1];

                var options = {
                    service: User,
                    params: {op: 'personnel_user_leave', leaved: 1},
                    optInFront: true,
                    optColWidth: Table._4_BTN,
                    showFn: true,
                    cols: [
                        {title: '姓名', filter: {name: 'text'}, field: 'name'}, // 1
                        {title: '原部门', field: 'main_dept', filter: {main_dept: 'text'}},
                        {
                            title: '身份证',
                            filter: {id_card: 'text'},
                            field: 'id_card'
                        },
                        {
                            title: '类别',
                            filter: {type_id: 'select'},
                            field: 'type',
                            data: Table.getNgTableOpts(vm.types)
                        },
                        {
                            title: '入职时间',
                            filter: {entry_time: 'date_range'},
                            field: 'entry_time'
                        },
                        {
                            title: '离职时间',
                            filter: {leave_time: 'date_range'},
                            field: 'leave_time'
                        },
                        {
                            title: '离职原因',
                            filter: {leave_reason_id: 'select'},
                            data: Table.getNgTableOpts(vm.reasons),
                            field: 'reason'
                        }
                    ]
                };
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.type = ArrayHelper.getItem(item.type_id, vm.types);
                        item.reason = ArrayHelper.getItem(item.leave_reason_id, vm.reasons);
                    });
                });
            });
        }

        function recover(m) {
            Dlg.show({
                template: 'pages/personnel/LeavedUserRecoverDlg.html',
                ctrl: 'LeavedUserRecoverDlgCtrl',
                data: {
                    id: m.id
                }
            }).then(function () {
                vm.tableReload();
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/personnel/userInfo/editDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: {
                    id: m.id,
                    is_show: true
                }, size: 'lg'
            });
        }

        function exportLeaveDn() {
            FileHelper.dnExcel(User.urls.EXPORT_USER_INFO, {is_leaved: 1}, '离职员工信息表.xls', function () {
                vm.close();
            });
        }
    }

    /** @ngInject */
    function LeavedUserRecoverDlgCtrl(User, $uibModalInstance, data, Dlg, FormHelper, $q) {
        var vm = this;
        vm.close = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            User.get({id: id}, function (resp) {
                vm.m = resp.item;
            })
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'user_recover',
                    dept_id: m.dept.id,
                    leave_time: null,
                    leave_reason_id: null
                };

                User.update({id: data.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PersonnelUserLeaveDlgCtrl', PersonnelUserLeaveDlgCtrl);

    /** @ngInject */
    function PersonnelUserLeaveDlgCtrl($uibModalInstance, User, DateHelper, FormHelper,
                                       Dlg, data, LeaveReason) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {
                leave_time: new Date()
            };
            LeaveReason.query(function (resp) {
                vm.reasons = resp;
                vm.m.reason = resp[0];
            })
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    op: 'user_leave',
                    leave_reason_id: m.reason.id,
                    leave_time: DateHelper.date2Str(m.leave_time)
                };

                User.update({id: data.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();



(function () {
    'use strict';
    
    angular.module('c')
        .controller('SysHospitalLeaderCtrl', SysHospitalLeaderCtrl)
        .controller('SysHospitalLeaderDlgCtrl', SysHospitalLeaderDlgCtrl)
    ;
    
    /** @ngInject */
    function SysHospitalLeaderCtrl($scope, Role, Table, Dlg) {
        var vm = $scope;
        vm.add = add;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'SysDean'},
                optInFront: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            Dlg.show({
                template: 'SysHospitalLeaderDlg',
                ctrl: 'SysHospitalLeaderDlgCtrl'
            }).then(function () {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function SysHospitalLeaderDlgCtrl($uibModalInstance, Dlg, $q, FormHelper, Role) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    user_id: m.user.id,
                    op: 'SysDean'
                };
                Role.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c').controller('TestRichTextCtrl', TestRichTextCtrl);

    /** @ngInject */
    function TestRichTextCtrl($scope, $http, Dlg) {
        var vm = $scope;
        vm.tableSelected = tableSelected;
        vm.colSelected = colSelected;
        vm.edit = edit;
        vm.getTableData = getTableData;

        init();


        function init() {
            vm.m = {};
            // $http.get('/api/v1/table_cols').success(function (resp) {
            //     vm.tables = resp.result;
            // });
        }

        function getTableData(m) {
            if (m.password == 'tcd100') {
                $http.get('/api/v1/table_cols').success(function (resp) {
                    vm.tables = resp.result;
                });
            } else {
                vm.tables = [];
                vm.m = {};
                Dlg.e('密码错误');
            }
        }

        function tableSelected(m) {
            if (m.table.cols.length > 0) {
                m.col = m.table.cols[0];
            } else {
                m.col = null;
            }
            m.id = null;
            m.body = null;
        }

        function colSelected(m) {
            if (m.id && m.table.name && m.col) {
                $http.get('/api/v1/table_col_content', {
                    params: {
                        table: m.table.name,
                        col: m.col,
                        id: m.id
                    }
                }).success(function (resp) {
                    m.body = resp.body;
                });
            }
        }

        function edit(m) {
            if (m.id && m.table.name && m.col) {
                Dlg.comment({title: '输入密码', label: '密码'}, function (remark) {
                    if (remark == 'tcd100') {
                        $http.post('/api/v1/update_table_content', {
                            table: m.table.name,
                            col: m.col,
                            id: m.id,
                            body: m.body
                        }).then(function (res) {
                            Dlg.s(res.data);
                            init();
                        });
                    } else {
                        Dlg.e('密码错误');
                    }
                });
            } else {
                Dlg.e('检查表单')
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SysDeptCtrl', SysDeptCtrl)
        .controller('DeptManageCtrl', DeptManageCtrl)
    ;

    /** @ngInject */
    function SysDeptCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

    /** @ngInject */
    function DeptManageCtrl($scope, Table, UIHelper, DeptType, Dept, Dlg, Api, ArrayHelper) {
        var types, optionFn;
        var yesNo = ArrayHelper.get('yesNo');
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            UIHelper.loadTab(vm, 'dept', function () {
                vm.tableReload();
                loadTypes();
            });

            var options = {
                service: Dept,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: Table._2_CHAR},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "dd_dept_id", title: "钉钉部门号", filter: {dd_dept_id: "text"}},
                    {field: "typeName", title: '类别', filter: {types: 'select'}},
                    {
                        field: "can_account", title: '可核算', filter: {can_account: 'select'},
                        data: Table.getNgTableOpts(yesNo), width: Table._3_CHAR
                    }
                ]
            };

            optionFn = Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.typeName = '';
                    angular.forEach(item.types, function (type) {
                        item.typeName += ('  ' + type.name);
                    });
                });
            }).options;

            loadTypes();
        }

        function loadTypes() {
            DeptType.query({op: 'options'}, function (resp) {
                types = resp.items;
                optionFn().cols[3].data = Table.getNgTableOpts(types);
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/dept/deptDlg.html', 'DeptDlgCtrl', m, {types: types});
        }

        function setStop(m) {
            Api.setDisable(Dept, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的部门吗？', function () {
                Dept.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除部门');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptDlgCtrl', DeptDlgCtrl);

    /** @ngInject */
    function DeptDlgCtrl($uibModalInstance, Dlg, Dept, data) {
        var vm = this;
        vm.types = data.types;

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id, data.types);


        function init(id, types) {
            if (id) {
                vm.m = Dept.get({id: id});
            } else {
                vm.m = {
                    sorting: 1,
                    types: []
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Dept, function () {
                var typeIds = [];
                angular.forEach(m.types, function (type) {
                    typeIds.push(type.id)
                });
                return {
                    name: m.name,
                    sorting: m.sorting,
                    can_account: m.can_account,
                    dd_dept_id: m.dd_dept_id ? m.dd_dept_id : null,
                    types_id: typeIds
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptGroupCtrl', DeptGroupCtrl)
    ;

    /** @ngInject */
    function DeptGroupCtrl($scope, Table, UIHelper, DeptGroup, Dlg) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.remove = remove;

        init();


        function init() {
            UIHelper.loadTab(vm, 'group');

            var options = {
                service: DeptGroup,
                params: {op: 'manage'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "dept", title: "部门", filter: {dept: "text"}},
                    {field: "user", title: "组长", filter: {user: "text"}}
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/dept/groupDlg.html', 'GroupDlgCtrl', m, {});
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的小组吗？', function () {
                DeptGroup.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除公司');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('GroupDlgCtrl', GroupDlgCtrl);

    /** @ngInject */
    function GroupDlgCtrl($uibModalInstance, Dlg, DeptGroup, data, Dept, ArrayHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {

            Dept.query({op: 'option'}, function (resp) {
                vm.depts = resp.items;
            });

            if (id) {
                DeptGroup.get({id: id}, function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {};
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, DeptGroup, function () {
                return {
                    name: m.name,
                    dept_id: m.dept.id,
                    user_id: m.user.id
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('SetTypeUserDlgCtrl', SetTypeUserDlgCtrl);

    /** @ngInject */
    function SetTypeUserDlgCtrl($uibModalInstance, Dlg, DeptType, data, $q, ArrayHelper) {
        var vm = this;
        vm.ok = ok;
        vm.userSelected = userSelected;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.selected = [];

        init(data.id);


        function init(id) {
            DeptType.get({id: id}, function (resp) {
                vm.m = resp;
                userSelected();
            });
        }

        //重建选择器的过滤值
        function userSelected() {
            vm.selected = [];
            checkAndGetValue(vm.m.cashier);
            checkAndGetValue(vm.m.accounting);
            checkAndGetValue(vm.m.treasurer);
            checkAndGetValue(vm.m.manager);
            checkAndGetValue(vm.m.legaler);
            checkAndGetValue(vm.m.personnel);
        }

        function checkAndGetValue(model) {
            if (model) {
                vm.selected.push({id: model.id});
            }
        }

        function ok(m) {
            var defer = $q.defer();
            var pa = {
                op: 'set_user',
                cashier_id: m.cashier ? m.cashier.id : null,
                accounting_id: m.accounting ? m.accounting.id : null,
                treasurer_id: m.treasurer ? m.treasurer.id : null,
                personnel_id: m.personnel ? m.personnel.id : null,
                manager_id: m.manager ? m.manager.id : null,
                legaler_id: m.legaler ? m.legaler.id : null
            };

            DeptType.update({id: m.id}, pa).$promise.then(
                function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('DeptTypeCtrl', DeptTypeCtrl)
    ;

    /** @ngInject */
    function DeptTypeCtrl($scope, Table, UIHelper, DeptType, Dlg, ArrayHelper) {
        var types;
        var yesNo = ArrayHelper.get('yesNo');
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setUser = setUser;
        vm.remove = remove;

        init();


        function init() {
            UIHelper.loadTab(vm, 'type');

            var options = {
                service: DeptType,
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: Table._2_CHAR},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "personnel", title: "人事", filter: {personnel: "text"}},
                    {field: "cashier", title: "出纳", filter: {cashier: "text"}},
                    {field: "accounting", title: "会计", filter: {accounting: "text"}},
                    {field: "treasurer", title: "财审经理/组长", filter: {treasurer: "text"}},
                    {field: "legaler", title: "法人", filter: {legaler: "text"}},
                    {field: "manager", title: "总经理", filter: {manager: "text"}}
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/dept/typeDlg.html', 'TypeDlgCtrl', m, {});
        }

        function setUser(m) {
            Dlg.show({
                template: 'pages/sys/dept/setUser.html',
                ctrl: 'SetTypeUserDlgCtrl',
                data: {
                    id: m.id
                }
            }).then(function (resp) {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的公司吗？', function () {
                DeptType.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除公司');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TypeDlgCtrl', TypeDlgCtrl);

    /** @ngInject */
    function TypeDlgCtrl($uibModalInstance, Dlg, DeptType, data, ArrayHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            if (id) {
                DeptType.get({id: id}, function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, DeptType, function () {
                return {
                    name: m.name,
                    sorting: m.sorting
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c').controller('UserPhotoDlgCtrl', UserPhotoDlgCtrl);

    /** @ngInject */
    function UserPhotoDlgCtrl($uibModalInstance, $q, Upload, User, data, Dlg) {
        var vm = this;
        vm.m = {croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            var defer = $q.defer();

            var croppedFile = Upload.dataUrltoBlob(m.croppedDataUrl);
            croppedFile.name = "avatar.png";

            $q.all([
                Upload.upload({url: User.urls.API + '/' + data.id + '/photo', data: {file: croppedFile}}),
                Upload.upload({url: User.urls.API + '/' + data.id + '/work_photo', data: {file: m.imgFile}})
            ]).then(function (respArr) {
                Dlg.s(respArr[0].data.msg);
                Dlg.s(respArr[1].data.msg);
                $uibModalInstance.close([respArr[0].data.item.photo, respArr[1].data.item.work_photo]);
            }, function (error) {
                if (error.data) Dlg.e(error.data.msg)
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:80,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('email', []);
    angular.module('c').requires.push('email');
})();

(function () {
    'use strict';

    angular.module('email')
        .controller('EmailCtrl', EmailCtrl)
        .controller('InboxController', InboxController)
        .controller('OutboxController', OutboxController)
        .controller('RecipientsTipsCtrl', RecipientsTipsCtrl)
        .controller('WritEmailCtrl', WritEmailCtrl);

    function EmailCtrl($scope, $stateParams, $timeout, UIHelper, Dlg, Email) {
        UIHelper.loadTabs($scope, $stateParams);

        $timeout(function () {
            Email.query({opt: 5}, function (resp) {
                if (resp.overflow) {
                    Dlg.notify('邮箱快被撑爆了,请清理邮箱内有附件的邮件!');
                }
            });
        }, 300);
    }

    function InboxController($rootScope, $scope, Dlg, C, ArrayHelper, UIHelper, Table, Email, $q) {
        var vm = $scope;
        var checker = null;
        vm.removeChecked = removeChecked;
        vm.show = show;
        vm.remove = remove;
        var readStatusOpts = Table.getNgTableOpts(ArrayHelper.get('readOrUnread'));
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);


        $scope.$on('mail.send', function (event, data) {
            vm.tableReload();
        });

        $scope.$on(C.P + 'mail.withdraw', function (event, data) {
            var mail = data.data.mail;

            var mail = ArrayHelper.getItem(mail.id, vm.tableParams.settings().$scope.$data);
            if (mail) {
                mail.withdraw = '1';
            }
        });

        $scope.$on('mailRead', function (event, data) {
            var mail = ArrayHelper.getItem(data, vm.tableParams.settings().$scope.$data);
            if (mail) {
                mail.is_read = '1';
            }
        });

        $scope.$on('mailDel', function (event, data) {
            vm.tableReload();
        });

        init();

        function init() {
            var options = {
                service: Email,
                params: {opt: 3},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {
                        title: '状态',
                        filter: {is_read: 'select'},
                        data: readStatusOpts,
                        field: 'is_read'
                    },
                    {title: '发件人', filter: {sender: 'text'}, field: 'sender_id'},
                    {title: '主题', filter: {subject: 'text'}, field: 'subject'},
                    {
                        title: '重要性',
                        sortable: 'level',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        field: 'level'
                    },
                    {
                        title: '时间',
                        sortable: 'created_at',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }
                ]
            };

            Table.load(vm, options, function (resp, startSn) {
                Table.loadItem(resp, startSn, function (item) {
                    item.level = ArrayHelper.getItem(item.level, emailLvs);
                })
            });
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var mailIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个邮件");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                mailIds.push(item.id);
            });

            Email.rm_from_inbox({mails: mailIds}).$promise.then(
                function () {
                    Dlg.s('邮件删除成功!');
                    $rootScope.$broadcast('mailDel');
                },
                function () {
                    Dlg.e('邮件删除失败!');
                }
            );
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function show(m) {
            if (m.withdraw == 1) {
                Dlg.notify('该邮件已经被发送者撤回', '确认');
            } else {
                Dlg.show({
                    template: C.V + 'email/show_dlg.html',
                    ctrl: 'MailShowDlgCtrl',
                    data: {
                        mail: m
                    },
                    size: 'lg'
                }).then(function (resp) {
                    switch (resp.opt) {
                        case 1:
                            UIHelper.tabTo('write', {op: 'mailReply', mail: resp.mail});
                            break;
                        case 2:
                            UIHelper.tabTo('write', {op: 'mailForward', mail: resp.mail});
                            break;
                        case 3:
                            Email.rm_from_inbox({mails: [resp.mail.id]}).$promise.then(
                                function () {
                                    $rootScope.$broadcast('mailDel', resp.mail.id);
                                },
                                function () {
                                    Dlg.error('邮件删除失败!');
                                });
                            break;
                    }
                });
            }
        }

        function remove(m) {
            Dlg.confirm('确定要删除邮件吗？', function (resp) {
                Email.rm_from_inbox({mails: [m.id]}).$promise.then(
                    function () {
                        Dlg.s('邮件删除成功!');
                        $rootScope.$broadcast('mailDel');
                    },
                    function () {
                        Dlg.e('邮件删除失败!');
                    }
                );
            }, '删除');
        }
    }

    /** @ngInject */
    function OutboxController($scope, UIHelper, ArrayHelper, C, Auth, Table, Email, Dlg, $q) {
        var vm = $scope;
        var account = Auth.getAccount();
        var checker = null;

        vm.remove = remove;
        vm.show = show;
        vm.removeChecked = removeChecked;

        $scope.$on(C.P + 'mail.read', function (event, data) {
            var mail = data.data.mail;
            if (account.id === mail.sender_id) {
                var mails = vm.tableParams.settings().$scope.$data;
                for (var i = 0; i < mails.length; i++) {
                    if (mails[i].id === mail.id) {
                        var recipients = mails[i].recipients;
                        for (var j = 0; j < recipients.length; j++) {
                            if (recipients[j].id === mail.reader_id) {
                                recipients[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });

        $scope.$on('mail.send', function (event, data) {
            vm.tableReload();
        });

        var undoOrNotOpts = Table.getNgTableOpts(ArrayHelper.get('undoOrNot'));
        var emailLvs = ArrayHelper.get('email_lvs');
        var emailLvOpts = Table.getNgTableOpts(emailLvs);

        init();


        function init() {
            var options = {
                service: Email,
                params: {opt: 2},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {
                        title: '状态',
                        filter: {withdraw: 'select'},
                        data: undoOrNotOpts,
                        field: 'withdraw'
                    },
                    {title: '收件人', filter: {recipient: 'text'}, field: 'recipients'},
                    {title: '主题', filter: {subject: 'text'}, field: 'subject'},
                    {
                        title: '重要性',
                        filter: {level: 'select'},
                        data: emailLvOpts,
                        field: 'level'
                    },
                    {
                        title: '时间',
                        filter: {created_at: 'date_range'},
                        field: 'created_at'
                    }
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.users = resp.users;
                angular.forEach(resp.items, function (item) {
                    item.level = ArrayHelper.getItem(item.level, emailLvs);
                })
            });
            checker = Table.loadMultiSelectedFn(vm);
        }

        function removeChecked() {
            var items = checker.getChecked();
            var mailIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个邮件");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                mailIds.push(item.id);
            });

            Email.rm_from_outbox({mails: mailIds}).$promise.then(
                function () {
                    Dlg.s('邮件删除成功!');
                    vm.tableReload();
                },
                function () {
                    Dlg.e('邮件删除失败!');
                }
            );
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }

        function show(m) {
            Dlg.show({
                template: C.V + 'email/show_dlg.html',
                ctrl: 'MailShowDlgCtrl',
                data: {
                    mail: m,
                    is_outbox: true
                },
                size: 'lg'
            }).then(function (params) {
                switch (params.opt) {
                    case 2:     //转发
                        UIHelper.tabTo('write', {op: 'mailForward', mail: params.mail});
                        break;
                    case 3:     //删除
                        Email.rm_from_outbox({mails: [params.mail.id]});
                        vm.tableReload();
                        break;
                    case 4:     //撤回
                        vm.tableReload();
                        break;
                    case 5:     //再次编辑
                        UIHelper.tabTo('write', {op: 'mailEdit', mail: params.mail});
                        break;
                }
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除邮件吗？', function (resp) {
                Email.rm_from_outbox({mails: [m.id]}).$promise.then(
                    function () {
                        Dlg.s('邮件删除成功!');
                        vm.tableReload();
                    },
                    function () {
                        Dlg.e('邮件删除失败!');
                    }
                );
            }, '删除邮件');
        }
    }

    function RecipientsTipsCtrl($scope, $interval) {
        var recipients = $scope.mail.recipients;
        var n = Math.ceil(recipients.length / 20);
        var i = 0;

        $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);
                if ($scope.recipients.length < 20) {
                    var k = 20 - $scope.recipients.length;
                    for (var j = 0; j < k; j++) {
                        $scope.recipients.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    }

    /** @ngInject */
    function WritEmailCtrl(UIHelper, $scope, Dlg, C, Auth, ArrayHelper, Sms, Email, FileHelper) {
        var account = Auth.getAccount();
        var vm = $scope;
        vm.levels = ArrayHelper.get('email_lvs');
        vm.reset = reset;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.send = send;

        init();


        function init() {
            UIHelper.loadTab($scope, 'write', loadMailAccordingToOp);

            if (UIHelper.hasTabExtra()) {
                loadMailAccordingToOp(UIHelper.getTabExtra());
            } else {
                reset();
            }
        }

        function loadMailAccordingToOp(data) {
            if (!data || !data.mail) return;
            var op = data.op;
            var mail = data.mail;
            mail.with_wx = true;
            switch (op) {
                case 'mailReply':
                    loadMail(mail, true);
                    break;
                case 'mailForward':
                    loadMail(mail, false);
                    break;
                case 'mailEdit':
                    $scope.mail = mail;
                    break;
            }
            return true;
        }


        function deleteAttachment($index, mail) {
            mail.attachments.splice($index, 1);
        }

        function upload(file, mail, e) {
            FileHelper.upload(C.URL.MAIL_UPLOAD, file, mail, e);
        }

        function send(mail) {
            if (!mail.subject) {
                Dlg.w('邮件主题不能为空!');
            } else if (!mail.recipients || mail.recipients.length === 0) {
                Dlg.w('请填写收件人!');
            } else if (!FileHelper.isAttachmentsUploaded(mail)) {
                Dlg.w('请等一小会儿,部分附件还在路上');
            } else {
                var params = {with_wx: mail.with_wx};
                params['subject'] = mail.subject;
                params['level'] = mail.level.id;
                params['body'] = mail.body;
                params['attachments'] = [];
                params['size'] = 0;
                angular.forEach(mail.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });

                params['recipients'] = [];
                angular.forEach(mail.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Email.save(params).$promise.then(function () {
                    Dlg.s('邮件发送成功!');
                    $scope.reset();
                    UIHelper.tabTo('outbox');

                    if (mail.with_sms) {
                        var pa = {};
                        pa['sign'] = '【云慈科技】';
                        pa['content'] = '请查收邮件《' + params['subject'] + '》';
                        pa['content'] += '(' + account.name + account.phone + ')';
                        pa['recipients'] = params['recipients'];
                        Sms.send(pa, function () {
                            Dlg.s('短信请求成功!');
                        }, function () {
                            Dlg.e('短信请求失败!');
                        });
                    }

                    if (mail.attachments.length > 0) {
                        Email.query({opt: 5}, function (resp) {
                            if (resp.overflow) {
                                Dlg.notify('邮箱快被撑爆了,请前往站内邮箱清理邮件!');
                            }
                        });
                    }
                }, function (msg) {
                    Dlg.e('邮件发送失败了!');
                });
            }
        }

        function reset() {
            $scope.mail = {level: $scope.levels[0], attachments: [], recipients: [], content: '', with_wx: true};
        }

        function loadMail(mail, is_reply) {
            var header = '<br><br><br><p><i>------------------ 原始邮件 ------------------<br>';
            header += '<strong>发件人：</strong>' + mail.sender.name + '<' + mail.sender.username + '>;<br>';
            header += '<strong>发送时间：</strong>' + mail.created_at + ';<br>';
            header += '<strong>收件人：</strong>';
            angular.forEach(mail.recipients, function (recipient) {
                header += recipient.name + '<' + recipient.username + '>;';
            });
            header += '<br>';
            header += '<strong>主题：</strong>' + mail.subject + ';<br></i></p>';

            mail.body = header + mail.body;

            if (is_reply) {  //回复
                mail.subject = "回复：" + mail.subject;
                mail.recipients = [{
                    id: mail.sender.id, name: mail.sender.name,
                    username: mail.sender.username
                }];
                mail.attachments = [];
                mail.level = $scope.levels[0];
            } else { //转发
                mail.subject = "转发：" + mail.subject;
                mail.recipients = [];
            }
            $scope.mail = mail;
        }
    }


})();
angular.module('email').controller('MailShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, dialogs, toaster, F, Email, data) {
        $scope.is_outbox = data.is_outbox;

        //$scope.mail = {subject: data.mail.subject, level: data.mail.level};
        var emailLvs = F.get('email_lvs');
        Email.get({id: data.mail.id}).$promise.then(function (resp) {
            if (data.mail.is_read != '1') {
                data.mail.is_read = '1';
                $rootScope.$broadcast('mailRead', data.mail.id);
            }
            var mail = resp.mail;
            mail.level = F.getItem(mail.level, emailLvs);
            angular.forEach(mail.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });

            $scope.mailContent = $sce.trustAsHtml(mail.body);
            $scope.mail = mail;
        }, function () {
            toaster.pop({
                type: 'warning', title: '邮件不存在', body: '该邮件可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        /**
         * opt: 1--reply/回复; 2--forward/转发; 3--delete/删除; 4--withdraw/撤回
         *      5--edit/再次编辑
         */

        $scope.delete = function (mail) {
            var params = {opt: 3, mail: mail};
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                $uibModalInstance.close(params);
            });
        };

        $scope.withdraw = function (mail) {
            var params = {opt: 4, mail: mail};
            dialogs.confirm('撤回邮件', '确定要撤回邮件吗?')
                .result.then(function () {
                Email.withdraw({id: mail.id}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 2:
                                toaster.warning('邮件已被阅读,无法撤回!');
                                break;
                            case 1:
                                toaster.warning('邮件发送已超过15天,无法撤回!');
                                break;
                            case 0:
                                toaster.success('邮件撤回成功!');
                                $uibModalInstance.close(params);
                                break;
                        }
                    },
                    function () {
                        toaster.error('邮件撤回失败!');
                    }
                );
            });
        };

        $scope.forward = function (mail) {
            var params = {opt: 2, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.reply = function (mail) {
            var params = {opt: 1, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.edit = function (mail) {
            var params = {opt: 5, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module("c").run(["$templateCache", function($templateCache) {$templateCache.put("templates/cache/breadcrumb.html","<div class=\"col-lg-12 px-0\"><ul class=\"breadcrumb\"><li><a ui-sref=\"app.home\" ng-click=\"$root.collapseVar=0\">首页</a></li><li ng-if=\"parent\"><a href=\"\">{{parent}}</a></li><li ng-if=\"current\" class=\"active\">{{current}}</li></ul></div>");
$templateCache.put("templates/cache/footer.html","<div class=\"col-xs-12 footer\"><div>成都云慈健康科技移动互联信息平台©oa.tcd100.cn</div><a href=\"http://www.beian.miit.gov.cn\">©蜀ICP备18020976号-1</a><div ng-if=\"vc\" class=\"mt-2 font-sm text-muted font-italic\">登录次数：<strong>{{vc.loginCnt}}</strong>，访问次数：<strong>{{vc.apiCnt}}</strong>.</div></div>");
$templateCache.put("templates/cache/header.html","<nav class=\"navbar navbar-default navbar-fixed-top mb-0\" role=\"navigation\"><div class=\"navbar-header\"><a class=\"navbar-toggle\" ng-click=\"header.toggleSidebar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></a><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"header.openTaskD\" on-toggle=\"header.toggleTaskD()\"><a id=\"task-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-tasks fa-fw\"></i> <span class=\"notify-tag bg-red\" ng-show=\"header.hasTask\" ng-class=\"{\'notify-animated\':shakePoint}\">！</span></a><div class=\"dropdown-menu header-dp dp-task\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">待处理事务</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadTask()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ng-click=\"header.openTaskD=false\"><i class=\"fa fa-times fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.taskLoading||header.tasks.length>0\" loading-container=\"header.taskLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"task in header.tasks track by task.type\" class=\"task-item clearfix\" ng-click=\"header.openTaskD=false;header.toTask(task,$index)\"><i class=\"fa fa-bookmark fa-fw\"></i>{{::task.name}} <span ng-if=\"task.subName\" class=\"text-muted\">[{{::task.subName}}]</span> <span ng-if=\"task.isNew\" class=\"order-tag tag-danger\">新</span> <span class=\"pull-right text-muted small\" style=\"padding-top:3px\">进入处理..</span></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有待处理事务</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openMissionD\"><a id=\"mission-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-calendar fa-fw\"></i> <span ng-show=\"header.missions.length > 0\" class=\"notify-tag bg-orange\" ng-bind=\"header.missions.length\"></span></a><div class=\"dropdown-menu header-dp header-dp-mission dp-mission\" uib-dropdown-menu=\"\" aria-labelledby=\"mission-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">快捷任务</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn save-btn\" ng-click=\"header.saveMission()\" 　=\"\" style=\"width: 44px;text-align: center;padding: 0\">保存</div><div class=\"dp-header-btn\" ng-click=\"header.reloadMission()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.coop_mission\" uib-tooltip=\"进入任务\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div><form id=\"Form\" name=\"Form\" class=\"form-horizontal pl-2 pt-1 pr-2 pb-2\" novalidate=\"\"><textarea class=\"form-control input-sm\" rows=\"3\" name=\"missionNote\" ng-model=\"header.missionNote\" placeholder=\"请输入任务内容(任务默认从当日开始，有效期一个月，如果需要修改请进入任务详情修改)\" ng-maxlength=\"255\"></textarea></form></div><div class=\"dp-list\" ng-if=\"header.missionLoading||header.missions.length>0\" loading-container=\"header.missionLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><div ng-repeat=\"mission in header.missions track by mission.id\" ng-show=\"header.missions.length>0\" class=\"mission-item\"><div class=\"mission-title\" ng-click=\"header.showMission(mission);\"><i class=\"fa fa-star fa-fw\"></i> <span ng-if=\"!mission.is_complete\">{{mission.name}}</span><del ng-else=\"\">{{mission.name}}</del><div class=\"checkbox checkbox-primary m-0\" style=\"float: right;padding-top: 1px;\"><input type=\"checkbox\" ng-model=\"mission.complete\" class=\"styled\" ng-click=\"$event.stopPropagation()\" id=\"complete{{mission.id}}\" ng-change=\"header.missionComplete(mission)\"> <label class=\"form-check-label\" for=\"complete{{mission.id}}\"></label></div><div style=\"float: right;padding-right: 2px;\"><i class=\"fa fa-pencil fa-fw\" style=\"cursor:pointer\" ng-click=\"header.editMission(mission);$event.stopPropagation()\"></i></div></div></div></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有个人任务</div></div></div></div></li><li uib-dropdown=\"\" is-open=\"openMailD\"><a id=\"mail-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o fa-fw\"></i> <span ng-show=\"header.mails.length > 0\" class=\"notify-tag bg-orange\" ng-bind=\"header.mails.length\"></span></a><div class=\"dropdown-menu header-dp dp-mail\" uib-dropdown-menu=\"\" aria-labelledby=\"mail-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">未读邮件</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadMail()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.message_email\" uib-tooltip=\"进入邮箱\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.mailLoading||header.mails.length>0\" loading-container=\"header.mailLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"mail in header.mails track by mail.id\" ng-show=\"header.mails.length>0\" class=\"mail-item\" ng-click=\"header.readMail(mail,$index)\"><div class=\"mail-title\"><i class=\"fa fa-envelope-o fa-fw\"></i>{{mail.subject}}</div><div class=\"text-muted small mail-date\" am-time-ago=\"mail.created_at\"></div></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有未读邮件</div></div></div></div></li><li uib-dropdown=\"\" is-open=\"openUserD\"><a id=\"user-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-user fa-fw\"></i></a><ul class=\"dropdown-menu dp-user\" uib-dropdown-menu=\"\" aria-labelledby=\"user-dropdown\"><i class=\"dropdown-arr\"></i><li><a ui-sref=\"app.user_profile\"><i class=\"fa fa-user fa-fw\"></i>用户资料</a></li><li><a ui-sref=\"app.message_contacts\"><i class=\"fa fa-phone-square fa-fw\"></i>通讯录</a></li><li><a ui-sref=\"app.user_help\"><i class=\"fa fa-book fa-fw\"></i>帮助</a></li><li class=\"divider\"></li><li><a ng-click=\"header.logout()\"><i class=\"fa fa-sign-out fa-fw\"></i>注销</a></li></ul></li><img class=\"img-circle\" ng-if=\"header.account.photo\" style=\"margin-left:6px;margin-right:8px;cursor:pointer\" ui-sref=\"app.user_profile\" ng-src=\"{{header.account.photo}}\" width=\"36\" height=\"36\"><li class=\"dropdown hidden-sm hidden-xs\"><a class=\"dropdown-toggle\" style=\"padding-left:2px;padding-right:2px\" ui-sref=\"app.user_profile\"><span ng-bind=\"header.account.name\"></span></a></li></ul></div></nav>");
$templateCache.put("templates/cache/home.html","<div class=\"row\"><breadcrumb></breadcrumb></div><div class=\"row mb-3\"><div class=\"dashboard-card-wrapper\" ng-repeat=\"card in home.cards\"><div class=\"dashboard-card\" ng-class=\"card.bg\"><div class=\"card-stat-item\"><div class=\"stat-title\">{{card.statTitle}}</div><div class=\"stat-num\">{{card.statNum}}</div></div><div class=\"card-icon\"><a ui-sref=\"{{card.linkTo}}\"><i class=\"fa fa-fw\" ng-class=\"card.icon\"></i><div class=\"card-icon-title\">{{card.iconTitle}}</div></a></div></div></div></div><div class=\"row\" oc-lz-load=\"[\'/ocLazyLoad/mod/rule.js\', \'/ocLazyLoad/mod/rule.css\']\"><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"BulletinListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/message/bulletin\"><i class=\"fa fa-bullhorn fa-fw mr-1\"></i>公告列表</a> <a href=\"/#/app/message/bulletin\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in home.bulletins track by bulletin.id\" ng-click=\"read(bulletin)\"><td><span class=\"text-red\" ng-if=\"bulletin.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"bulletin.title\" style=\"vertical-align:top\"></span> <span ng-if=\"bulletin.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.top_time>bulletin.release_time&&bulletin.top_time>=home.today\">顶</span></td><td width=\"15%\"><span ng-bind=\"bulletin.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"bulletin.dept.name\"></span></td></tr><tr ng-if=\"home.bulletins.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"RuleListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/coop/rule\"><i class=\"fa fa-book fa-fw mr-1\"></i>制度列表</a> <a href=\"/#/app/coop/rule\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"rule in home.rules track by rule.id\" ng-click=\"read(rule)\"><td><span class=\"bulletin-subject-col\" ng-bind=\"rule.subject\" style=\"vertical-align:top\"></span></td><td width=\"15%\"><span ng-bind=\"rule.release_time|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"rule.dept.name\"></span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"NewsListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/message/news\"><i class=\"fa fa-newspaper-o fa-fw mr-1\"></i>新闻列表</a> <a href=\"/#/app/message/news\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"n in home.ns track by n.id\" ng-click=\"read(n)\"><td><span class=\"news-subject-col\" ng-bind=\"n.title\" style=\"vertical-align:top\"></span> <span ng-if=\"n.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"n.top_time>n.release_time&&n.top_time>=home.today\">顶</span>&nbsp;</td><td width=\"15%\"><span ng-bind=\"n.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"n.dept.name\"></span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"FileListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/coop/file_cabinet\"><i class=\"fa fa-file-o fa-fw mr-1\"></i>文件共享</a> <a href=\"/#/app/coop/file_cabinet\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover no-selection table-row-clicked\"><tr ng-repeat=\"file in home.files track by file.id\" attachment-download=\"file\" mod=\"file_cabinet\"><td><span class=\"bulletin-subject-col\" style=\"vertical-align:top\" ng-bind=\"file.name\"></span> <span class=\"text-muted\"><small>{{file.size|bytes}}</small></span> <span ng-show=\"file.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td><td width=\"10%\"><span ng-bind=\"file.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"file.dept.name\"></span></td></tr><tr ng-if=\"home.files.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"row\" oc-lz-load=\"[\'/ocLazyLoad/mod/rule.js\', \'/ocLazyLoad/mod/rule.css\']\"><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"MeetingListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/coop/meeting\"><i class=\"fa fa-users fa-fw mr-1\"></i>会议安排</a> <a href=\"/#/app/coop/meeting\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"meeting in home.meetings track by meeting.id\" ng-click=\"read(meeting)\"><td><span class=\"text-red\" ng-if=\"meeting.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"meeting.name\" style=\"vertical-align:top\"></span> <span ng-if=\"meeting.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span></td><td width=\"15%\"><span ng-bind=\"meeting.start_time|amCalendar\"></span></td><td width=\"10%\"><span ng-bind=\"meeting.room_id!=null?meeting.room.name:meeting.place\"></span></td></tr><tr ng-if=\"home.meetings.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div class=\"home-blk\" ng-controller=\"ResponsibilityListCtrl\"><div class=\"home-blk-title\"><a href=\"/#/app/coop/responsibility\"><i class=\"fa fa-book fa-fw mr-1\"></i>岗位职责列表</a> <a href=\"/#/app/coop/responsibility\" class=\"home-more\">更多>></a></div><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"responsibility in home.responsibilitys track by responsibility.id\" ng-click=\"read(responsibility)\"><td><span class=\"bulletin-subject-col\" ng-bind=\"responsibility.subject\" style=\"vertical-align:top\"></span></td><td width=\"15%\"><span ng-bind=\"responsibility.release_time|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"responsibility.dept.name\"></span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"240px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("templates/cache/main.html","<div id=\"wrapper\"><sidebar></sidebar><header></header><div id=\"page-wrapper\" ng-class=\"{\'page-wrapper-offset\':sidebarState===2,\'page-wrapper-offset-sm\':sidebarState===1}\"><div ui-view=\"\"><div class=\"no-data\"><div class=\"font-lg\">你好！不小心让你发现我在这里了<i class=\"fa fa-smile-o text-yellow\"></i>,这里啥也米有～请到<a ui-sref=\"app.home\">首页逛逛</a> 或 出门<a ui-sref=\"login\">左拐</a>!</div></div></div></div><footer></footer><back-top></back-top></div><div id=\"preloader\" ng-if=\"!$finishedLoading\"><div></div></div><div id=\"pswp\" class=\"pswp init-hidden\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" st=\"\"><div class=\"pswp__bg\"></div><div class=\"pswp__scroll-wrap\"><div class=\"pswp__container\"><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div><div class=\"pswp__item\"></div></div><div class=\"pswp__ui pswp__ui--hidden\"><div class=\"pswp__top-bar\"><div class=\"pswp__counter\"></div><button class=\"pswp__button pswp__button--close\" title=\"关闭 (Esc)\"></button> <button class=\"pswp__button pswp__button--download\" title=\"下载图片\"></button> <button class=\"pswp__button pswp__button--fs\" title=\"全屏\"></button> <button class=\"pswp__button pswp__button--zoom\" title=\"放大/缩小\"></button><div class=\"pswp__preloader\"><div class=\"pswp__preloader__icn\"><div class=\"pswp__preloader__cut\"><div class=\"pswp__preloader__donut\"></div></div></div></div></div><div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\"><div class=\"pswp__share-tooltip\"></div></div><button class=\"pswp__button pswp__button--arrow--left\" title=\"上一张\"></button> <button class=\"pswp__button pswp__button--arrow--right\" title=\"下一张\"></button><div class=\"pswp__caption\"><div class=\"pswp__caption__center\"></div></div></div></div></div>");
$templateCache.put("templates/cache/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\" ng-show=\"sidebarState>0\" ng-class=\"{\'icon-only\':sidebarState===1}\"><div id=\"sidebar-nav\"><ul class=\"nav in\" slimscroll=\"{height: \'{{sidebar.menuHeight}}px\',touchScrollStep:100, position:\'left\'}\" slimscroll-watch=\"sidebar.menuHeight\"><div class=\"p-1 sidebar-search hidden-xs\" ng-if=\"sidebarState===2\"><i class=\"fa fa-search fw text-muted\"></i> <input type=\"text\" class=\"form-control input-xs\" placeholder=\"请输入菜单检索\" ng-model=\"sidebar.search\" ng-model-options=\"{ debounce: 200 }\"> <button ng-if=\"sidebar.search\" class=\"close\" ng-click=\"sidebar.search=null\">&times;</button></div><li ui-sref-active=\"active\" ng-click=\"sidebar.check(0)\" class=\"home-link\"><a ui-sref=\"app.home\"><i class=\"fa fa-home fa-fw\"></i> 首页</a></li><li ng-repeat=\"item in sidebar.menuItems\" ng-if=\"sidebar.firstLvVisible(item)\" ng-class=\"{active: collapseVar===$index+1}\" ng-mouseover=\"sidebar.mouseOverMenuItem($event)\" ng-mouseleave=\"sidebar.mouseLeaveMenuItem($event)\"><a ng-click=\"sidebar.check($index+1)\"><i ng-class=\"[\'fa\', \'fa-\' + item.icon, \'fa-fw\']\"></i> {{::item.display_name}} <span class=\"fa arrow\"></span></a><div class=\"sub-item-wrapper\" msd-wheel=\"sidebar.mouseWheelSubItem($event)\"><div ng-if=\"sidebarState===1\" class=\"sub-item-title\">{{::item.display_name}}</div><ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.subItemCollapse($index+1)\"><li ng-repeat=\"subItem in item.children\" ui-sref-active=\"active\" ng-click=\"sidebar.clickSubItem($event)\" ng-if=\"sidebar.secondLvVisible(subItem)\"><a ui-sref=\"{{::subItem.state.name}}\">{{::subItem.display_name}}</a></li></ul></div></li></ul></div></div>");}]);